var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** An enumeration. */
export var AddendumStatus;
(function (AddendumStatus) {
    /** Draft */
    AddendumStatus["DRAFT"] = "DRAFT";
    /** Signed */
    AddendumStatus["SIGNED"] = "SIGNED";
    /** Cancel */
    AddendumStatus["CANCEL"] = "CANCEL";
})(AddendumStatus || (AddendumStatus = {}));
/** An enumeration. */
export var AppointmentEventType;
(function (AppointmentEventType) {
    /** Lock */
    AppointmentEventType["LOCK"] = "LOCK";
    /** Study */
    AppointmentEventType["STUDY"] = "STUDY";
})(AppointmentEventType || (AppointmentEventType = {}));
/** An enumeration. */
export var ContactContactType;
(function (ContactContactType) {
    /** Phone */
    ContactContactType["PHONE"] = "PHONE";
    /** Email */
    ContactContactType["EMAIL"] = "EMAIL";
})(ContactContactType || (ContactContactType = {}));
/** An enumeration. */
export var DicomPrintQuality;
(function (DicomPrintQuality) {
    /** High */
    DicomPrintQuality["HIGH"] = "HIGH";
    /** Medium */
    DicomPrintQuality["MEDIUM"] = "MEDIUM";
    /** Low */
    DicomPrintQuality["LOW"] = "LOW";
})(DicomPrintQuality || (DicomPrintQuality = {}));
/** An enumeration. */
export var DicomPrintShowTextInfo;
(function (DicomPrintShowTextInfo) {
    /** No Text */
    DicomPrintShowTextInfo["NO_TEXT"] = "NO_TEXT";
    /** Left */
    DicomPrintShowTextInfo["LEFT"] = "LEFT";
    /** Right */
    DicomPrintShowTextInfo["RIGHT"] = "RIGHT";
})(DicomPrintShowTextInfo || (DicomPrintShowTextInfo = {}));
/** An enumeration. */
export var DicomPrintStatus;
(function (DicomPrintStatus) {
    /** Pending */
    DicomPrintStatus["PENDING"] = "PENDING";
    /** Completed */
    DicomPrintStatus["COMPLETED"] = "COMPLETED";
    /** Failed */
    DicomPrintStatus["FAILED"] = "FAILED";
})(DicomPrintStatus || (DicomPrintStatus = {}));
/** An enumeration. */
export var DicomPrintStatusPrint;
(function (DicomPrintStatusPrint) {
    /** In Progress */
    DicomPrintStatusPrint["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DicomPrintStatusPrint["COMPLETED"] = "COMPLETED";
    /** Failed */
    DicomPrintStatusPrint["FAILED"] = "FAILED";
    /** TAKEN */
    DicomPrintStatusPrint["TAKEN"] = "TAKEN";
    /** TIMEOUT */
    DicomPrintStatusPrint["TIMEOUT"] = "TIMEOUT";
})(DicomPrintStatusPrint || (DicomPrintStatusPrint = {}));
/** An enumeration. */
export var DiscountDiscountType;
(function (DiscountDiscountType) {
    /** Discount */
    DiscountDiscountType["DISCOUNT"] = "DISCOUNT";
    /** Charge */
    DiscountDiscountType["CHARGE"] = "CHARGE";
    /** Package */
    DiscountDiscountType["PACKAGE"] = "PACKAGE";
})(DiscountDiscountType || (DiscountDiscountType = {}));
/** An enumeration. */
export var DiscountDiscountValueType;
(function (DiscountDiscountValueType) {
    /** Percentage */
    DiscountDiscountValueType["PERCENTAGE"] = "PERCENTAGE";
    /** Money */
    DiscountDiscountValueType["MONEY"] = "MONEY";
})(DiscountDiscountValueType || (DiscountDiscountValueType = {}));
/** An enumeration. */
export var DownloadDownloadType;
(function (DownloadDownloadType) {
    /** Study ZIP */
    DownloadDownloadType["ZIP_STUDY"] = "ZIP_STUDY";
    /** CSV Study List */
    DownloadDownloadType["CSV_STUDY_LIST"] = "CSV_STUDY_LIST";
    /** CSV Worklist */
    DownloadDownloadType["CSV_WORKLIST"] = "CSV_WORKLIST";
    /** CSV Management Order List */
    DownloadDownloadType["CSV_MANAGEMENT_ORDER_LIST"] = "CSV_MANAGEMENT_ORDER_LIST";
})(DownloadDownloadType || (DownloadDownloadType = {}));
/** An enumeration. */
export var DownloadIsoMultiStatus;
(function (DownloadIsoMultiStatus) {
    /** New */
    DownloadIsoMultiStatus["NEW"] = "NEW";
    /** In progress */
    DownloadIsoMultiStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DownloadIsoMultiStatus["COMPLETED"] = "COMPLETED";
    /** Failed */
    DownloadIsoMultiStatus["FAILED"] = "FAILED";
    /** Has updates */
    DownloadIsoMultiStatus["HAS_UPDATES"] = "HAS_UPDATES";
    /** Size exceeded */
    DownloadIsoMultiStatus["SIZE_EXCEEDED"] = "SIZE_EXCEEDED";
})(DownloadIsoMultiStatus || (DownloadIsoMultiStatus = {}));
/** An enumeration. */
export var DownloadIsoMultiStatusBurn;
(function (DownloadIsoMultiStatusBurn) {
    /** Pending */
    DownloadIsoMultiStatusBurn["PENDING"] = "PENDING";
    /** In progress */
    DownloadIsoMultiStatusBurn["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DownloadIsoMultiStatusBurn["COMPLETED"] = "COMPLETED";
    /** Failed */
    DownloadIsoMultiStatusBurn["FAILED"] = "FAILED";
})(DownloadIsoMultiStatusBurn || (DownloadIsoMultiStatusBurn = {}));
/** An enumeration. */
export var DownloadIsoViewIsoType;
(function (DownloadIsoViewIsoType) {
    /** SINGLE */
    DownloadIsoViewIsoType["SINGLE"] = "SINGLE";
    /** MULTI */
    DownloadIsoViewIsoType["MULTI"] = "MULTI";
})(DownloadIsoViewIsoType || (DownloadIsoViewIsoType = {}));
/** An enumeration. */
export var DownloadIsoViewStatus;
(function (DownloadIsoViewStatus) {
    /** New */
    DownloadIsoViewStatus["NEW"] = "NEW";
    /** In progress */
    DownloadIsoViewStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DownloadIsoViewStatus["COMPLETED"] = "COMPLETED";
    /** Failed */
    DownloadIsoViewStatus["FAILED"] = "FAILED";
    /** Has updates */
    DownloadIsoViewStatus["HAS_UPDATES"] = "HAS_UPDATES";
    /** Size exceeded */
    DownloadIsoViewStatus["SIZE_EXCEEDED"] = "SIZE_EXCEEDED";
})(DownloadIsoViewStatus || (DownloadIsoViewStatus = {}));
/** An enumeration. */
export var DownloadIsoViewStatusBurn;
(function (DownloadIsoViewStatusBurn) {
    /** Pending */
    DownloadIsoViewStatusBurn["PENDING"] = "PENDING";
    /** In progress */
    DownloadIsoViewStatusBurn["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DownloadIsoViewStatusBurn["COMPLETED"] = "COMPLETED";
    /** Failed */
    DownloadIsoViewStatusBurn["FAILED"] = "FAILED";
})(DownloadIsoViewStatusBurn || (DownloadIsoViewStatusBurn = {}));
/** An enumeration. */
export var DownloadStatus;
(function (DownloadStatus) {
    /** In progress */
    DownloadStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    DownloadStatus["COMPLETED"] = "COMPLETED";
    /** Failed */
    DownloadStatus["FAILED"] = "FAILED";
})(DownloadStatus || (DownloadStatus = {}));
/** An enumeration. */
export var FacilityCurrency;
(function (FacilityCurrency) {
    /** Mexican Pesos */
    FacilityCurrency["MXN"] = "MXN";
    /** US Dollars */
    FacilityCurrency["USD"] = "USD";
    /** Brazilian Reals */
    FacilityCurrency["BRL"] = "BRL";
    /** Argentine Pesos */
    FacilityCurrency["ARS"] = "ARS";
    /** Bolivianos */
    FacilityCurrency["BOB"] = "BOB";
    /** Belize Dollars */
    FacilityCurrency["BZD"] = "BZD";
    /** Chilean Pesos */
    FacilityCurrency["CLP"] = "CLP";
    /** Colombian Pesos */
    FacilityCurrency["COP"] = "COP";
    /** Costa Rican Colons */
    FacilityCurrency["CRC"] = "CRC";
    /** Dominican Pesos */
    FacilityCurrency["DOP"] = "DOP";
    /** Guatemalan Quetzales */
    FacilityCurrency["GTQ"] = "GTQ";
    /** Honduran Lempiras */
    FacilityCurrency["HNL"] = "HNL";
    /** Jamaican Dollars */
    FacilityCurrency["JMD"] = "JMD";
    /** Peruvian Soles */
    FacilityCurrency["PEN"] = "PEN";
    /** Paraguayan Guaranies */
    FacilityCurrency["PYG"] = "PYG";
    /** Salvadoran Colons */
    FacilityCurrency["SVC"] = "SVC";
})(FacilityCurrency || (FacilityCurrency = {}));
/** An enumeration. */
export var FacilityLocale;
(function (FacilityLocale) {
    /** Spanish (Mexico) */
    FacilityLocale["ES_MX"] = "ES_MX";
    /** English (United States) */
    FacilityLocale["EN_US"] = "EN_US";
    /** Portuguese (Brazil) */
    FacilityLocale["PT_BR"] = "PT_BR";
    /** English (Belize) */
    FacilityLocale["EN_BZ"] = "EN_BZ";
    /** English (Jamaica) */
    FacilityLocale["EN_JM"] = "EN_JM";
    /** Spanish (Argentina) */
    FacilityLocale["ES_AR"] = "ES_AR";
    /** Spanish (Bolivia) */
    FacilityLocale["ES_BO"] = "ES_BO";
    /** Spanish (Chile) */
    FacilityLocale["ES_CL"] = "ES_CL";
    /** Spanish (Colombia) */
    FacilityLocale["ES_CO"] = "ES_CO";
    /** Spanish (Costa Rica) */
    FacilityLocale["ES_CR"] = "ES_CR";
    /** Spanish (Dominican Republic) */
    FacilityLocale["ES_DO"] = "ES_DO";
    /** Spanish (Ecuador) */
    FacilityLocale["ES_EC"] = "ES_EC";
    /** Spanish (El Salvador) */
    FacilityLocale["ES_SV"] = "ES_SV";
    /** Spanish (Guatemala) */
    FacilityLocale["ES_GT"] = "ES_GT";
    /** Spanish (Honduras) */
    FacilityLocale["ES_HN"] = "ES_HN";
    /** Spanish (Paraguay) */
    FacilityLocale["ES_PY"] = "ES_PY";
    /** Spanish (Peru) */
    FacilityLocale["ES_PE"] = "ES_PE";
})(FacilityLocale || (FacilityLocale = {}));
/** Gender type availables. */
export var GenderType;
(function (GenderType) {
    GenderType["FEMALE"] = "FEMALE";
    GenderType["MALE"] = "MALE";
    GenderType["OTHER"] = "OTHER";
})(GenderType || (GenderType = {}));
/** An enumeration. */
export var InstanceDicomSopStatus;
(function (InstanceDicomSopStatus) {
    /** Not Specified */
    InstanceDicomSopStatus["NS"] = "NS";
    /** Original */
    InstanceDicomSopStatus["OR"] = "OR";
    /** Authorized Original */
    InstanceDicomSopStatus["AO"] = "AO";
    /** Authorized Copy */
    InstanceDicomSopStatus["AC"] = "AC";
})(InstanceDicomSopStatus || (InstanceDicomSopStatus = {}));
/** An enumeration. */
export var InvoiceLineTaxTaxType;
(function (InvoiceLineTaxTaxType) {
    /** Percentage */
    InvoiceLineTaxTaxType["PERCENTAGE"] = "PERCENTAGE";
    /** Fixed */
    InvoiceLineTaxTaxType["FIXED"] = "FIXED";
    /** Exempt */
    InvoiceLineTaxTaxType["EXEMPT"] = "EXEMPT";
})(InvoiceLineTaxTaxType || (InvoiceLineTaxTaxType = {}));
/** An enumeration. */
export var InvoicePaymentMethod;
(function (InvoicePaymentMethod) {
    /** PUE */
    InvoicePaymentMethod["PUE"] = "PUE";
    /** PPD */
    InvoicePaymentMethod["PPD"] = "PPD";
})(InvoicePaymentMethod || (InvoicePaymentMethod = {}));
/** An enumeration. */
export var InvoiceStatus;
(function (InvoiceStatus) {
    /** Draft */
    InvoiceStatus["DRAFT"] = "DRAFT";
    /** Signed */
    InvoiceStatus["SIGNED"] = "SIGNED";
    /** Sent */
    InvoiceStatus["SENT"] = "SENT";
    /** Cancelled pending */
    InvoiceStatus["CANCELLED_PENDING"] = "CANCELLED_PENDING";
    /** Cancelled */
    InvoiceStatus["CANCELLED"] = "CANCELLED";
    /** Error */
    InvoiceStatus["ERROR"] = "ERROR";
})(InvoiceStatus || (InvoiceStatus = {}));
/** An enumeration. */
export var NotificationListModel;
(function (NotificationListModel) {
    /** STUDY */
    NotificationListModel["STUDY"] = "STUDY";
})(NotificationListModel || (NotificationListModel = {}));
/** An enumeration. */
export var NotificationListNotificationType;
(function (NotificationListNotificationType) {
    /** PRACTITIONER_ASSIGNED */
    NotificationListNotificationType["PRACTITIONER_ASSIGNED"] = "PRACTITIONER_ASSIGNED";
    /** REFERRING_PRACTITIONER */
    NotificationListNotificationType["REFERRING_PRACTITIONER"] = "REFERRING_PRACTITIONER";
    /** REVIEWER_PRACTITIONER */
    NotificationListNotificationType["REVIEWER_PRACTITIONER"] = "REVIEWER_PRACTITIONER";
})(NotificationListNotificationType || (NotificationListNotificationType = {}));
/** An enumeration. */
export var NotificationListPriority;
(function (NotificationListPriority) {
    /** NORMAL */
    NotificationListPriority["NORMAL"] = "NORMAL";
    /** HIGH */
    NotificationListPriority["HIGH"] = "HIGH";
})(NotificationListPriority || (NotificationListPriority = {}));
/** An enumeration. */
export var OrderPriority;
(function (OrderPriority) {
    /** Normal */
    OrderPriority["NORMAL"] = "NORMAL";
    /** Highest */
    OrderPriority["HIGHEST"] = "HIGHEST";
    /** Urgent */
    OrderPriority["URGENT"] = "URGENT";
})(OrderPriority || (OrderPriority = {}));
/** An enumeration. */
export var OrderStatus;
(function (OrderStatus) {
    /** New */
    OrderStatus["NEW"] = "NEW";
    /** Patient arrived */
    OrderStatus["PATIENT_ARRIVED"] = "PATIENT_ARRIVED";
    /** In process */
    OrderStatus["IN_PROCESS"] = "IN_PROCESS";
    /** Completed */
    OrderStatus["COMPLETED"] = "COMPLETED";
    /** Cancelled */
    OrderStatus["CANCELLED"] = "CANCELLED";
})(OrderStatus || (OrderStatus = {}));
/** Status availables for order input. */
export var OrderStatusType;
(function (OrderStatusType) {
    OrderStatusType["NEW"] = "NEW";
    OrderStatusType["IN_PROCESS"] = "IN_PROCESS";
    OrderStatusType["PATIENT_ARRIVED"] = "PATIENT_ARRIVED";
    OrderStatusType["COMPLETED"] = "COMPLETED";
})(OrderStatusType || (OrderStatusType = {}));
/** An enumeration. */
export var OrderStudyFileRecordType;
(function (OrderStudyFileRecordType) {
    /** Regular */
    OrderStudyFileRecordType["REGULAR"] = "REGULAR";
    /** Image Bookmark */
    OrderStudyFileRecordType["IMAGE_BOOKMARK"] = "IMAGE_BOOKMARK";
})(OrderStudyFileRecordType || (OrderStudyFileRecordType = {}));
/** An enumeration. */
export var OrganizationSpecificFieldFieldType;
(function (OrganizationSpecificFieldFieldType) {
    /** String */
    OrganizationSpecificFieldFieldType["STRING"] = "STRING";
    /** Int */
    OrganizationSpecificFieldFieldType["INTEGER"] = "INTEGER";
    /** Date */
    OrganizationSpecificFieldFieldType["DATE"] = "DATE";
})(OrganizationSpecificFieldFieldType || (OrganizationSpecificFieldFieldType = {}));
/** An enumeration. */
export var OrganizationSpecificFieldOptionFieldType;
(function (OrganizationSpecificFieldOptionFieldType) {
    /** String */
    OrganizationSpecificFieldOptionFieldType["STRING"] = "STRING";
    /** Int */
    OrganizationSpecificFieldOptionFieldType["INTEGER"] = "INTEGER";
    /** Date */
    OrganizationSpecificFieldOptionFieldType["DATE"] = "DATE";
})(OrganizationSpecificFieldOptionFieldType || (OrganizationSpecificFieldOptionFieldType = {}));
/** An enumeration. */
export var OrganizationSpecificFieldRelatedModelType;
(function (OrganizationSpecificFieldRelatedModelType) {
    /** Patient */
    OrganizationSpecificFieldRelatedModelType["PATIENT"] = "PATIENT";
    /** Study */
    OrganizationSpecificFieldRelatedModelType["STUDY"] = "STUDY";
    /** Order */
    OrganizationSpecificFieldRelatedModelType["ORDER"] = "ORDER";
})(OrganizationSpecificFieldRelatedModelType || (OrganizationSpecificFieldRelatedModelType = {}));
/** An enumeration. */
export var PatientDataDocumentType;
(function (PatientDataDocumentType) {
    /** DNI */
    PatientDataDocumentType["DNI"] = "DNI";
    /** Id card */
    PatientDataDocumentType["ID_CARD"] = "ID_CARD";
    /** Passport */
    PatientDataDocumentType["PASSPORT"] = "PASSPORT";
    /** Driving license */
    PatientDataDocumentType["DRIVING_LICENSE"] = "DRIVING_LICENSE";
    /** Other */
    PatientDataDocumentType["OTHER"] = "OTHER";
})(PatientDataDocumentType || (PatientDataDocumentType = {}));
/** An enumeration. */
export var PatientGender;
(function (PatientGender) {
    /** Masculino */
    PatientGender["M"] = "M";
    /** Femenino */
    PatientGender["F"] = "F";
    /** Otro */
    PatientGender["O"] = "O";
})(PatientGender || (PatientGender = {}));
/** An enumeration. */
export var PaymentOrderStatus;
(function (PaymentOrderStatus) {
    /** Pending */
    PaymentOrderStatus["PENDING"] = "PENDING";
    /** Partial */
    PaymentOrderStatus["PARTIAL"] = "PARTIAL";
    /** Paid */
    PaymentOrderStatus["PAID"] = "PAID";
    /** Invoiced */
    PaymentOrderStatus["INVOICED"] = "INVOICED";
})(PaymentOrderStatus || (PaymentOrderStatus = {}));
/** An enumeration. */
export var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["API_ACTIVATE_REPORT"] = "API_ACTIVATE_REPORT";
    PermissionsEnum["API_ADD_ADDENDUM"] = "API_ADD_ADDENDUM";
    PermissionsEnum["API_ADD_ADDENDUMIMAGE"] = "API_ADD_ADDENDUMIMAGE";
    PermissionsEnum["API_ADD_ASSET"] = "API_ADD_ASSET";
    PermissionsEnum["API_ADD_ASSIGNDEMOSTUDYPROXY"] = "API_ADD_ASSIGNDEMOSTUDYPROXY";
    PermissionsEnum["API_ADD_AUTHREALMPROVIDER"] = "API_ADD_AUTHREALMPROVIDER";
    PermissionsEnum["API_ADD_AUTHREALMROLE"] = "API_ADD_AUTHREALMROLE";
    PermissionsEnum["API_ADD_AUTOSENDREPORTBIRADSRULE"] = "API_ADD_AUTOSENDREPORTBIRADSRULE";
    PermissionsEnum["API_ADD_AUTOSENDREPORTRULE"] = "API_ADD_AUTOSENDREPORTRULE";
    PermissionsEnum["API_ADD_BILLING"] = "API_ADD_BILLING";
    PermissionsEnum["API_ADD_BILLINGSETUP"] = "API_ADD_BILLINGSETUP";
    PermissionsEnum["API_ADD_BILLINGSETUPLIMIT"] = "API_ADD_BILLINGSETUPLIMIT";
    PermissionsEnum["API_ADD_BILLINGTYPELIMIT"] = "API_ADD_BILLINGTYPELIMIT";
    PermissionsEnum["API_ADD_BIRADSREPORTPROXY"] = "API_ADD_BIRADSREPORTPROXY";
    PermissionsEnum["API_ADD_BLOCKEDSESSION"] = "API_ADD_BLOCKEDSESSION";
    PermissionsEnum["API_ADD_BODYPART"] = "API_ADD_BODYPART";
    PermissionsEnum["API_ADD_BURNER"] = "API_ADD_BURNER";
    PermissionsEnum["API_ADD_BURN_CD"] = "API_ADD_BURN_CD";
    PermissionsEnum["API_ADD_CHANGEUSERORGANIZATION"] = "API_ADD_CHANGEUSERORGANIZATION";
    PermissionsEnum["API_ADD_CONFIGURATION"] = "API_ADD_CONFIGURATION";
    PermissionsEnum["API_ADD_COUNTRY"] = "API_ADD_COUNTRY";
    PermissionsEnum["API_ADD_CREATEMULTIORGUSER"] = "API_ADD_CREATEMULTIORGUSER";
    PermissionsEnum["API_ADD_CREATEREFERRINGPRACTITIONER"] = "API_ADD_CREATEREFERRINGPRACTITIONER";
    PermissionsEnum["API_ADD_CRITICALVALUE"] = "API_ADD_CRITICALVALUE";
    PermissionsEnum["API_ADD_CRMORGANIZATION"] = "API_ADD_CRMORGANIZATION";
    PermissionsEnum["API_ADD_DEMOSTUDY"] = "API_ADD_DEMOSTUDY";
    PermissionsEnum["API_ADD_DEMOSTUDYPROXY"] = "API_ADD_DEMOSTUDYPROXY";
    PermissionsEnum["API_ADD_DICOMFILE"] = "API_ADD_DICOMFILE";
    PermissionsEnum["API_ADD_DICOMPRINT"] = "API_ADD_DICOMPRINT";
    PermissionsEnum["API_ADD_DICOMPRINTER"] = "API_ADD_DICOMPRINTER";
    PermissionsEnum["API_ADD_DICOMURL"] = "API_ADD_DICOMURL";
    PermissionsEnum["API_ADD_DICTATION"] = "API_ADD_DICTATION";
    PermissionsEnum["API_ADD_DICTATIONAUDIO"] = "API_ADD_DICTATIONAUDIO";
    PermissionsEnum["API_ADD_DOWNLOAD"] = "API_ADD_DOWNLOAD";
    PermissionsEnum["API_ADD_DOWNLOADISO"] = "API_ADD_DOWNLOADISO";
    PermissionsEnum["API_ADD_DOWNLOADISOMULTI"] = "API_ADD_DOWNLOADISOMULTI";
    PermissionsEnum["API_ADD_DOWNLOADISOVIEW"] = "API_ADD_DOWNLOADISOVIEW";
    PermissionsEnum["API_ADD_EXTERNALORDER"] = "API_ADD_EXTERNALORDER";
    PermissionsEnum["API_ADD_FACILITY"] = "API_ADD_FACILITY";
    PermissionsEnum["API_ADD_FACILITYPDFTEMPLATE"] = "API_ADD_FACILITYPDFTEMPLATE";
    PermissionsEnum["API_ADD_FACILITYPRACTITIONER"] = "API_ADD_FACILITYPRACTITIONER";
    PermissionsEnum["API_ADD_FLAG"] = "API_ADD_FLAG";
    PermissionsEnum["API_ADD_GLOBALASSET"] = "API_ADD_GLOBALASSET";
    PermissionsEnum["API_ADD_HEALTHOFFICER"] = "API_ADD_HEALTHOFFICER";
    PermissionsEnum["API_ADD_INSTANCE"] = "API_ADD_INSTANCE";
    PermissionsEnum["API_ADD_INSTANCEDICOMTAGS"] = "API_ADD_INSTANCEDICOMTAGS";
    PermissionsEnum["API_ADD_INSTANCEFILE"] = "API_ADD_INSTANCEFILE";
    PermissionsEnum["API_ADD_INSTANCEPARENT"] = "API_ADD_INSTANCEPARENT";
    PermissionsEnum["API_ADD_INSTANCEVIEW"] = "API_ADD_INSTANCEVIEW";
    PermissionsEnum["API_ADD_JOINPATIENTS"] = "API_ADD_JOINPATIENTS";
    PermissionsEnum["API_ADD_JOINSTUDIES"] = "API_ADD_JOINSTUDIES";
    PermissionsEnum["API_ADD_LICENSE"] = "API_ADD_LICENSE";
    PermissionsEnum["API_ADD_MAILPROXY"] = "API_ADD_MAILPROXY";
    PermissionsEnum["API_ADD_MEASUREMENT"] = "API_ADD_MEASUREMENT";
    PermissionsEnum["API_ADD_MESSAGEPROXY"] = "API_ADD_MESSAGEPROXY";
    PermissionsEnum["API_ADD_MIGRATION"] = "API_ADD_MIGRATION";
    PermissionsEnum["API_ADD_MOBILEINSTANCEFILE"] = "API_ADD_MOBILEINSTANCEFILE";
    PermissionsEnum["API_ADD_MODALITY"] = "API_ADD_MODALITY";
    PermissionsEnum["API_ADD_MULTIPROCESSING"] = "API_ADD_MULTIPROCESSING";
    PermissionsEnum["API_ADD_NURSINGUNIT"] = "API_ADD_NURSINGUNIT";
    PermissionsEnum["API_ADD_OPERATION"] = "API_ADD_OPERATION";
    PermissionsEnum["API_ADD_OPERATIONGROUP"] = "API_ADD_OPERATIONGROUP";
    PermissionsEnum["API_ADD_ORGANIZATION"] = "API_ADD_ORGANIZATION";
    PermissionsEnum["API_ADD_ORGANIZATIONBLACKLIST"] = "API_ADD_ORGANIZATIONBLACKLIST";
    PermissionsEnum["API_ADD_ORGANIZATIONCONFIGURATION"] = "API_ADD_ORGANIZATIONCONFIGURATION";
    PermissionsEnum["API_ADD_ORGANIZATIONCRITICALVALUE"] = "API_ADD_ORGANIZATIONCRITICALVALUE";
    PermissionsEnum["API_ADD_ORGANIZATIONFLAG"] = "API_ADD_ORGANIZATIONFLAG";
    PermissionsEnum["API_ADD_ORGANIZATIONINVITATION"] = "API_ADD_ORGANIZATIONINVITATION";
    PermissionsEnum["API_ADD_ORGANIZATIONOWNER"] = "API_ADD_ORGANIZATIONOWNER";
    PermissionsEnum["API_ADD_ORGANIZATIONSPECIFICFIELD"] = "API_ADD_ORGANIZATIONSPECIFICFIELD";
    PermissionsEnum["API_ADD_ORGANIZATIONSPECIFICFIELDOPTION"] = "API_ADD_ORGANIZATIONSPECIFICFIELDOPTION";
    PermissionsEnum["API_ADD_ORGANIZATIONUSER"] = "API_ADD_ORGANIZATIONUSER";
    PermissionsEnum["API_ADD_ORGANIZATIONUSERGROUP"] = "API_ADD_ORGANIZATIONUSERGROUP";
    PermissionsEnum["API_ADD_PATIENT"] = "API_ADD_PATIENT";
    PermissionsEnum["API_ADD_PDFTEMPLATE"] = "API_ADD_PDFTEMPLATE";
    PermissionsEnum["API_ADD_PRACTITIONER"] = "API_ADD_PRACTITIONER";
    PermissionsEnum["API_ADD_PRACTITIONERASSIGNATION"] = "API_ADD_PRACTITIONERASSIGNATION";
    PermissionsEnum["API_ADD_PRINT"] = "API_ADD_PRINT";
    PermissionsEnum["API_ADD_PRODUCT"] = "API_ADD_PRODUCT";
    PermissionsEnum["API_ADD_PRODUCTORGANIZATION"] = "API_ADD_PRODUCTORGANIZATION";
    PermissionsEnum["API_ADD_PRODUCTORGANIZATIONBILLING"] = "API_ADD_PRODUCTORGANIZATIONBILLING";
    PermissionsEnum["API_ADD_PRODUCTORGANIZATIONFACILITYBILLING"] = "API_ADD_PRODUCTORGANIZATIONFACILITYBILLING";
    PermissionsEnum["API_ADD_PRODUCTPERMISSIONGROUP"] = "API_ADD_PRODUCTPERMISSIONGROUP";
    PermissionsEnum["API_ADD_REPORT"] = "API_ADD_REPORT";
    PermissionsEnum["API_ADD_REPORTCONCLUSION"] = "API_ADD_REPORTCONCLUSION";
    PermissionsEnum["API_ADD_REPORTFIELD"] = "API_ADD_REPORTFIELD";
    PermissionsEnum["API_ADD_REPORTIMAGE"] = "API_ADD_REPORTIMAGE";
    PermissionsEnum["API_ADD_REPORTMESSAGE"] = "API_ADD_REPORTMESSAGE";
    PermissionsEnum["API_ADD_REPORTSIGNISSUES"] = "API_ADD_REPORTSIGNISSUES";
    PermissionsEnum["API_ADD_REPORT_EXTERNAL_PDF"] = "API_ADD_REPORT_EXTERNAL_PDF";
    PermissionsEnum["API_ADD_REQUEST"] = "API_ADD_REQUEST";
    PermissionsEnum["API_ADD_ROUTER"] = "API_ADD_ROUTER";
    PermissionsEnum["API_ADD_SERIES"] = "API_ADD_SERIES";
    PermissionsEnum["API_ADD_SERIESECG"] = "API_ADD_SERIESECG";
    PermissionsEnum["API_ADD_SERIESECGSIGNAL"] = "API_ADD_SERIESECGSIGNAL";
    PermissionsEnum["API_ADD_SERIESVIEWER"] = "API_ADD_SERIESVIEWER";
    PermissionsEnum["API_ADD_SPECIALTY"] = "API_ADD_SPECIALTY";
    PermissionsEnum["API_ADD_SPELLCHECKLANGUAGE"] = "API_ADD_SPELLCHECKLANGUAGE";
    PermissionsEnum["API_ADD_SPLITSTUDIES"] = "API_ADD_SPLITSTUDIES";
    PermissionsEnum["API_ADD_STUDY"] = "API_ADD_STUDY";
    PermissionsEnum["API_ADD_STUDYCRITICALVALUE"] = "API_ADD_STUDYCRITICALVALUE";
    PermissionsEnum["API_ADD_STUDYDATA"] = "API_ADD_STUDYDATA";
    PermissionsEnum["API_ADD_STUDYEVENT"] = "API_ADD_STUDYEVENT";
    PermissionsEnum["API_ADD_STUDYEVENTVIEW"] = "API_ADD_STUDYEVENTVIEW";
    PermissionsEnum["API_ADD_STUDYFILE"] = "API_ADD_STUDYFILE";
    PermissionsEnum["API_ADD_STUDYLIST"] = "API_ADD_STUDYLIST";
    PermissionsEnum["API_ADD_STUDYNOTE"] = "API_ADD_STUDYNOTE";
    PermissionsEnum["API_ADD_STUDYOPERATIONSCHANGELOG"] = "API_ADD_STUDYOPERATIONSCHANGELOG";
    PermissionsEnum["API_ADD_STUDYPDFFILE"] = "API_ADD_STUDYPDFFILE";
    PermissionsEnum["API_ADD_STUDYREVIEWRULE"] = "API_ADD_STUDYREVIEWRULE";
    PermissionsEnum["API_ADD_STUDYSTATISTICS"] = "API_ADD_STUDYSTATISTICS";
    PermissionsEnum["API_ADD_STUDYTYPE"] = "API_ADD_STUDYTYPE";
    PermissionsEnum["API_ADD_STUDYTZ"] = "API_ADD_STUDYTZ";
    PermissionsEnum["API_ADD_STUDYWRONGMODALITIES"] = "API_ADD_STUDYWRONGMODALITIES";
    PermissionsEnum["API_ADD_STUDYWRONGMODALITIESFULLSEARCH"] = "API_ADD_STUDYWRONGMODALITIESFULLSEARCH";
    PermissionsEnum["API_ADD_SUSPENDEDACCOUNT"] = "API_ADD_SUSPENDEDACCOUNT";
    PermissionsEnum["API_ADD_TEMPLATE"] = "API_ADD_TEMPLATE";
    PermissionsEnum["API_ADD_TEMPLATEFIELD"] = "API_ADD_TEMPLATEFIELD";
    PermissionsEnum["API_ADD_TRANSLATIONTERM"] = "API_ADD_TRANSLATIONTERM";
    PermissionsEnum["API_ADD_USER"] = "API_ADD_USER";
    PermissionsEnum["API_ADD_USERINTEGRATION"] = "API_ADD_USERINTEGRATION";
    PermissionsEnum["API_ADD_USERPREFERENCE"] = "API_ADD_USERPREFERENCE";
    PermissionsEnum["API_ADD_USERROWPERMISSION"] = "API_ADD_USERROWPERMISSION";
    PermissionsEnum["API_ADD_VISITANT"] = "API_ADD_VISITANT";
    PermissionsEnum["API_ADD_VISITANTACCESS"] = "API_ADD_VISITANTACCESS";
    PermissionsEnum["API_BUILD_PDF_REPORT"] = "API_BUILD_PDF_REPORT";
    PermissionsEnum["API_CANCEL_ADDENDUM"] = "API_CANCEL_ADDENDUM";
    PermissionsEnum["API_CANCEL_REQUIRE_REVIEW_REPORT"] = "API_CANCEL_REQUIRE_REVIEW_REPORT";
    PermissionsEnum["API_CANCEL_REVIEW_REPORT"] = "API_CANCEL_REVIEW_REPORT";
    PermissionsEnum["API_CHANGE_ADDENDUM"] = "API_CHANGE_ADDENDUM";
    PermissionsEnum["API_CHANGE_ADDENDUMIMAGE"] = "API_CHANGE_ADDENDUMIMAGE";
    PermissionsEnum["API_CHANGE_ASSET"] = "API_CHANGE_ASSET";
    PermissionsEnum["API_CHANGE_ASSIGNDEMOSTUDYPROXY"] = "API_CHANGE_ASSIGNDEMOSTUDYPROXY";
    PermissionsEnum["API_CHANGE_AUTHREALMPROVIDER"] = "API_CHANGE_AUTHREALMPROVIDER";
    PermissionsEnum["API_CHANGE_AUTHREALMROLE"] = "API_CHANGE_AUTHREALMROLE";
    PermissionsEnum["API_CHANGE_AUTOSENDREPORTBIRADSRULE"] = "API_CHANGE_AUTOSENDREPORTBIRADSRULE";
    PermissionsEnum["API_CHANGE_AUTOSENDREPORTRULE"] = "API_CHANGE_AUTOSENDREPORTRULE";
    PermissionsEnum["API_CHANGE_BILLING"] = "API_CHANGE_BILLING";
    PermissionsEnum["API_CHANGE_BILLINGSETUP"] = "API_CHANGE_BILLINGSETUP";
    PermissionsEnum["API_CHANGE_BILLINGSETUPLIMIT"] = "API_CHANGE_BILLINGSETUPLIMIT";
    PermissionsEnum["API_CHANGE_BILLINGTYPELIMIT"] = "API_CHANGE_BILLINGTYPELIMIT";
    PermissionsEnum["API_CHANGE_BIRADSREPORTPROXY"] = "API_CHANGE_BIRADSREPORTPROXY";
    PermissionsEnum["API_CHANGE_BLOCKEDSESSION"] = "API_CHANGE_BLOCKEDSESSION";
    PermissionsEnum["API_CHANGE_BODYPART"] = "API_CHANGE_BODYPART";
    PermissionsEnum["API_CHANGE_BURNER"] = "API_CHANGE_BURNER";
    PermissionsEnum["API_CHANGE_CHANGEUSERORGANIZATION"] = "API_CHANGE_CHANGEUSERORGANIZATION";
    PermissionsEnum["API_CHANGE_CONFIGURATION"] = "API_CHANGE_CONFIGURATION";
    PermissionsEnum["API_CHANGE_COUNTRY"] = "API_CHANGE_COUNTRY";
    PermissionsEnum["API_CHANGE_CREATEMULTIORGUSER"] = "API_CHANGE_CREATEMULTIORGUSER";
    PermissionsEnum["API_CHANGE_CREATEREFERRINGPRACTITIONER"] = "API_CHANGE_CREATEREFERRINGPRACTITIONER";
    PermissionsEnum["API_CHANGE_CRITICALVALUE"] = "API_CHANGE_CRITICALVALUE";
    PermissionsEnum["API_CHANGE_CRMORGANIZATION"] = "API_CHANGE_CRMORGANIZATION";
    PermissionsEnum["API_CHANGE_DEMOSTUDY"] = "API_CHANGE_DEMOSTUDY";
    PermissionsEnum["API_CHANGE_DEMOSTUDYPROXY"] = "API_CHANGE_DEMOSTUDYPROXY";
    PermissionsEnum["API_CHANGE_DICOMFILE"] = "API_CHANGE_DICOMFILE";
    PermissionsEnum["API_CHANGE_DICOMPRINT"] = "API_CHANGE_DICOMPRINT";
    PermissionsEnum["API_CHANGE_DICOMPRINTER"] = "API_CHANGE_DICOMPRINTER";
    PermissionsEnum["API_CHANGE_DICOMURL"] = "API_CHANGE_DICOMURL";
    PermissionsEnum["API_CHANGE_DICTATION"] = "API_CHANGE_DICTATION";
    PermissionsEnum["API_CHANGE_DICTATIONAUDIO"] = "API_CHANGE_DICTATIONAUDIO";
    PermissionsEnum["API_CHANGE_DOWNLOAD"] = "API_CHANGE_DOWNLOAD";
    PermissionsEnum["API_CHANGE_DOWNLOADISO"] = "API_CHANGE_DOWNLOADISO";
    PermissionsEnum["API_CHANGE_DOWNLOADISOMULTI"] = "API_CHANGE_DOWNLOADISOMULTI";
    PermissionsEnum["API_CHANGE_DOWNLOADISOVIEW"] = "API_CHANGE_DOWNLOADISOVIEW";
    PermissionsEnum["API_CHANGE_EXTERNALORDER"] = "API_CHANGE_EXTERNALORDER";
    PermissionsEnum["API_CHANGE_FACILITY"] = "API_CHANGE_FACILITY";
    PermissionsEnum["API_CHANGE_FACILITYPDFTEMPLATE"] = "API_CHANGE_FACILITYPDFTEMPLATE";
    PermissionsEnum["API_CHANGE_FACILITYPRACTITIONER"] = "API_CHANGE_FACILITYPRACTITIONER";
    PermissionsEnum["API_CHANGE_FLAG"] = "API_CHANGE_FLAG";
    PermissionsEnum["API_CHANGE_GLOBALASSET"] = "API_CHANGE_GLOBALASSET";
    PermissionsEnum["API_CHANGE_HEALTHOFFICER"] = "API_CHANGE_HEALTHOFFICER";
    PermissionsEnum["API_CHANGE_INSTANCE"] = "API_CHANGE_INSTANCE";
    PermissionsEnum["API_CHANGE_INSTANCEDICOMTAGS"] = "API_CHANGE_INSTANCEDICOMTAGS";
    PermissionsEnum["API_CHANGE_INSTANCEFILE"] = "API_CHANGE_INSTANCEFILE";
    PermissionsEnum["API_CHANGE_INSTANCEPARENT"] = "API_CHANGE_INSTANCEPARENT";
    PermissionsEnum["API_CHANGE_INSTANCEVIEW"] = "API_CHANGE_INSTANCEVIEW";
    PermissionsEnum["API_CHANGE_JOINPATIENTS"] = "API_CHANGE_JOINPATIENTS";
    PermissionsEnum["API_CHANGE_JOINSTUDIES"] = "API_CHANGE_JOINSTUDIES";
    PermissionsEnum["API_CHANGE_LICENSE"] = "API_CHANGE_LICENSE";
    PermissionsEnum["API_CHANGE_MAILPROXY"] = "API_CHANGE_MAILPROXY";
    PermissionsEnum["API_CHANGE_MEASUREMENT"] = "API_CHANGE_MEASUREMENT";
    PermissionsEnum["API_CHANGE_MESSAGEPROXY"] = "API_CHANGE_MESSAGEPROXY";
    PermissionsEnum["API_CHANGE_MIGRATION"] = "API_CHANGE_MIGRATION";
    PermissionsEnum["API_CHANGE_MOBILEINSTANCEFILE"] = "API_CHANGE_MOBILEINSTANCEFILE";
    PermissionsEnum["API_CHANGE_MODALITY"] = "API_CHANGE_MODALITY";
    PermissionsEnum["API_CHANGE_MULTIPROCESSING"] = "API_CHANGE_MULTIPROCESSING";
    PermissionsEnum["API_CHANGE_NURSINGUNIT"] = "API_CHANGE_NURSINGUNIT";
    PermissionsEnum["API_CHANGE_OPERATION"] = "API_CHANGE_OPERATION";
    PermissionsEnum["API_CHANGE_OPERATIONGROUP"] = "API_CHANGE_OPERATIONGROUP";
    PermissionsEnum["API_CHANGE_ORGANIZATION"] = "API_CHANGE_ORGANIZATION";
    PermissionsEnum["API_CHANGE_ORGANIZATIONBLACKLIST"] = "API_CHANGE_ORGANIZATIONBLACKLIST";
    PermissionsEnum["API_CHANGE_ORGANIZATIONCONFIGURATION"] = "API_CHANGE_ORGANIZATIONCONFIGURATION";
    PermissionsEnum["API_CHANGE_ORGANIZATIONCRITICALVALUE"] = "API_CHANGE_ORGANIZATIONCRITICALVALUE";
    PermissionsEnum["API_CHANGE_ORGANIZATIONFLAG"] = "API_CHANGE_ORGANIZATIONFLAG";
    PermissionsEnum["API_CHANGE_ORGANIZATIONINVITATION"] = "API_CHANGE_ORGANIZATIONINVITATION";
    PermissionsEnum["API_CHANGE_ORGANIZATIONOWNER"] = "API_CHANGE_ORGANIZATIONOWNER";
    PermissionsEnum["API_CHANGE_ORGANIZATIONSPECIFICFIELD"] = "API_CHANGE_ORGANIZATIONSPECIFICFIELD";
    PermissionsEnum["API_CHANGE_ORGANIZATIONSPECIFICFIELDOPTION"] = "API_CHANGE_ORGANIZATIONSPECIFICFIELDOPTION";
    PermissionsEnum["API_CHANGE_ORGANIZATIONUSER"] = "API_CHANGE_ORGANIZATIONUSER";
    PermissionsEnum["API_CHANGE_ORGANIZATIONUSERGROUP"] = "API_CHANGE_ORGANIZATIONUSERGROUP";
    PermissionsEnum["API_CHANGE_PATIENT"] = "API_CHANGE_PATIENT";
    PermissionsEnum["API_CHANGE_PDFTEMPLATE"] = "API_CHANGE_PDFTEMPLATE";
    PermissionsEnum["API_CHANGE_PRACTITIONER"] = "API_CHANGE_PRACTITIONER";
    PermissionsEnum["API_CHANGE_PRACTITIONERASSIGNATION"] = "API_CHANGE_PRACTITIONERASSIGNATION";
    PermissionsEnum["API_CHANGE_PRODUCT"] = "API_CHANGE_PRODUCT";
    PermissionsEnum["API_CHANGE_PRODUCTORGANIZATION"] = "API_CHANGE_PRODUCTORGANIZATION";
    PermissionsEnum["API_CHANGE_PRODUCTORGANIZATIONBILLING"] = "API_CHANGE_PRODUCTORGANIZATIONBILLING";
    PermissionsEnum["API_CHANGE_PRODUCTORGANIZATIONFACILITYBILLING"] = "API_CHANGE_PRODUCTORGANIZATIONFACILITYBILLING";
    PermissionsEnum["API_CHANGE_PRODUCTPERMISSIONGROUP"] = "API_CHANGE_PRODUCTPERMISSIONGROUP";
    PermissionsEnum["API_CHANGE_REPORT"] = "API_CHANGE_REPORT";
    PermissionsEnum["API_CHANGE_REPORTCONCLUSION"] = "API_CHANGE_REPORTCONCLUSION";
    PermissionsEnum["API_CHANGE_REPORTFIELD"] = "API_CHANGE_REPORTFIELD";
    PermissionsEnum["API_CHANGE_REPORTIMAGE"] = "API_CHANGE_REPORTIMAGE";
    PermissionsEnum["API_CHANGE_REPORTMESSAGE"] = "API_CHANGE_REPORTMESSAGE";
    PermissionsEnum["API_CHANGE_REPORTSIGNISSUES"] = "API_CHANGE_REPORTSIGNISSUES";
    PermissionsEnum["API_CHANGE_REQUEST"] = "API_CHANGE_REQUEST";
    PermissionsEnum["API_CHANGE_ROUTER"] = "API_CHANGE_ROUTER";
    PermissionsEnum["API_CHANGE_SERIES"] = "API_CHANGE_SERIES";
    PermissionsEnum["API_CHANGE_SERIESECG"] = "API_CHANGE_SERIESECG";
    PermissionsEnum["API_CHANGE_SERIESECGSIGNAL"] = "API_CHANGE_SERIESECGSIGNAL";
    PermissionsEnum["API_CHANGE_SERIESVIEWER"] = "API_CHANGE_SERIESVIEWER";
    PermissionsEnum["API_CHANGE_SPECIALTY"] = "API_CHANGE_SPECIALTY";
    PermissionsEnum["API_CHANGE_SPELLCHECKLANGUAGE"] = "API_CHANGE_SPELLCHECKLANGUAGE";
    PermissionsEnum["API_CHANGE_SPLITSTUDIES"] = "API_CHANGE_SPLITSTUDIES";
    PermissionsEnum["API_CHANGE_STUDY"] = "API_CHANGE_STUDY";
    PermissionsEnum["API_CHANGE_STUDYCRITICALVALUE"] = "API_CHANGE_STUDYCRITICALVALUE";
    PermissionsEnum["API_CHANGE_STUDYDATA"] = "API_CHANGE_STUDYDATA";
    PermissionsEnum["API_CHANGE_STUDYEVENT"] = "API_CHANGE_STUDYEVENT";
    PermissionsEnum["API_CHANGE_STUDYEVENTVIEW"] = "API_CHANGE_STUDYEVENTVIEW";
    PermissionsEnum["API_CHANGE_STUDYFILE"] = "API_CHANGE_STUDYFILE";
    PermissionsEnum["API_CHANGE_STUDYLIST"] = "API_CHANGE_STUDYLIST";
    PermissionsEnum["API_CHANGE_STUDYNOTE"] = "API_CHANGE_STUDYNOTE";
    PermissionsEnum["API_CHANGE_STUDYOPERATIONSCHANGELOG"] = "API_CHANGE_STUDYOPERATIONSCHANGELOG";
    PermissionsEnum["API_CHANGE_STUDYPDFFILE"] = "API_CHANGE_STUDYPDFFILE";
    PermissionsEnum["API_CHANGE_STUDYREVIEWRULE"] = "API_CHANGE_STUDYREVIEWRULE";
    PermissionsEnum["API_CHANGE_STUDYSTATISTICS"] = "API_CHANGE_STUDYSTATISTICS";
    PermissionsEnum["API_CHANGE_STUDYTYPE"] = "API_CHANGE_STUDYTYPE";
    PermissionsEnum["API_CHANGE_STUDYTZ"] = "API_CHANGE_STUDYTZ";
    PermissionsEnum["API_CHANGE_STUDYWRONGMODALITIES"] = "API_CHANGE_STUDYWRONGMODALITIES";
    PermissionsEnum["API_CHANGE_STUDYWRONGMODALITIESFULLSEARCH"] = "API_CHANGE_STUDYWRONGMODALITIESFULLSEARCH";
    PermissionsEnum["API_CHANGE_SUSPENDEDACCOUNT"] = "API_CHANGE_SUSPENDEDACCOUNT";
    PermissionsEnum["API_CHANGE_TEMPLATE"] = "API_CHANGE_TEMPLATE";
    PermissionsEnum["API_CHANGE_TEMPLATEFIELD"] = "API_CHANGE_TEMPLATEFIELD";
    PermissionsEnum["API_CHANGE_TRANSLATIONTERM"] = "API_CHANGE_TRANSLATIONTERM";
    PermissionsEnum["API_CHANGE_USER"] = "API_CHANGE_USER";
    PermissionsEnum["API_CHANGE_USERINTEGRATION"] = "API_CHANGE_USERINTEGRATION";
    PermissionsEnum["API_CHANGE_USERPREFERENCE"] = "API_CHANGE_USERPREFERENCE";
    PermissionsEnum["API_CHANGE_USERROWPERMISSION"] = "API_CHANGE_USERROWPERMISSION";
    PermissionsEnum["API_CHANGE_USER_ORGANIZATION"] = "API_CHANGE_USER_ORGANIZATION";
    PermissionsEnum["API_CHANGE_VISITANT"] = "API_CHANGE_VISITANT";
    PermissionsEnum["API_CHANGE_VISITANTACCESS"] = "API_CHANGE_VISITANTACCESS";
    PermissionsEnum["API_CLEAR_REPORT"] = "API_CLEAR_REPORT";
    PermissionsEnum["API_CLONE_TEMPLATE"] = "API_CLONE_TEMPLATE";
    PermissionsEnum["API_CREATE_MULTI_ORG_USER"] = "API_CREATE_MULTI_ORG_USER";
    PermissionsEnum["API_CREATE_REFERRING_PRACTITIONERS"] = "API_CREATE_REFERRING_PRACTITIONERS";
    PermissionsEnum["API_DELETE_ADDENDUM"] = "API_DELETE_ADDENDUM";
    PermissionsEnum["API_DELETE_ADDENDUMIMAGE"] = "API_DELETE_ADDENDUMIMAGE";
    PermissionsEnum["API_DELETE_ASSET"] = "API_DELETE_ASSET";
    PermissionsEnum["API_DELETE_ASSIGNDEMOSTUDYPROXY"] = "API_DELETE_ASSIGNDEMOSTUDYPROXY";
    PermissionsEnum["API_DELETE_AUTHREALMPROVIDER"] = "API_DELETE_AUTHREALMPROVIDER";
    PermissionsEnum["API_DELETE_AUTHREALMROLE"] = "API_DELETE_AUTHREALMROLE";
    PermissionsEnum["API_DELETE_AUTOSENDREPORTBIRADSRULE"] = "API_DELETE_AUTOSENDREPORTBIRADSRULE";
    PermissionsEnum["API_DELETE_AUTOSENDREPORTRULE"] = "API_DELETE_AUTOSENDREPORTRULE";
    PermissionsEnum["API_DELETE_BILLING"] = "API_DELETE_BILLING";
    PermissionsEnum["API_DELETE_BILLINGSETUP"] = "API_DELETE_BILLINGSETUP";
    PermissionsEnum["API_DELETE_BILLINGSETUPLIMIT"] = "API_DELETE_BILLINGSETUPLIMIT";
    PermissionsEnum["API_DELETE_BILLINGTYPELIMIT"] = "API_DELETE_BILLINGTYPELIMIT";
    PermissionsEnum["API_DELETE_BIRADSREPORTPROXY"] = "API_DELETE_BIRADSREPORTPROXY";
    PermissionsEnum["API_DELETE_BLOCKEDSESSION"] = "API_DELETE_BLOCKEDSESSION";
    PermissionsEnum["API_DELETE_BODYPART"] = "API_DELETE_BODYPART";
    PermissionsEnum["API_DELETE_BURNER"] = "API_DELETE_BURNER";
    PermissionsEnum["API_DELETE_CHANGEUSERORGANIZATION"] = "API_DELETE_CHANGEUSERORGANIZATION";
    PermissionsEnum["API_DELETE_CONFIGURATION"] = "API_DELETE_CONFIGURATION";
    PermissionsEnum["API_DELETE_COUNTRY"] = "API_DELETE_COUNTRY";
    PermissionsEnum["API_DELETE_CREATEMULTIORGUSER"] = "API_DELETE_CREATEMULTIORGUSER";
    PermissionsEnum["API_DELETE_CREATEREFERRINGPRACTITIONER"] = "API_DELETE_CREATEREFERRINGPRACTITIONER";
    PermissionsEnum["API_DELETE_CRITICALVALUE"] = "API_DELETE_CRITICALVALUE";
    PermissionsEnum["API_DELETE_CRMORGANIZATION"] = "API_DELETE_CRMORGANIZATION";
    PermissionsEnum["API_DELETE_DEMOSTUDY"] = "API_DELETE_DEMOSTUDY";
    PermissionsEnum["API_DELETE_DEMOSTUDYPROXY"] = "API_DELETE_DEMOSTUDYPROXY";
    PermissionsEnum["API_DELETE_DICOMFILE"] = "API_DELETE_DICOMFILE";
    PermissionsEnum["API_DELETE_DICOMPRINT"] = "API_DELETE_DICOMPRINT";
    PermissionsEnum["API_DELETE_DICOMPRINTER"] = "API_DELETE_DICOMPRINTER";
    PermissionsEnum["API_DELETE_DICOMURL"] = "API_DELETE_DICOMURL";
    PermissionsEnum["API_DELETE_DICTATION"] = "API_DELETE_DICTATION";
    PermissionsEnum["API_DELETE_DICTATIONAUDIO"] = "API_DELETE_DICTATIONAUDIO";
    PermissionsEnum["API_DELETE_DOWNLOAD"] = "API_DELETE_DOWNLOAD";
    PermissionsEnum["API_DELETE_DOWNLOADISO"] = "API_DELETE_DOWNLOADISO";
    PermissionsEnum["API_DELETE_DOWNLOADISOMULTI"] = "API_DELETE_DOWNLOADISOMULTI";
    PermissionsEnum["API_DELETE_DOWNLOADISOVIEW"] = "API_DELETE_DOWNLOADISOVIEW";
    PermissionsEnum["API_DELETE_EXTERNALORDER"] = "API_DELETE_EXTERNALORDER";
    PermissionsEnum["API_DELETE_FACILITY"] = "API_DELETE_FACILITY";
    PermissionsEnum["API_DELETE_FACILITYPDFTEMPLATE"] = "API_DELETE_FACILITYPDFTEMPLATE";
    PermissionsEnum["API_DELETE_FACILITYPRACTITIONER"] = "API_DELETE_FACILITYPRACTITIONER";
    PermissionsEnum["API_DELETE_FLAG"] = "API_DELETE_FLAG";
    PermissionsEnum["API_DELETE_GLOBALASSET"] = "API_DELETE_GLOBALASSET";
    PermissionsEnum["API_DELETE_HEALTHOFFICER"] = "API_DELETE_HEALTHOFFICER";
    PermissionsEnum["API_DELETE_INSTANCE"] = "API_DELETE_INSTANCE";
    PermissionsEnum["API_DELETE_INSTANCEDICOMTAGS"] = "API_DELETE_INSTANCEDICOMTAGS";
    PermissionsEnum["API_DELETE_INSTANCEFILE"] = "API_DELETE_INSTANCEFILE";
    PermissionsEnum["API_DELETE_INSTANCEPARENT"] = "API_DELETE_INSTANCEPARENT";
    PermissionsEnum["API_DELETE_INSTANCEVIEW"] = "API_DELETE_INSTANCEVIEW";
    PermissionsEnum["API_DELETE_JOINPATIENTS"] = "API_DELETE_JOINPATIENTS";
    PermissionsEnum["API_DELETE_JOINSTUDIES"] = "API_DELETE_JOINSTUDIES";
    PermissionsEnum["API_DELETE_LICENSE"] = "API_DELETE_LICENSE";
    PermissionsEnum["API_DELETE_MAILPROXY"] = "API_DELETE_MAILPROXY";
    PermissionsEnum["API_DELETE_MEASUREMENT"] = "API_DELETE_MEASUREMENT";
    PermissionsEnum["API_DELETE_MESSAGEPROXY"] = "API_DELETE_MESSAGEPROXY";
    PermissionsEnum["API_DELETE_MIGRATION"] = "API_DELETE_MIGRATION";
    PermissionsEnum["API_DELETE_MOBILEINSTANCEFILE"] = "API_DELETE_MOBILEINSTANCEFILE";
    PermissionsEnum["API_DELETE_MODALITY"] = "API_DELETE_MODALITY";
    PermissionsEnum["API_DELETE_MULTIPROCESSING"] = "API_DELETE_MULTIPROCESSING";
    PermissionsEnum["API_DELETE_NURSINGUNIT"] = "API_DELETE_NURSINGUNIT";
    PermissionsEnum["API_DELETE_OPERATION"] = "API_DELETE_OPERATION";
    PermissionsEnum["API_DELETE_OPERATIONGROUP"] = "API_DELETE_OPERATIONGROUP";
    PermissionsEnum["API_DELETE_ORGANIZATION"] = "API_DELETE_ORGANIZATION";
    PermissionsEnum["API_DELETE_ORGANIZATIONBLACKLIST"] = "API_DELETE_ORGANIZATIONBLACKLIST";
    PermissionsEnum["API_DELETE_ORGANIZATIONCONFIGURATION"] = "API_DELETE_ORGANIZATIONCONFIGURATION";
    PermissionsEnum["API_DELETE_ORGANIZATIONCRITICALVALUE"] = "API_DELETE_ORGANIZATIONCRITICALVALUE";
    PermissionsEnum["API_DELETE_ORGANIZATIONFLAG"] = "API_DELETE_ORGANIZATIONFLAG";
    PermissionsEnum["API_DELETE_ORGANIZATIONINVITATION"] = "API_DELETE_ORGANIZATIONINVITATION";
    PermissionsEnum["API_DELETE_ORGANIZATIONOWNER"] = "API_DELETE_ORGANIZATIONOWNER";
    PermissionsEnum["API_DELETE_ORGANIZATIONSPECIFICFIELD"] = "API_DELETE_ORGANIZATIONSPECIFICFIELD";
    PermissionsEnum["API_DELETE_ORGANIZATIONSPECIFICFIELDOPTION"] = "API_DELETE_ORGANIZATIONSPECIFICFIELDOPTION";
    PermissionsEnum["API_DELETE_ORGANIZATIONUSER"] = "API_DELETE_ORGANIZATIONUSER";
    PermissionsEnum["API_DELETE_ORGANIZATIONUSERGROUP"] = "API_DELETE_ORGANIZATIONUSERGROUP";
    PermissionsEnum["API_DELETE_PATIENT"] = "API_DELETE_PATIENT";
    PermissionsEnum["API_DELETE_PDFTEMPLATE"] = "API_DELETE_PDFTEMPLATE";
    PermissionsEnum["API_DELETE_PRACTITIONER"] = "API_DELETE_PRACTITIONER";
    PermissionsEnum["API_DELETE_PRACTITIONERASSIGNATION"] = "API_DELETE_PRACTITIONERASSIGNATION";
    PermissionsEnum["API_DELETE_PRODUCT"] = "API_DELETE_PRODUCT";
    PermissionsEnum["API_DELETE_PRODUCTORGANIZATION"] = "API_DELETE_PRODUCTORGANIZATION";
    PermissionsEnum["API_DELETE_PRODUCTORGANIZATIONBILLING"] = "API_DELETE_PRODUCTORGANIZATIONBILLING";
    PermissionsEnum["API_DELETE_PRODUCTORGANIZATIONFACILITYBILLING"] = "API_DELETE_PRODUCTORGANIZATIONFACILITYBILLING";
    PermissionsEnum["API_DELETE_PRODUCTPERMISSIONGROUP"] = "API_DELETE_PRODUCTPERMISSIONGROUP";
    PermissionsEnum["API_DELETE_REPORT"] = "API_DELETE_REPORT";
    PermissionsEnum["API_DELETE_REPORTCONCLUSION"] = "API_DELETE_REPORTCONCLUSION";
    PermissionsEnum["API_DELETE_REPORTFIELD"] = "API_DELETE_REPORTFIELD";
    PermissionsEnum["API_DELETE_REPORTIMAGE"] = "API_DELETE_REPORTIMAGE";
    PermissionsEnum["API_DELETE_REPORTMESSAGE"] = "API_DELETE_REPORTMESSAGE";
    PermissionsEnum["API_DELETE_REPORTSIGNISSUES"] = "API_DELETE_REPORTSIGNISSUES";
    PermissionsEnum["API_DELETE_REQUEST"] = "API_DELETE_REQUEST";
    PermissionsEnum["API_DELETE_ROUTER"] = "API_DELETE_ROUTER";
    PermissionsEnum["API_DELETE_SERIES"] = "API_DELETE_SERIES";
    PermissionsEnum["API_DELETE_SERIESECG"] = "API_DELETE_SERIESECG";
    PermissionsEnum["API_DELETE_SERIESECGSIGNAL"] = "API_DELETE_SERIESECGSIGNAL";
    PermissionsEnum["API_DELETE_SERIESVIEWER"] = "API_DELETE_SERIESVIEWER";
    PermissionsEnum["API_DELETE_SPECIALTY"] = "API_DELETE_SPECIALTY";
    PermissionsEnum["API_DELETE_SPELLCHECKLANGUAGE"] = "API_DELETE_SPELLCHECKLANGUAGE";
    PermissionsEnum["API_DELETE_SPLITSTUDIES"] = "API_DELETE_SPLITSTUDIES";
    PermissionsEnum["API_DELETE_STUDY"] = "API_DELETE_STUDY";
    PermissionsEnum["API_DELETE_STUDYCRITICALVALUE"] = "API_DELETE_STUDYCRITICALVALUE";
    PermissionsEnum["API_DELETE_STUDYDATA"] = "API_DELETE_STUDYDATA";
    PermissionsEnum["API_DELETE_STUDYEVENT"] = "API_DELETE_STUDYEVENT";
    PermissionsEnum["API_DELETE_STUDYEVENTVIEW"] = "API_DELETE_STUDYEVENTVIEW";
    PermissionsEnum["API_DELETE_STUDYFILE"] = "API_DELETE_STUDYFILE";
    PermissionsEnum["API_DELETE_STUDYLIST"] = "API_DELETE_STUDYLIST";
    PermissionsEnum["API_DELETE_STUDYNOTE"] = "API_DELETE_STUDYNOTE";
    PermissionsEnum["API_DELETE_STUDYOPERATIONSCHANGELOG"] = "API_DELETE_STUDYOPERATIONSCHANGELOG";
    PermissionsEnum["API_DELETE_STUDYPDFFILE"] = "API_DELETE_STUDYPDFFILE";
    PermissionsEnum["API_DELETE_STUDYREVIEWRULE"] = "API_DELETE_STUDYREVIEWRULE";
    PermissionsEnum["API_DELETE_STUDYSTATISTICS"] = "API_DELETE_STUDYSTATISTICS";
    PermissionsEnum["API_DELETE_STUDYTYPE"] = "API_DELETE_STUDYTYPE";
    PermissionsEnum["API_DELETE_STUDYTZ"] = "API_DELETE_STUDYTZ";
    PermissionsEnum["API_DELETE_STUDYWRONGMODALITIES"] = "API_DELETE_STUDYWRONGMODALITIES";
    PermissionsEnum["API_DELETE_STUDYWRONGMODALITIESFULLSEARCH"] = "API_DELETE_STUDYWRONGMODALITIESFULLSEARCH";
    PermissionsEnum["API_DELETE_SUSPENDEDACCOUNT"] = "API_DELETE_SUSPENDEDACCOUNT";
    PermissionsEnum["API_DELETE_TEMPLATE"] = "API_DELETE_TEMPLATE";
    PermissionsEnum["API_DELETE_TEMPLATEFIELD"] = "API_DELETE_TEMPLATEFIELD";
    PermissionsEnum["API_DELETE_TRANSLATIONTERM"] = "API_DELETE_TRANSLATIONTERM";
    PermissionsEnum["API_DELETE_USER"] = "API_DELETE_USER";
    PermissionsEnum["API_DELETE_USERINTEGRATION"] = "API_DELETE_USERINTEGRATION";
    PermissionsEnum["API_DELETE_USERPREFERENCE"] = "API_DELETE_USERPREFERENCE";
    PermissionsEnum["API_DELETE_USERROWPERMISSION"] = "API_DELETE_USERROWPERMISSION";
    PermissionsEnum["API_DELETE_VISITANT"] = "API_DELETE_VISITANT";
    PermissionsEnum["API_DELETE_VISITANTACCESS"] = "API_DELETE_VISITANTACCESS";
    PermissionsEnum["API_FIX_REPORT_SIGN_ISSUES"] = "API_FIX_REPORT_SIGN_ISSUES";
    PermissionsEnum["API_JOIN_MULTIPLE_STUDIES"] = "API_JOIN_MULTIPLE_STUDIES";
    PermissionsEnum["API_JOIN_PATIENTS"] = "API_JOIN_PATIENTS";
    PermissionsEnum["API_JOIN_STUDIES"] = "API_JOIN_STUDIES";
    PermissionsEnum["API_PREVIEW_REPORT"] = "API_PREVIEW_REPORT";
    PermissionsEnum["API_REPORT_REDIRECT"] = "API_REPORT_REDIRECT";
    PermissionsEnum["API_REQUIRE_REVIEW_REPORT"] = "API_REQUIRE_REVIEW_REPORT";
    PermissionsEnum["API_REVIEW_REPORT"] = "API_REVIEW_REPORT";
    PermissionsEnum["API_SELECT_CLONED_TEMPLATE"] = "API_SELECT_CLONED_TEMPLATE";
    PermissionsEnum["API_SEND_MAIL_REPORT"] = "API_SEND_MAIL_REPORT";
    PermissionsEnum["API_SEND_MAIL_VIEWER_LINK"] = "API_SEND_MAIL_VIEWER_LINK";
    PermissionsEnum["API_SEND_MESSAGE_REPORT"] = "API_SEND_MESSAGE_REPORT";
    PermissionsEnum["API_SEND_MESSAGE_VIEWER_LINK"] = "API_SEND_MESSAGE_VIEWER_LINK";
    PermissionsEnum["API_SEND_REPORT"] = "API_SEND_REPORT";
    PermissionsEnum["API_SEND_STUDY_VIEWER_LINK"] = "API_SEND_STUDY_VIEWER_LINK";
    PermissionsEnum["API_SIGN_ADDENDUM"] = "API_SIGN_ADDENDUM";
    PermissionsEnum["API_SIGN_REPORT"] = "API_SIGN_REPORT";
    PermissionsEnum["API_SPLIT_STUDIES"] = "API_SPLIT_STUDIES";
    PermissionsEnum["API_UNDO_SIGN_ADDENDUM"] = "API_UNDO_SIGN_ADDENDUM";
    PermissionsEnum["API_UNDO_SIGN_REPORT"] = "API_UNDO_SIGN_REPORT";
    PermissionsEnum["API_VIEW_ADDENDUM"] = "API_VIEW_ADDENDUM";
    PermissionsEnum["API_VIEW_ADDENDUMIMAGE"] = "API_VIEW_ADDENDUMIMAGE";
    PermissionsEnum["API_VIEW_ASSET"] = "API_VIEW_ASSET";
    PermissionsEnum["API_VIEW_ASSIGNDEMOSTUDYPROXY"] = "API_VIEW_ASSIGNDEMOSTUDYPROXY";
    PermissionsEnum["API_VIEW_AUTHREALMPROVIDER"] = "API_VIEW_AUTHREALMPROVIDER";
    PermissionsEnum["API_VIEW_AUTHREALMROLE"] = "API_VIEW_AUTHREALMROLE";
    PermissionsEnum["API_VIEW_AUTOSENDREPORTBIRADSRULE"] = "API_VIEW_AUTOSENDREPORTBIRADSRULE";
    PermissionsEnum["API_VIEW_AUTOSENDREPORTRULE"] = "API_VIEW_AUTOSENDREPORTRULE";
    PermissionsEnum["API_VIEW_BILLING"] = "API_VIEW_BILLING";
    PermissionsEnum["API_VIEW_BILLINGSETUP"] = "API_VIEW_BILLINGSETUP";
    PermissionsEnum["API_VIEW_BILLINGSETUPLIMIT"] = "API_VIEW_BILLINGSETUPLIMIT";
    PermissionsEnum["API_VIEW_BILLINGTYPELIMIT"] = "API_VIEW_BILLINGTYPELIMIT";
    PermissionsEnum["API_VIEW_BIRADSREPORTPROXY"] = "API_VIEW_BIRADSREPORTPROXY";
    PermissionsEnum["API_VIEW_BLOCKEDSESSION"] = "API_VIEW_BLOCKEDSESSION";
    PermissionsEnum["API_VIEW_BODYPART"] = "API_VIEW_BODYPART";
    PermissionsEnum["API_VIEW_BURNER"] = "API_VIEW_BURNER";
    PermissionsEnum["API_VIEW_CHANGEUSERORGANIZATION"] = "API_VIEW_CHANGEUSERORGANIZATION";
    PermissionsEnum["API_VIEW_CONFIGURATION"] = "API_VIEW_CONFIGURATION";
    PermissionsEnum["API_VIEW_COUNTRY"] = "API_VIEW_COUNTRY";
    PermissionsEnum["API_VIEW_CREATEMULTIORGUSER"] = "API_VIEW_CREATEMULTIORGUSER";
    PermissionsEnum["API_VIEW_CREATEREFERRINGPRACTITIONER"] = "API_VIEW_CREATEREFERRINGPRACTITIONER";
    PermissionsEnum["API_VIEW_CRITICALVALUE"] = "API_VIEW_CRITICALVALUE";
    PermissionsEnum["API_VIEW_CRMORGANIZATION"] = "API_VIEW_CRMORGANIZATION";
    PermissionsEnum["API_VIEW_DEMOSTUDY"] = "API_VIEW_DEMOSTUDY";
    PermissionsEnum["API_VIEW_DEMOSTUDYPROXY"] = "API_VIEW_DEMOSTUDYPROXY";
    PermissionsEnum["API_VIEW_DICOMFILE"] = "API_VIEW_DICOMFILE";
    PermissionsEnum["API_VIEW_DICOMPRINT"] = "API_VIEW_DICOMPRINT";
    PermissionsEnum["API_VIEW_DICOMPRINTER"] = "API_VIEW_DICOMPRINTER";
    PermissionsEnum["API_VIEW_DICOMURL"] = "API_VIEW_DICOMURL";
    PermissionsEnum["API_VIEW_DICOM_PRINTS_BY_BURNER"] = "API_VIEW_DICOM_PRINTS_BY_BURNER";
    PermissionsEnum["API_VIEW_DICTATION"] = "API_VIEW_DICTATION";
    PermissionsEnum["API_VIEW_DICTATIONAUDIO"] = "API_VIEW_DICTATIONAUDIO";
    PermissionsEnum["API_VIEW_DOWNLOAD"] = "API_VIEW_DOWNLOAD";
    PermissionsEnum["API_VIEW_DOWNLOADISO"] = "API_VIEW_DOWNLOADISO";
    PermissionsEnum["API_VIEW_DOWNLOADISOMULTI"] = "API_VIEW_DOWNLOADISOMULTI";
    PermissionsEnum["API_VIEW_DOWNLOADISOVIEW"] = "API_VIEW_DOWNLOADISOVIEW";
    PermissionsEnum["API_VIEW_DOWNLOAD_ISOS_BY_BURNER"] = "API_VIEW_DOWNLOAD_ISOS_BY_BURNER";
    PermissionsEnum["API_VIEW_EXTERNALORDER"] = "API_VIEW_EXTERNALORDER";
    PermissionsEnum["API_VIEW_FACILITY"] = "API_VIEW_FACILITY";
    PermissionsEnum["API_VIEW_FACILITYPDFTEMPLATE"] = "API_VIEW_FACILITYPDFTEMPLATE";
    PermissionsEnum["API_VIEW_FACILITYPRACTITIONER"] = "API_VIEW_FACILITYPRACTITIONER";
    PermissionsEnum["API_VIEW_FLAG"] = "API_VIEW_FLAG";
    PermissionsEnum["API_VIEW_GLOBALASSET"] = "API_VIEW_GLOBALASSET";
    PermissionsEnum["API_VIEW_HEALTHOFFICER"] = "API_VIEW_HEALTHOFFICER";
    PermissionsEnum["API_VIEW_INSTANCE"] = "API_VIEW_INSTANCE";
    PermissionsEnum["API_VIEW_INSTANCEDICOMTAGS"] = "API_VIEW_INSTANCEDICOMTAGS";
    PermissionsEnum["API_VIEW_INSTANCEFILE"] = "API_VIEW_INSTANCEFILE";
    PermissionsEnum["API_VIEW_INSTANCEPARENT"] = "API_VIEW_INSTANCEPARENT";
    PermissionsEnum["API_VIEW_INSTANCEVIEW"] = "API_VIEW_INSTANCEVIEW";
    PermissionsEnum["API_VIEW_JOINPATIENTS"] = "API_VIEW_JOINPATIENTS";
    PermissionsEnum["API_VIEW_JOINSTUDIES"] = "API_VIEW_JOINSTUDIES";
    PermissionsEnum["API_VIEW_LICENSE"] = "API_VIEW_LICENSE";
    PermissionsEnum["API_VIEW_MAILPROXY"] = "API_VIEW_MAILPROXY";
    PermissionsEnum["API_VIEW_MEASUREMENT"] = "API_VIEW_MEASUREMENT";
    PermissionsEnum["API_VIEW_MESSAGEPROXY"] = "API_VIEW_MESSAGEPROXY";
    PermissionsEnum["API_VIEW_MIGRATION"] = "API_VIEW_MIGRATION";
    PermissionsEnum["API_VIEW_MOBILEINSTANCEFILE"] = "API_VIEW_MOBILEINSTANCEFILE";
    PermissionsEnum["API_VIEW_MODALITY"] = "API_VIEW_MODALITY";
    PermissionsEnum["API_VIEW_MULTIPROCESSING"] = "API_VIEW_MULTIPROCESSING";
    PermissionsEnum["API_VIEW_NURSINGUNIT"] = "API_VIEW_NURSINGUNIT";
    PermissionsEnum["API_VIEW_OPERATION"] = "API_VIEW_OPERATION";
    PermissionsEnum["API_VIEW_OPERATIONGROUP"] = "API_VIEW_OPERATIONGROUP";
    PermissionsEnum["API_VIEW_ORGANIZATION"] = "API_VIEW_ORGANIZATION";
    PermissionsEnum["API_VIEW_ORGANIZATIONBLACKLIST"] = "API_VIEW_ORGANIZATIONBLACKLIST";
    PermissionsEnum["API_VIEW_ORGANIZATIONCONFIGURATION"] = "API_VIEW_ORGANIZATIONCONFIGURATION";
    PermissionsEnum["API_VIEW_ORGANIZATIONCRITICALVALUE"] = "API_VIEW_ORGANIZATIONCRITICALVALUE";
    PermissionsEnum["API_VIEW_ORGANIZATIONFLAG"] = "API_VIEW_ORGANIZATIONFLAG";
    PermissionsEnum["API_VIEW_ORGANIZATIONINVITATION"] = "API_VIEW_ORGANIZATIONINVITATION";
    PermissionsEnum["API_VIEW_ORGANIZATIONOWNER"] = "API_VIEW_ORGANIZATIONOWNER";
    PermissionsEnum["API_VIEW_ORGANIZATIONSPECIFICFIELD"] = "API_VIEW_ORGANIZATIONSPECIFICFIELD";
    PermissionsEnum["API_VIEW_ORGANIZATIONSPECIFICFIELDOPTION"] = "API_VIEW_ORGANIZATIONSPECIFICFIELDOPTION";
    PermissionsEnum["API_VIEW_ORGANIZATIONUSER"] = "API_VIEW_ORGANIZATIONUSER";
    PermissionsEnum["API_VIEW_ORGANIZATIONUSERGROUP"] = "API_VIEW_ORGANIZATIONUSERGROUP";
    PermissionsEnum["API_VIEW_PATIENT"] = "API_VIEW_PATIENT";
    PermissionsEnum["API_VIEW_PDFTEMPLATE"] = "API_VIEW_PDFTEMPLATE";
    PermissionsEnum["API_VIEW_PRACTITIONER"] = "API_VIEW_PRACTITIONER";
    PermissionsEnum["API_VIEW_PRACTITIONERASSIGNATION"] = "API_VIEW_PRACTITIONERASSIGNATION";
    PermissionsEnum["API_VIEW_PRODUCT"] = "API_VIEW_PRODUCT";
    PermissionsEnum["API_VIEW_PRODUCTORGANIZATION"] = "API_VIEW_PRODUCTORGANIZATION";
    PermissionsEnum["API_VIEW_PRODUCTORGANIZATIONBILLING"] = "API_VIEW_PRODUCTORGANIZATIONBILLING";
    PermissionsEnum["API_VIEW_PRODUCTORGANIZATIONFACILITYBILLING"] = "API_VIEW_PRODUCTORGANIZATIONFACILITYBILLING";
    PermissionsEnum["API_VIEW_PRODUCTPERMISSIONGROUP"] = "API_VIEW_PRODUCTPERMISSIONGROUP";
    PermissionsEnum["API_VIEW_REPORT"] = "API_VIEW_REPORT";
    PermissionsEnum["API_VIEW_REPORTCONCLUSION"] = "API_VIEW_REPORTCONCLUSION";
    PermissionsEnum["API_VIEW_REPORTFIELD"] = "API_VIEW_REPORTFIELD";
    PermissionsEnum["API_VIEW_REPORTIMAGE"] = "API_VIEW_REPORTIMAGE";
    PermissionsEnum["API_VIEW_REPORTMESSAGE"] = "API_VIEW_REPORTMESSAGE";
    PermissionsEnum["API_VIEW_REPORTSIGNISSUES"] = "API_VIEW_REPORTSIGNISSUES";
    PermissionsEnum["API_VIEW_REQUEST"] = "API_VIEW_REQUEST";
    PermissionsEnum["API_VIEW_ROUTER"] = "API_VIEW_ROUTER";
    PermissionsEnum["API_VIEW_SERIES"] = "API_VIEW_SERIES";
    PermissionsEnum["API_VIEW_SERIESECG"] = "API_VIEW_SERIESECG";
    PermissionsEnum["API_VIEW_SERIESECGSIGNAL"] = "API_VIEW_SERIESECGSIGNAL";
    PermissionsEnum["API_VIEW_SERIESVIEWER"] = "API_VIEW_SERIESVIEWER";
    PermissionsEnum["API_VIEW_SINGLE_NURSING_UNIT"] = "API_VIEW_SINGLE_NURSING_UNIT";
    PermissionsEnum["API_VIEW_SINGLE_STUDY"] = "API_VIEW_SINGLE_STUDY";
    PermissionsEnum["API_VIEW_SPECIALTY"] = "API_VIEW_SPECIALTY";
    PermissionsEnum["API_VIEW_SPELLCHECKLANGUAGE"] = "API_VIEW_SPELLCHECKLANGUAGE";
    PermissionsEnum["API_VIEW_SPLITSTUDIES"] = "API_VIEW_SPLITSTUDIES";
    PermissionsEnum["API_VIEW_STUDIES"] = "API_VIEW_STUDIES";
    PermissionsEnum["API_VIEW_STUDY"] = "API_VIEW_STUDY";
    PermissionsEnum["API_VIEW_STUDYCRITICALVALUE"] = "API_VIEW_STUDYCRITICALVALUE";
    PermissionsEnum["API_VIEW_STUDYDATA"] = "API_VIEW_STUDYDATA";
    PermissionsEnum["API_VIEW_STUDYEVENT"] = "API_VIEW_STUDYEVENT";
    PermissionsEnum["API_VIEW_STUDYEVENTVIEW"] = "API_VIEW_STUDYEVENTVIEW";
    PermissionsEnum["API_VIEW_STUDYFILE"] = "API_VIEW_STUDYFILE";
    PermissionsEnum["API_VIEW_STUDYLIST"] = "API_VIEW_STUDYLIST";
    PermissionsEnum["API_VIEW_STUDYNOTE"] = "API_VIEW_STUDYNOTE";
    PermissionsEnum["API_VIEW_STUDYOPERATIONSCHANGELOG"] = "API_VIEW_STUDYOPERATIONSCHANGELOG";
    PermissionsEnum["API_VIEW_STUDYPDFFILE"] = "API_VIEW_STUDYPDFFILE";
    PermissionsEnum["API_VIEW_STUDYREVIEWRULE"] = "API_VIEW_STUDYREVIEWRULE";
    PermissionsEnum["API_VIEW_STUDYSTATISTICS"] = "API_VIEW_STUDYSTATISTICS";
    PermissionsEnum["API_VIEW_STUDYTYPE"] = "API_VIEW_STUDYTYPE";
    PermissionsEnum["API_VIEW_STUDYTZ"] = "API_VIEW_STUDYTZ";
    PermissionsEnum["API_VIEW_STUDYWRONGMODALITIES"] = "API_VIEW_STUDYWRONGMODALITIES";
    PermissionsEnum["API_VIEW_STUDYWRONGMODALITIESFULLSEARCH"] = "API_VIEW_STUDYWRONGMODALITIESFULLSEARCH";
    PermissionsEnum["API_VIEW_STUDY_STATISTICS"] = "API_VIEW_STUDY_STATISTICS";
    PermissionsEnum["API_VIEW_SUSPENDEDACCOUNT"] = "API_VIEW_SUSPENDEDACCOUNT";
    PermissionsEnum["API_VIEW_TEMPLATE"] = "API_VIEW_TEMPLATE";
    PermissionsEnum["API_VIEW_TEMPLATEFIELD"] = "API_VIEW_TEMPLATEFIELD";
    PermissionsEnum["API_VIEW_TRANSLATIONTERM"] = "API_VIEW_TRANSLATIONTERM";
    PermissionsEnum["API_VIEW_USER"] = "API_VIEW_USER";
    PermissionsEnum["API_VIEW_USERFEATUREPERMISSIONS"] = "API_VIEW_USERFEATUREPERMISSIONS";
    PermissionsEnum["API_VIEW_USERINTEGRATION"] = "API_VIEW_USERINTEGRATION";
    PermissionsEnum["API_VIEW_USERPREFERENCE"] = "API_VIEW_USERPREFERENCE";
    PermissionsEnum["API_VIEW_USERROWPERMISSION"] = "API_VIEW_USERROWPERMISSION";
    PermissionsEnum["API_VIEW_VIEWER_LINK"] = "API_VIEW_VIEWER_LINK";
    PermissionsEnum["API_VIEW_VISITANT"] = "API_VIEW_VISITANT";
    PermissionsEnum["API_VIEW_VISITANTACCESS"] = "API_VIEW_VISITANTACCESS";
    PermissionsEnum["MANAGEMENT_ADD_ADDRESS"] = "MANAGEMENT_ADD_ADDRESS";
    PermissionsEnum["MANAGEMENT_ADD_APPOINTMENT"] = "MANAGEMENT_ADD_APPOINTMENT";
    PermissionsEnum["MANAGEMENT_ADD_CFDIDATA"] = "MANAGEMENT_ADD_CFDIDATA";
    PermissionsEnum["MANAGEMENT_ADD_CITY"] = "MANAGEMENT_ADD_CITY";
    PermissionsEnum["MANAGEMENT_ADD_COMPANY"] = "MANAGEMENT_ADD_COMPANY";
    PermissionsEnum["MANAGEMENT_ADD_CONSUMABLE"] = "MANAGEMENT_ADD_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_ADD_CONTACT"] = "MANAGEMENT_ADD_CONTACT";
    PermissionsEnum["MANAGEMENT_ADD_DISCOUNT"] = "MANAGEMENT_ADD_DISCOUNT";
    PermissionsEnum["MANAGEMENT_ADD_FACILITYADDRESS"] = "MANAGEMENT_ADD_FACILITYADDRESS";
    PermissionsEnum["MANAGEMENT_ADD_FACILITYTEMPLATE"] = "MANAGEMENT_ADD_FACILITYTEMPLATE";
    PermissionsEnum["MANAGEMENT_ADD_FISCALDATA"] = "MANAGEMENT_ADD_FISCALDATA";
    PermissionsEnum["MANAGEMENT_ADD_INSURANCECARRIER"] = "MANAGEMENT_ADD_INSURANCECARRIER";
    PermissionsEnum["MANAGEMENT_ADD_INVOICE"] = "MANAGEMENT_ADD_INVOICE";
    PermissionsEnum["MANAGEMENT_ADD_INVOICELINE"] = "MANAGEMENT_ADD_INVOICELINE";
    PermissionsEnum["MANAGEMENT_ADD_INVOICELINETAX"] = "MANAGEMENT_ADD_INVOICELINETAX";
    PermissionsEnum["MANAGEMENT_ADD_INVOICEUSAGE"] = "MANAGEMENT_ADD_INVOICEUSAGE";
    PermissionsEnum["MANAGEMENT_ADD_MEASUREMENTUNIT"] = "MANAGEMENT_ADD_MEASUREMENTUNIT";
    PermissionsEnum["MANAGEMENT_ADD_MGMTSTUDY"] = "MANAGEMENT_ADD_MGMTSTUDY";
    PermissionsEnum["MANAGEMENT_ADD_ORDER"] = "MANAGEMENT_ADD_ORDER";
    PermissionsEnum["MANAGEMENT_ADD_ORDERCANCELREASON"] = "MANAGEMENT_ADD_ORDERCANCELREASON";
    PermissionsEnum["MANAGEMENT_ADD_ORDERFILE"] = "MANAGEMENT_ADD_ORDERFILE";
    PermissionsEnum["MANAGEMENT_ADD_ORDERSTUDYFILE"] = "MANAGEMENT_ADD_ORDERSTUDYFILE";
    PermissionsEnum["MANAGEMENT_ADD_ORDERTZ"] = "MANAGEMENT_ADD_ORDERTZ";
    PermissionsEnum["MANAGEMENT_ADD_ORGANIZATIONTEMPLATE"] = "MANAGEMENT_ADD_ORGANIZATIONTEMPLATE";
    PermissionsEnum["MANAGEMENT_ADD_PATIENTDATA"] = "MANAGEMENT_ADD_PATIENTDATA";
    PermissionsEnum["MANAGEMENT_ADD_PAYMENT"] = "MANAGEMENT_ADD_PAYMENT";
    PermissionsEnum["MANAGEMENT_ADD_PAYMENTORDER"] = "MANAGEMENT_ADD_PAYMENTORDER";
    PermissionsEnum["MANAGEMENT_ADD_PAYMENTORDERSTUDYORDER"] = "MANAGEMENT_ADD_PAYMENTORDERSTUDYORDER";
    PermissionsEnum["MANAGEMENT_ADD_PAYMENTTYPE"] = "MANAGEMENT_ADD_PAYMENTTYPE";
    PermissionsEnum["MANAGEMENT_ADD_PHYSICIAN"] = "MANAGEMENT_ADD_PHYSICIAN";
    PermissionsEnum["MANAGEMENT_ADD_PRODUCTCODE"] = "MANAGEMENT_ADD_PRODUCTCODE";
    PermissionsEnum["MANAGEMENT_ADD_QUOTE"] = "MANAGEMENT_ADD_QUOTE";
    PermissionsEnum["MANAGEMENT_ADD_QUOTEDISCOUNT"] = "MANAGEMENT_ADD_QUOTEDISCOUNT";
    PermissionsEnum["MANAGEMENT_ADD_QUOTEITEM"] = "MANAGEMENT_ADD_QUOTEITEM";
    PermissionsEnum["MANAGEMENT_ADD_QUOTEITEMDISCOUNT"] = "MANAGEMENT_ADD_QUOTEITEMDISCOUNT";
    PermissionsEnum["MANAGEMENT_ADD_RISMESSAGE"] = "MANAGEMENT_ADD_RISMESSAGE";
    PermissionsEnum["MANAGEMENT_ADD_ROOM"] = "MANAGEMENT_ADD_ROOM";
    PermissionsEnum["MANAGEMENT_ADD_ROOMDAILYSCHEDULE"] = "MANAGEMENT_ADD_ROOMDAILYSCHEDULE";
    PermissionsEnum["MANAGEMENT_ADD_SALECHANNEL"] = "MANAGEMENT_ADD_SALECHANNEL";
    PermissionsEnum["MANAGEMENT_ADD_SETUPMANAGEMENTPROXY"] = "MANAGEMENT_ADD_SETUPMANAGEMENTPROXY";
    PermissionsEnum["MANAGEMENT_ADD_STATE"] = "MANAGEMENT_ADD_STATE";
    PermissionsEnum["MANAGEMENT_ADD_STUDYBODYPART"] = "MANAGEMENT_ADD_STUDYBODYPART";
    PermissionsEnum["MANAGEMENT_ADD_STUDYCONSUMABLE"] = "MANAGEMENT_ADD_STUDYCONSUMABLE";
    PermissionsEnum["MANAGEMENT_ADD_STUDYCOUPON"] = "MANAGEMENT_ADD_STUDYCOUPON";
    PermissionsEnum["MANAGEMENT_ADD_STUDYDISCOUNT"] = "MANAGEMENT_ADD_STUDYDISCOUNT";
    PermissionsEnum["MANAGEMENT_ADD_STUDYLOADCSV"] = "MANAGEMENT_ADD_STUDYLOADCSV";
    PermissionsEnum["MANAGEMENT_ADD_STUDYROOM"] = "MANAGEMENT_ADD_STUDYROOM";
    PermissionsEnum["MANAGEMENT_ADD_STUDYTAX"] = "MANAGEMENT_ADD_STUDYTAX";
    PermissionsEnum["MANAGEMENT_ADD_TAX"] = "MANAGEMENT_ADD_TAX";
    PermissionsEnum["MANAGEMENT_ADD_TAXREGIME"] = "MANAGEMENT_ADD_TAXREGIME";
    PermissionsEnum["MANAGEMENT_CHANGE_ADDRESS"] = "MANAGEMENT_CHANGE_ADDRESS";
    PermissionsEnum["MANAGEMENT_CHANGE_APPOINTMENT"] = "MANAGEMENT_CHANGE_APPOINTMENT";
    PermissionsEnum["MANAGEMENT_CHANGE_CFDIDATA"] = "MANAGEMENT_CHANGE_CFDIDATA";
    PermissionsEnum["MANAGEMENT_CHANGE_CITY"] = "MANAGEMENT_CHANGE_CITY";
    PermissionsEnum["MANAGEMENT_CHANGE_COMPANY"] = "MANAGEMENT_CHANGE_COMPANY";
    PermissionsEnum["MANAGEMENT_CHANGE_CONSUMABLE"] = "MANAGEMENT_CHANGE_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_CHANGE_CONTACT"] = "MANAGEMENT_CHANGE_CONTACT";
    PermissionsEnum["MANAGEMENT_CHANGE_DISCOUNT"] = "MANAGEMENT_CHANGE_DISCOUNT";
    PermissionsEnum["MANAGEMENT_CHANGE_FACILITYADDRESS"] = "MANAGEMENT_CHANGE_FACILITYADDRESS";
    PermissionsEnum["MANAGEMENT_CHANGE_FACILITYTEMPLATE"] = "MANAGEMENT_CHANGE_FACILITYTEMPLATE";
    PermissionsEnum["MANAGEMENT_CHANGE_FISCALDATA"] = "MANAGEMENT_CHANGE_FISCALDATA";
    PermissionsEnum["MANAGEMENT_CHANGE_INSURANCECARRIER"] = "MANAGEMENT_CHANGE_INSURANCECARRIER";
    PermissionsEnum["MANAGEMENT_CHANGE_INVOICE"] = "MANAGEMENT_CHANGE_INVOICE";
    PermissionsEnum["MANAGEMENT_CHANGE_INVOICELINE"] = "MANAGEMENT_CHANGE_INVOICELINE";
    PermissionsEnum["MANAGEMENT_CHANGE_INVOICELINETAX"] = "MANAGEMENT_CHANGE_INVOICELINETAX";
    PermissionsEnum["MANAGEMENT_CHANGE_INVOICEUSAGE"] = "MANAGEMENT_CHANGE_INVOICEUSAGE";
    PermissionsEnum["MANAGEMENT_CHANGE_MEASUREMENTUNIT"] = "MANAGEMENT_CHANGE_MEASUREMENTUNIT";
    PermissionsEnum["MANAGEMENT_CHANGE_MGMTSTUDY"] = "MANAGEMENT_CHANGE_MGMTSTUDY";
    PermissionsEnum["MANAGEMENT_CHANGE_ORDER"] = "MANAGEMENT_CHANGE_ORDER";
    PermissionsEnum["MANAGEMENT_CHANGE_ORDERCANCELREASON"] = "MANAGEMENT_CHANGE_ORDERCANCELREASON";
    PermissionsEnum["MANAGEMENT_CHANGE_ORDERFILE"] = "MANAGEMENT_CHANGE_ORDERFILE";
    PermissionsEnum["MANAGEMENT_CHANGE_ORDERSTUDYFILE"] = "MANAGEMENT_CHANGE_ORDERSTUDYFILE";
    PermissionsEnum["MANAGEMENT_CHANGE_ORDERTZ"] = "MANAGEMENT_CHANGE_ORDERTZ";
    PermissionsEnum["MANAGEMENT_CHANGE_ORGANIZATIONTEMPLATE"] = "MANAGEMENT_CHANGE_ORGANIZATIONTEMPLATE";
    PermissionsEnum["MANAGEMENT_CHANGE_PATIENTDATA"] = "MANAGEMENT_CHANGE_PATIENTDATA";
    PermissionsEnum["MANAGEMENT_CHANGE_PAYMENT"] = "MANAGEMENT_CHANGE_PAYMENT";
    PermissionsEnum["MANAGEMENT_CHANGE_PAYMENTORDER"] = "MANAGEMENT_CHANGE_PAYMENTORDER";
    PermissionsEnum["MANAGEMENT_CHANGE_PAYMENTORDERSTUDYORDER"] = "MANAGEMENT_CHANGE_PAYMENTORDERSTUDYORDER";
    PermissionsEnum["MANAGEMENT_CHANGE_PAYMENTTYPE"] = "MANAGEMENT_CHANGE_PAYMENTTYPE";
    PermissionsEnum["MANAGEMENT_CHANGE_PHYSICIAN"] = "MANAGEMENT_CHANGE_PHYSICIAN";
    PermissionsEnum["MANAGEMENT_CHANGE_PRODUCTCODE"] = "MANAGEMENT_CHANGE_PRODUCTCODE";
    PermissionsEnum["MANAGEMENT_CHANGE_QUOTE"] = "MANAGEMENT_CHANGE_QUOTE";
    PermissionsEnum["MANAGEMENT_CHANGE_QUOTEDISCOUNT"] = "MANAGEMENT_CHANGE_QUOTEDISCOUNT";
    PermissionsEnum["MANAGEMENT_CHANGE_QUOTEITEM"] = "MANAGEMENT_CHANGE_QUOTEITEM";
    PermissionsEnum["MANAGEMENT_CHANGE_QUOTEITEMDISCOUNT"] = "MANAGEMENT_CHANGE_QUOTEITEMDISCOUNT";
    PermissionsEnum["MANAGEMENT_CHANGE_RISMESSAGE"] = "MANAGEMENT_CHANGE_RISMESSAGE";
    PermissionsEnum["MANAGEMENT_CHANGE_ROOM"] = "MANAGEMENT_CHANGE_ROOM";
    PermissionsEnum["MANAGEMENT_CHANGE_ROOMDAILYSCHEDULE"] = "MANAGEMENT_CHANGE_ROOMDAILYSCHEDULE";
    PermissionsEnum["MANAGEMENT_CHANGE_SALECHANNEL"] = "MANAGEMENT_CHANGE_SALECHANNEL";
    PermissionsEnum["MANAGEMENT_CHANGE_SETUPMANAGEMENTPROXY"] = "MANAGEMENT_CHANGE_SETUPMANAGEMENTPROXY";
    PermissionsEnum["MANAGEMENT_CHANGE_STATE"] = "MANAGEMENT_CHANGE_STATE";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYBODYPART"] = "MANAGEMENT_CHANGE_STUDYBODYPART";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYCONSUMABLE"] = "MANAGEMENT_CHANGE_STUDYCONSUMABLE";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYCOUPON"] = "MANAGEMENT_CHANGE_STUDYCOUPON";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYDISCOUNT"] = "MANAGEMENT_CHANGE_STUDYDISCOUNT";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYLOADCSV"] = "MANAGEMENT_CHANGE_STUDYLOADCSV";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYROOM"] = "MANAGEMENT_CHANGE_STUDYROOM";
    PermissionsEnum["MANAGEMENT_CHANGE_STUDYTAX"] = "MANAGEMENT_CHANGE_STUDYTAX";
    PermissionsEnum["MANAGEMENT_CHANGE_TAX"] = "MANAGEMENT_CHANGE_TAX";
    PermissionsEnum["MANAGEMENT_CHANGE_TAXREGIME"] = "MANAGEMENT_CHANGE_TAXREGIME";
    PermissionsEnum["MANAGEMENT_DELETE_ADDRESS"] = "MANAGEMENT_DELETE_ADDRESS";
    PermissionsEnum["MANAGEMENT_DELETE_APPOINTMENT"] = "MANAGEMENT_DELETE_APPOINTMENT";
    PermissionsEnum["MANAGEMENT_DELETE_CFDIDATA"] = "MANAGEMENT_DELETE_CFDIDATA";
    PermissionsEnum["MANAGEMENT_DELETE_CITY"] = "MANAGEMENT_DELETE_CITY";
    PermissionsEnum["MANAGEMENT_DELETE_COMPANY"] = "MANAGEMENT_DELETE_COMPANY";
    PermissionsEnum["MANAGEMENT_DELETE_CONSUMABLE"] = "MANAGEMENT_DELETE_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_DELETE_CONTACT"] = "MANAGEMENT_DELETE_CONTACT";
    PermissionsEnum["MANAGEMENT_DELETE_DISCOUNT"] = "MANAGEMENT_DELETE_DISCOUNT";
    PermissionsEnum["MANAGEMENT_DELETE_FACILITYADDRESS"] = "MANAGEMENT_DELETE_FACILITYADDRESS";
    PermissionsEnum["MANAGEMENT_DELETE_FACILITYTEMPLATE"] = "MANAGEMENT_DELETE_FACILITYTEMPLATE";
    PermissionsEnum["MANAGEMENT_DELETE_FISCALDATA"] = "MANAGEMENT_DELETE_FISCALDATA";
    PermissionsEnum["MANAGEMENT_DELETE_INSURANCECARRIER"] = "MANAGEMENT_DELETE_INSURANCECARRIER";
    PermissionsEnum["MANAGEMENT_DELETE_INVOICE"] = "MANAGEMENT_DELETE_INVOICE";
    PermissionsEnum["MANAGEMENT_DELETE_INVOICELINE"] = "MANAGEMENT_DELETE_INVOICELINE";
    PermissionsEnum["MANAGEMENT_DELETE_INVOICELINETAX"] = "MANAGEMENT_DELETE_INVOICELINETAX";
    PermissionsEnum["MANAGEMENT_DELETE_INVOICEUSAGE"] = "MANAGEMENT_DELETE_INVOICEUSAGE";
    PermissionsEnum["MANAGEMENT_DELETE_MEASUREMENTUNIT"] = "MANAGEMENT_DELETE_MEASUREMENTUNIT";
    PermissionsEnum["MANAGEMENT_DELETE_MGMTSTUDY"] = "MANAGEMENT_DELETE_MGMTSTUDY";
    PermissionsEnum["MANAGEMENT_DELETE_ORDER"] = "MANAGEMENT_DELETE_ORDER";
    PermissionsEnum["MANAGEMENT_DELETE_ORDERCANCELREASON"] = "MANAGEMENT_DELETE_ORDERCANCELREASON";
    PermissionsEnum["MANAGEMENT_DELETE_ORDERFILE"] = "MANAGEMENT_DELETE_ORDERFILE";
    PermissionsEnum["MANAGEMENT_DELETE_ORDERSTUDYFILE"] = "MANAGEMENT_DELETE_ORDERSTUDYFILE";
    PermissionsEnum["MANAGEMENT_DELETE_ORDERTZ"] = "MANAGEMENT_DELETE_ORDERTZ";
    PermissionsEnum["MANAGEMENT_DELETE_ORGANIZATIONTEMPLATE"] = "MANAGEMENT_DELETE_ORGANIZATIONTEMPLATE";
    PermissionsEnum["MANAGEMENT_DELETE_PATIENTDATA"] = "MANAGEMENT_DELETE_PATIENTDATA";
    PermissionsEnum["MANAGEMENT_DELETE_PAYMENT"] = "MANAGEMENT_DELETE_PAYMENT";
    PermissionsEnum["MANAGEMENT_DELETE_PAYMENTORDER"] = "MANAGEMENT_DELETE_PAYMENTORDER";
    PermissionsEnum["MANAGEMENT_DELETE_PAYMENTORDERSTUDYORDER"] = "MANAGEMENT_DELETE_PAYMENTORDERSTUDYORDER";
    PermissionsEnum["MANAGEMENT_DELETE_PAYMENTTYPE"] = "MANAGEMENT_DELETE_PAYMENTTYPE";
    PermissionsEnum["MANAGEMENT_DELETE_PHYSICIAN"] = "MANAGEMENT_DELETE_PHYSICIAN";
    PermissionsEnum["MANAGEMENT_DELETE_PRODUCTCODE"] = "MANAGEMENT_DELETE_PRODUCTCODE";
    PermissionsEnum["MANAGEMENT_DELETE_QUOTE"] = "MANAGEMENT_DELETE_QUOTE";
    PermissionsEnum["MANAGEMENT_DELETE_QUOTEDISCOUNT"] = "MANAGEMENT_DELETE_QUOTEDISCOUNT";
    PermissionsEnum["MANAGEMENT_DELETE_QUOTEITEM"] = "MANAGEMENT_DELETE_QUOTEITEM";
    PermissionsEnum["MANAGEMENT_DELETE_QUOTEITEMDISCOUNT"] = "MANAGEMENT_DELETE_QUOTEITEMDISCOUNT";
    PermissionsEnum["MANAGEMENT_DELETE_RISMESSAGE"] = "MANAGEMENT_DELETE_RISMESSAGE";
    PermissionsEnum["MANAGEMENT_DELETE_ROOM"] = "MANAGEMENT_DELETE_ROOM";
    PermissionsEnum["MANAGEMENT_DELETE_ROOMDAILYSCHEDULE"] = "MANAGEMENT_DELETE_ROOMDAILYSCHEDULE";
    PermissionsEnum["MANAGEMENT_DELETE_SALECHANNEL"] = "MANAGEMENT_DELETE_SALECHANNEL";
    PermissionsEnum["MANAGEMENT_DELETE_SETUPMANAGEMENTPROXY"] = "MANAGEMENT_DELETE_SETUPMANAGEMENTPROXY";
    PermissionsEnum["MANAGEMENT_DELETE_STATE"] = "MANAGEMENT_DELETE_STATE";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYBODYPART"] = "MANAGEMENT_DELETE_STUDYBODYPART";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYCONSUMABLE"] = "MANAGEMENT_DELETE_STUDYCONSUMABLE";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYCOUPON"] = "MANAGEMENT_DELETE_STUDYCOUPON";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYDISCOUNT"] = "MANAGEMENT_DELETE_STUDYDISCOUNT";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYLOADCSV"] = "MANAGEMENT_DELETE_STUDYLOADCSV";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYROOM"] = "MANAGEMENT_DELETE_STUDYROOM";
    PermissionsEnum["MANAGEMENT_DELETE_STUDYTAX"] = "MANAGEMENT_DELETE_STUDYTAX";
    PermissionsEnum["MANAGEMENT_DELETE_TAX"] = "MANAGEMENT_DELETE_TAX";
    PermissionsEnum["MANAGEMENT_DELETE_TAXREGIME"] = "MANAGEMENT_DELETE_TAXREGIME";
    PermissionsEnum["MANAGEMENT_VIEW_ADDRESS"] = "MANAGEMENT_VIEW_ADDRESS";
    PermissionsEnum["MANAGEMENT_VIEW_APPOINTMENT"] = "MANAGEMENT_VIEW_APPOINTMENT";
    PermissionsEnum["MANAGEMENT_VIEW_CFDIDATA"] = "MANAGEMENT_VIEW_CFDIDATA";
    PermissionsEnum["MANAGEMENT_VIEW_CITY"] = "MANAGEMENT_VIEW_CITY";
    PermissionsEnum["MANAGEMENT_VIEW_COMPANY"] = "MANAGEMENT_VIEW_COMPANY";
    PermissionsEnum["MANAGEMENT_VIEW_CONSUMABLE"] = "MANAGEMENT_VIEW_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_VIEW_CONTACT"] = "MANAGEMENT_VIEW_CONTACT";
    PermissionsEnum["MANAGEMENT_VIEW_DISCOUNT"] = "MANAGEMENT_VIEW_DISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_FACILITYADDRESS"] = "MANAGEMENT_VIEW_FACILITYADDRESS";
    PermissionsEnum["MANAGEMENT_VIEW_FACILITYTEMPLATE"] = "MANAGEMENT_VIEW_FACILITYTEMPLATE";
    PermissionsEnum["MANAGEMENT_VIEW_FISCALDATA"] = "MANAGEMENT_VIEW_FISCALDATA";
    PermissionsEnum["MANAGEMENT_VIEW_INSURANCECARRIER"] = "MANAGEMENT_VIEW_INSURANCECARRIER";
    PermissionsEnum["MANAGEMENT_VIEW_INVOICE"] = "MANAGEMENT_VIEW_INVOICE";
    PermissionsEnum["MANAGEMENT_VIEW_INVOICELINE"] = "MANAGEMENT_VIEW_INVOICELINE";
    PermissionsEnum["MANAGEMENT_VIEW_INVOICELINETAX"] = "MANAGEMENT_VIEW_INVOICELINETAX";
    PermissionsEnum["MANAGEMENT_VIEW_INVOICEUSAGE"] = "MANAGEMENT_VIEW_INVOICEUSAGE";
    PermissionsEnum["MANAGEMENT_VIEW_MEASUREMENTUNIT"] = "MANAGEMENT_VIEW_MEASUREMENTUNIT";
    PermissionsEnum["MANAGEMENT_VIEW_MGMTSTUDY"] = "MANAGEMENT_VIEW_MGMTSTUDY";
    PermissionsEnum["MANAGEMENT_VIEW_ORDER"] = "MANAGEMENT_VIEW_ORDER";
    PermissionsEnum["MANAGEMENT_VIEW_ORDERCANCELREASON"] = "MANAGEMENT_VIEW_ORDERCANCELREASON";
    PermissionsEnum["MANAGEMENT_VIEW_ORDERFILE"] = "MANAGEMENT_VIEW_ORDERFILE";
    PermissionsEnum["MANAGEMENT_VIEW_ORDERSTUDYFILE"] = "MANAGEMENT_VIEW_ORDERSTUDYFILE";
    PermissionsEnum["MANAGEMENT_VIEW_ORDERTZ"] = "MANAGEMENT_VIEW_ORDERTZ";
    PermissionsEnum["MANAGEMENT_VIEW_ORGANIZATIONTEMPLATE"] = "MANAGEMENT_VIEW_ORGANIZATIONTEMPLATE";
    PermissionsEnum["MANAGEMENT_VIEW_PATIENTDATA"] = "MANAGEMENT_VIEW_PATIENTDATA";
    PermissionsEnum["MANAGEMENT_VIEW_PAYMENT"] = "MANAGEMENT_VIEW_PAYMENT";
    PermissionsEnum["MANAGEMENT_VIEW_PAYMENTORDER"] = "MANAGEMENT_VIEW_PAYMENTORDER";
    PermissionsEnum["MANAGEMENT_VIEW_PAYMENTORDERSTUDYORDER"] = "MANAGEMENT_VIEW_PAYMENTORDERSTUDYORDER";
    PermissionsEnum["MANAGEMENT_VIEW_PAYMENTTYPE"] = "MANAGEMENT_VIEW_PAYMENTTYPE";
    PermissionsEnum["MANAGEMENT_VIEW_PHYSICIAN"] = "MANAGEMENT_VIEW_PHYSICIAN";
    PermissionsEnum["MANAGEMENT_VIEW_PRODUCTCODE"] = "MANAGEMENT_VIEW_PRODUCTCODE";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTE"] = "MANAGEMENT_VIEW_QUOTE";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTEDISCOUNT"] = "MANAGEMENT_VIEW_QUOTEDISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTEITEM"] = "MANAGEMENT_VIEW_QUOTEITEM";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTEITEMDISCOUNT"] = "MANAGEMENT_VIEW_QUOTEITEMDISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTE_GLOBAL_DISCOUNTS"] = "MANAGEMENT_VIEW_QUOTE_GLOBAL_DISCOUNTS";
    PermissionsEnum["MANAGEMENT_VIEW_QUOTE_ITEMS"] = "MANAGEMENT_VIEW_QUOTE_ITEMS";
    PermissionsEnum["MANAGEMENT_VIEW_RISMESSAGE"] = "MANAGEMENT_VIEW_RISMESSAGE";
    PermissionsEnum["MANAGEMENT_VIEW_ROOM"] = "MANAGEMENT_VIEW_ROOM";
    PermissionsEnum["MANAGEMENT_VIEW_ROOMDAILYSCHEDULE"] = "MANAGEMENT_VIEW_ROOMDAILYSCHEDULE";
    PermissionsEnum["MANAGEMENT_VIEW_SALECHANNEL"] = "MANAGEMENT_VIEW_SALECHANNEL";
    PermissionsEnum["MANAGEMENT_VIEW_SETUPMANAGEMENTPROXY"] = "MANAGEMENT_VIEW_SETUPMANAGEMENTPROXY";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_ADDRESS"] = "MANAGEMENT_VIEW_SINGLE_ADDRESS";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_APPOINTMENT"] = "MANAGEMENT_VIEW_SINGLE_APPOINTMENT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_CFDI_DATA"] = "MANAGEMENT_VIEW_SINGLE_CFDI_DATA";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_CITY"] = "MANAGEMENT_VIEW_SINGLE_CITY";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_COMPANY"] = "MANAGEMENT_VIEW_SINGLE_COMPANY";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_CONSUMABLE"] = "MANAGEMENT_VIEW_SINGLE_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_CONTACT"] = "MANAGEMENT_VIEW_SINGLE_CONTACT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_DISCOUNT"] = "MANAGEMENT_VIEW_SINGLE_DISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_FACILITY_ADDRESS"] = "MANAGEMENT_VIEW_SINGLE_FACILITY_ADDRESS";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_FACILITY_TEMPLATE"] = "MANAGEMENT_VIEW_SINGLE_FACILITY_TEMPLATE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_FISCAL_DATA"] = "MANAGEMENT_VIEW_SINGLE_FISCAL_DATA";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_INSURANCE_CARRIER"] = "MANAGEMENT_VIEW_SINGLE_INSURANCE_CARRIER";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_INVOICE"] = "MANAGEMENT_VIEW_SINGLE_INVOICE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_INVOICE_LINE"] = "MANAGEMENT_VIEW_SINGLE_INVOICE_LINE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_INVOICE_LINE_TAX"] = "MANAGEMENT_VIEW_SINGLE_INVOICE_LINE_TAX";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_INVOICE_USAGE"] = "MANAGEMENT_VIEW_SINGLE_INVOICE_USAGE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_MEASUREMENT_UNIT"] = "MANAGEMENT_VIEW_SINGLE_MEASUREMENT_UNIT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_ORDER"] = "MANAGEMENT_VIEW_SINGLE_ORDER";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_ORGANIZATION_TEMPLATE"] = "MANAGEMENT_VIEW_SINGLE_ORGANIZATION_TEMPLATE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PATIENT_DATA"] = "MANAGEMENT_VIEW_SINGLE_PATIENT_DATA";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PAYMENT"] = "MANAGEMENT_VIEW_SINGLE_PAYMENT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PAYMENT_ORDER"] = "MANAGEMENT_VIEW_SINGLE_PAYMENT_ORDER";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PAYMENT_ORDER_STUDY_ORDER"] = "MANAGEMENT_VIEW_SINGLE_PAYMENT_ORDER_STUDY_ORDER";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PAYMENT_TYPE"] = "MANAGEMENT_VIEW_SINGLE_PAYMENT_TYPE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PHYSICIAN"] = "MANAGEMENT_VIEW_SINGLE_PHYSICIAN";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_PRODUCT_CODE"] = "MANAGEMENT_VIEW_SINGLE_PRODUCT_CODE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_QUOTE"] = "MANAGEMENT_VIEW_SINGLE_QUOTE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_QUOTE_GLOBAL_DISCOUNT"] = "MANAGEMENT_VIEW_SINGLE_QUOTE_GLOBAL_DISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_QUOTE_ITEM"] = "MANAGEMENT_VIEW_SINGLE_QUOTE_ITEM";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_QUOTE_ITEM_DISCOUNT"] = "MANAGEMENT_VIEW_SINGLE_QUOTE_ITEM_DISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_ROOM"] = "MANAGEMENT_VIEW_SINGLE_ROOM";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_ROOM_SCHEDULE"] = "MANAGEMENT_VIEW_SINGLE_ROOM_SCHEDULE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_SALE_CHANNEL"] = "MANAGEMENT_VIEW_SINGLE_SALE_CHANNEL";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STATE"] = "MANAGEMENT_VIEW_SINGLE_STATE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY"] = "MANAGEMENT_VIEW_SINGLE_STUDY";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_BODY_PARTY"] = "MANAGEMENT_VIEW_SINGLE_STUDY_BODY_PARTY";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_CONSUMABLE"] = "MANAGEMENT_VIEW_SINGLE_STUDY_CONSUMABLE";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_COUPON"] = "MANAGEMENT_VIEW_SINGLE_STUDY_COUPON";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_DISCOUNT"] = "MANAGEMENT_VIEW_SINGLE_STUDY_DISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_ROOM"] = "MANAGEMENT_VIEW_SINGLE_STUDY_ROOM";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_STUDY_TAX"] = "MANAGEMENT_VIEW_SINGLE_STUDY_TAX";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_TAX"] = "MANAGEMENT_VIEW_SINGLE_TAX";
    PermissionsEnum["MANAGEMENT_VIEW_SINGLE_TAX_REGIME"] = "MANAGEMENT_VIEW_SINGLE_TAX_REGIME";
    PermissionsEnum["MANAGEMENT_VIEW_STATE"] = "MANAGEMENT_VIEW_STATE";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYBODYPART"] = "MANAGEMENT_VIEW_STUDYBODYPART";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYCONSUMABLE"] = "MANAGEMENT_VIEW_STUDYCONSUMABLE";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYCOUPON"] = "MANAGEMENT_VIEW_STUDYCOUPON";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYDISCOUNT"] = "MANAGEMENT_VIEW_STUDYDISCOUNT";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYLOADCSV"] = "MANAGEMENT_VIEW_STUDYLOADCSV";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYROOM"] = "MANAGEMENT_VIEW_STUDYROOM";
    PermissionsEnum["MANAGEMENT_VIEW_STUDYTAX"] = "MANAGEMENT_VIEW_STUDYTAX";
    PermissionsEnum["MANAGEMENT_VIEW_TAX"] = "MANAGEMENT_VIEW_TAX";
    PermissionsEnum["MANAGEMENT_VIEW_TAXREGIME"] = "MANAGEMENT_VIEW_TAXREGIME";
})(PermissionsEnum || (PermissionsEnum = {}));
/** An enumeration. */
export var PractitionerGender;
(function (PractitionerGender) {
    /** Male */
    PractitionerGender["MALE"] = "MALE";
    /** Female */
    PractitionerGender["FEMALE"] = "FEMALE";
    /** Other */
    PractitionerGender["OTHER"] = "OTHER";
})(PractitionerGender || (PractitionerGender = {}));
/** An enumeration. */
export var PractitionerStatus;
(function (PractitionerStatus) {
    /** Active */
    PractitionerStatus["ACTIVE"] = "ACTIVE";
    /** Pending */
    PractitionerStatus["PENDING"] = "PENDING";
    /** Suspended */
    PractitionerStatus["SUSPENDED"] = "SUSPENDED";
})(PractitionerStatus || (PractitionerStatus = {}));
/** An enumeration. */
export var QuoteStatus;
(function (QuoteStatus) {
    /** Draft */
    QuoteStatus["DRAFT"] = "DRAFT";
    /** New */
    QuoteStatus["NEW"] = "NEW";
    /** Sent */
    QuoteStatus["SENT"] = "SENT";
    /** Order */
    QuoteStatus["ORDER"] = "ORDER";
})(QuoteStatus || (QuoteStatus = {}));
/** An enumeration. */
export var ReportBirads;
(function (ReportBirads) {
    /** Birads 0 */
    ReportBirads["BIRADS_0"] = "BIRADS_0";
    /** Birads 1 */
    ReportBirads["BIRADS_1"] = "BIRADS_1";
    /** Birads 2 */
    ReportBirads["BIRADS_2"] = "BIRADS_2";
    /** Birads 3 */
    ReportBirads["BIRADS_3"] = "BIRADS_3";
    /** Birads 4 */
    ReportBirads["BIRADS_4"] = "BIRADS_4";
    /** Birads 4A */
    ReportBirads["BIRADS_4A"] = "BIRADS_4A";
    /** Birads 4B */
    ReportBirads["BIRADS_4B"] = "BIRADS_4B";
    /** Birads 4C */
    ReportBirads["BIRADS_4C"] = "BIRADS_4C";
    /** Birads 5 */
    ReportBirads["BIRADS_5"] = "BIRADS_5";
    /** Birads 6 */
    ReportBirads["BIRADS_6"] = "BIRADS_6";
    /** Technically Inadequate Mammagraphy */
    ReportBirads["INADEQUATE"] = "INADEQUATE";
    /** Pirads 1 */
    ReportBirads["PIRADS_1"] = "PIRADS_1";
    /** Pirads 2 */
    ReportBirads["PIRADS_2"] = "PIRADS_2";
    /** Pirads 3 */
    ReportBirads["PIRADS_3"] = "PIRADS_3";
    /** Pirads 4 */
    ReportBirads["PIRADS_4"] = "PIRADS_4";
    /** Pirads 5 */
    ReportBirads["PIRADS_5"] = "PIRADS_5";
})(ReportBirads || (ReportBirads = {}));
/** An enumeration. */
export var ReportMessageStatus;
(function (ReportMessageStatus) {
    /** New */
    ReportMessageStatus["NEW"] = "NEW";
    /** Sent */
    ReportMessageStatus["SENT"] = "SENT";
    /** Failed */
    ReportMessageStatus["FAILED"] = "FAILED";
    /** Done */
    ReportMessageStatus["DONE"] = "DONE";
})(ReportMessageStatus || (ReportMessageStatus = {}));
/** An enumeration. */
export var ReportStatus;
(function (ReportStatus) {
    /** Draft */
    ReportStatus["DRAFT"] = "DRAFT";
    /** Signed */
    ReportStatus["SIGNED"] = "SIGNED";
    /** In Review */
    ReportStatus["IN_REVIEW"] = "IN_REVIEW";
})(ReportStatus || (ReportStatus = {}));
/** An enumeration. */
export var RisMessageStatus;
(function (RisMessageStatus) {
    /** New */
    RisMessageStatus["NEW"] = "NEW";
    /** Sent */
    RisMessageStatus["SENT"] = "SENT";
    /** Failed */
    RisMessageStatus["FAILED"] = "FAILED";
    /** Done */
    RisMessageStatus["DONE"] = "DONE";
})(RisMessageStatus || (RisMessageStatus = {}));
/** An enumeration. */
export var SeriesEcgStatus;
(function (SeriesEcgStatus) {
    /** In progress */
    SeriesEcgStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    SeriesEcgStatus["COMPLETED"] = "COMPLETED";
    /** Failed */
    SeriesEcgStatus["FAILED"] = "FAILED";
})(SeriesEcgStatus || (SeriesEcgStatus = {}));
/** An enumeration. */
export var SeriesPreviewStatus;
(function (SeriesPreviewStatus) {
    /** Pending */
    SeriesPreviewStatus["PENDING"] = "PENDING";
    /** Processing */
    SeriesPreviewStatus["PROCESSING"] = "PROCESSING";
    /** Generated */
    SeriesPreviewStatus["GENERATED"] = "GENERATED";
})(SeriesPreviewStatus || (SeriesPreviewStatus = {}));
/** An enumeration. */
export var StudyFileRecordType;
(function (StudyFileRecordType) {
    /** Regular */
    StudyFileRecordType["REGULAR"] = "REGULAR";
    /** Image Bookmark */
    StudyFileRecordType["IMAGE_BOOKMARK"] = "IMAGE_BOOKMARK";
})(StudyFileRecordType || (StudyFileRecordType = {}));
/** An enumeration. */
export var StudyFileStatus;
(function (StudyFileStatus) {
    /** Pending */
    StudyFileStatus["PENDING"] = "PENDING";
    /** In Progress */
    StudyFileStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Sent */
    StudyFileStatus["SENT"] = "SENT";
    /** Failed */
    StudyFileStatus["FAILED"] = "FAILED";
})(StudyFileStatus || (StudyFileStatus = {}));
/** An enumeration. */
export var StudyPdfFileQuality;
(function (StudyPdfFileQuality) {
    /** High */
    StudyPdfFileQuality["HIGH"] = "HIGH";
    /** Medium */
    StudyPdfFileQuality["MEDIUM"] = "MEDIUM";
    /** Low */
    StudyPdfFileQuality["LOW"] = "LOW";
})(StudyPdfFileQuality || (StudyPdfFileQuality = {}));
/** An enumeration. */
export var StudyPdfFileSize;
(function (StudyPdfFileSize) {
    /** A4 */
    StudyPdfFileSize["A4"] = "A4";
})(StudyPdfFileSize || (StudyPdfFileSize = {}));
/** An enumeration. */
export var StudyPdfFileStatus;
(function (StudyPdfFileStatus) {
    /** In progress */
    StudyPdfFileStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Completed */
    StudyPdfFileStatus["COMPLETED"] = "COMPLETED";
    /** Has updates */
    StudyPdfFileStatus["HAS_UPDATES"] = "HAS_UPDATES";
    /** Has a logical Error */
    StudyPdfFileStatus["ERROR"] = "ERROR";
})(StudyPdfFileStatus || (StudyPdfFileStatus = {}));
/** An enumeration. */
export var StudyStatus;
(function (StudyStatus) {
    /** Uploading */
    StudyStatus["UPLOADING"] = "UPLOADING";
    /** Reading Pending */
    StudyStatus["READING_PENDING"] = "READING_PENDING";
    /** Reading */
    StudyStatus["READING"] = "READING";
    /** Report Signed */
    StudyStatus["SIGNED"] = "SIGNED";
    /** Review Pending */
    StudyStatus["REVIEW_PENDING"] = "REVIEW_PENDING";
    /** Delivered */
    StudyStatus["DELIVERED"] = "DELIVERED";
    /** Images Sent */
    StudyStatus["IMAGES_SENT"] = "IMAGES_SENT";
    /** In Addendum */
    StudyStatus["IN_ADDENDUM"] = "IN_ADDENDUM";
    /** Addendum Signed */
    StudyStatus["ADDENDUM_SIGNED"] = "ADDENDUM_SIGNED";
})(StudyStatus || (StudyStatus = {}));
/** An enumeration. */
export var StudyUrgencyLevel;
(function (StudyUrgencyLevel) {
    /** Urgent */
    StudyUrgencyLevel["URGENT"] = "URGENT";
    /** Priority */
    StudyUrgencyLevel["PRIORITY"] = "PRIORITY";
    /** Normal */
    StudyUrgencyLevel["NORMAL"] = "NORMAL";
})(StudyUrgencyLevel || (StudyUrgencyLevel = {}));
/** An enumeration. */
export var TaxTaxType;
(function (TaxTaxType) {
    /** Percentage */
    TaxTaxType["PERCENTAGE"] = "PERCENTAGE";
    /** Fixed */
    TaxTaxType["FIXED"] = "FIXED";
    /** Exempt */
    TaxTaxType["EXEMPT"] = "EXEMPT";
})(TaxTaxType || (TaxTaxType = {}));
/** An enumeration. */
export var TemplateFieldFieldType;
(function (TemplateFieldFieldType) {
    /** Boolean */
    TemplateFieldFieldType["BOOLEAN"] = "BOOLEAN";
    /** Choice */
    TemplateFieldFieldType["CHOICE"] = "CHOICE";
    /** File */
    TemplateFieldFieldType["FILE"] = "FILE";
    /** Integer */
    TemplateFieldFieldType["INTEGER"] = "INTEGER";
    /** Long Text */
    TemplateFieldFieldType["LONG_TEXT"] = "LONG_TEXT";
    /** Long Text Version 2 */
    TemplateFieldFieldType["LONG_TEXT_V2"] = "LONG_TEXT_V2";
    /** Multiple Choice */
    TemplateFieldFieldType["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    /** Multiple Text */
    TemplateFieldFieldType["MULTIPLE_TEXT"] = "MULTIPLE_TEXT";
    /** Other */
    TemplateFieldFieldType["OTHER"] = "OTHER";
    /** Select */
    TemplateFieldFieldType["SELECT"] = "SELECT";
    /** Short Text */
    TemplateFieldFieldType["SHORT_TEXT"] = "SHORT_TEXT";
})(TemplateFieldFieldType || (TemplateFieldFieldType = {}));
/** An enumeration. */
export var UserPreferenceFamily;
(function (UserPreferenceFamily) {
    /** FILTER */
    UserPreferenceFamily["FILTER"] = "FILTER";
    /** SHORTCUTS */
    UserPreferenceFamily["SHORTCUTS"] = "SHORTCUTS";
    /** SCREENS */
    UserPreferenceFamily["SCREENS"] = "SCREENS";
    /** FILTER_ORDERS */
    UserPreferenceFamily["FILTER_ORDERS"] = "FILTER_ORDERS";
    /** FILTER APPOINTMENTS */
    UserPreferenceFamily["FILTER_APPOINTMENTS"] = "FILTER_APPOINTMENTS";
    /** STUDY_LIST */
    UserPreferenceFamily["STUDY_LIST"] = "STUDY_LIST";
})(UserPreferenceFamily || (UserPreferenceFamily = {}));
/** An enumeration. */
export var UserRowPermissionModel;
(function (UserRowPermissionModel) {
    /** MODALITY */
    UserRowPermissionModel["MODALITY"] = "MODALITY";
    /** FACILITY */
    UserRowPermissionModel["FACILITY"] = "FACILITY";
    /** PRACTITIONER_ASSIGNED */
    UserRowPermissionModel["PRACTITIONER_ASSIGNED"] = "PRACTITIONER_ASSIGNED";
    /** FACILITY_EQUITY_ASSIGNATION */
    UserRowPermissionModel["FACILITY_EQUITY_ASSIGNATION"] = "FACILITY_EQUITY_ASSIGNATION";
})(UserRowPermissionModel || (UserRowPermissionModel = {}));
export var OrganizationFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Organization on OrganizationType {\n    id\n    name\n    createdAt\n  }\n"], ["\n  fragment Organization on OrganizationType {\n    id\n    name\n    createdAt\n  }\n"])));
export var ReportFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment Report on ReportType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    pdfFile\n    pdfUrl\n    template {\n      id\n    }\n    reportFields {\n      id\n      templateField {\n        id\n      }\n    }\n    pdfUrl\n  }\n"], ["\n  fragment Report on ReportType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    pdfFile\n    pdfUrl\n    template {\n      id\n    }\n    reportFields {\n      id\n      templateField {\n        id\n      }\n    }\n    pdfUrl\n  }\n"])));
export var DicomFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment Dicom on StudyType {\n    dicomDateTime\n    dicomDateTimeEditable\n    dicomDescription\n    dicomProcedure\n    dicomReason\n    dicomStatus\n    dicomStudyId\n    dicomReferringPhysician\n    dicomRequestingPhysician\n    dicomConsultingPhysician\n    dicomReadingPhysician\n  }\n"], ["\n  fragment Dicom on StudyType {\n    dicomDateTime\n    dicomDateTimeEditable\n    dicomDescription\n    dicomProcedure\n    dicomReason\n    dicomStatus\n    dicomStudyId\n    dicomReferringPhysician\n    dicomRequestingPhysician\n    dicomConsultingPhysician\n    dicomReadingPhysician\n  }\n"])));
export var PractitionerFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fragment Practitioner on PractitionerType {\n    id\n    phone\n    phoneCode\n    roles\n    gender\n    multilineSpecialty\n    fullName\n    user {\n      id\n    }\n    deleted\n    createdAt\n    updatedAt\n  }\n"], ["\n  fragment Practitioner on PractitionerType {\n    id\n    phone\n    phoneCode\n    roles\n    gender\n    multilineSpecialty\n    fullName\n    user {\n      id\n    }\n    deleted\n    createdAt\n    updatedAt\n  }\n"])));
export var FacilityFragmentDoc = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  fragment Facility on FacilityType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    address\n    phone\n  }\n"], ["\n  fragment Facility on FacilityType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    address\n    phone\n  }\n"])));
export var PatientFragmentDoc = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  fragment Patient on PatientType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    identifier\n    identifierEditable\n    name\n    firstSurname\n    lastSurname\n    fullName\n    age\n    gender\n    birthDate\n    nationalId\n    phoneNumber\n    phoneCode\n    phoneCountry {\n      id\n      isoCode\n    }\n    email\n    weight\n  }\n"], ["\n  fragment Patient on PatientType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    identifier\n    identifierEditable\n    name\n    firstSurname\n    lastSurname\n    fullName\n    age\n    gender\n    birthDate\n    nationalId\n    phoneNumber\n    phoneCode\n    phoneCountry {\n      id\n      isoCode\n    }\n    email\n    weight\n  }\n"])));
export var ModalityFragmentDoc = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  fragment Modality on ModalityType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    description\n    identifier\n  }\n"], ["\n  fragment Modality on ModalityType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    description\n    identifier\n  }\n"])));
export var BodyPartFragmentDoc = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  fragment BodyPart on BodyPartType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    description\n    identifier\n  }\n"], ["\n  fragment BodyPart on BodyPartType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    description\n    identifier\n  }\n"])));
export var InstanceFileFragmentDoc = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  fragment InstanceFile on InstanceFileType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    type\n    file\n    image\n    fileUrl\n    imageUrl\n  }\n"], ["\n  fragment InstanceFile on InstanceFileType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    type\n    file\n    image\n    fileUrl\n    imageUrl\n  }\n"])));
export var MeasurementFragmentDoc = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  fragment Measurement on MeasurementType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    tool\n    cornerstoneId\n    label\n    description\n    instance {\n      id\n    }\n    data\n    series {\n      id\n    }\n  }\n"], ["\n  fragment Measurement on MeasurementType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    tool\n    cornerstoneId\n    label\n    description\n    instance {\n      id\n    }\n    data\n    series {\n      id\n    }\n  }\n"])));
export var InstanceFragmentDoc = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  fragment Instance on InstanceType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    dicomInstanceId\n    dicomNumber\n    dicomNumberOfFrames\n    dicomDateTime\n    dicomAcquisitionNumber\n    dicomAcquisitionDateTime\n    dicomTimeZone\n    dicomSopClass\n    dicomSopStatus\n    isPreview\n    isMultiFrame\n    files {\n      ...InstanceFile\n    }\n    measurements {\n      ...Measurement\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment Instance on InstanceType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    name\n    dicomInstanceId\n    dicomNumber\n    dicomNumberOfFrames\n    dicomDateTime\n    dicomAcquisitionNumber\n    dicomAcquisitionDateTime\n    dicomTimeZone\n    dicomSopClass\n    dicomSopStatus\n    isPreview\n    isMultiFrame\n    files {\n      ...InstanceFile\n    }\n    measurements {\n      ...Measurement\n    }\n  }\n  ", "\n  ", "\n"])), InstanceFileFragmentDoc, MeasurementFragmentDoc);
export var SeriesFragmentDoc = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  fragment Series on SeriesType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    modality {\n      ...Modality\n    }\n    bodyPart {\n      ...BodyPart\n    }\n    dicomDateTime\n    dicomDescription\n    dicomPerformingPhysician\n    dicomPerformingPhysicianInstitution\n    dicomOperatorsName\n    dicomPatientPosition\n    dicomNumber\n    dicomLaterality\n    dicomSeriesId\n    instances {\n      ...Instance\n    }\n    measurements {\n      ...Measurement\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment Series on SeriesType {\n    id\n    deleted\n    createdAt\n    updatedAt\n    modality {\n      ...Modality\n    }\n    bodyPart {\n      ...BodyPart\n    }\n    dicomDateTime\n    dicomDescription\n    dicomPerformingPhysician\n    dicomPerformingPhysicianInstitution\n    dicomOperatorsName\n    dicomPatientPosition\n    dicomNumber\n    dicomLaterality\n    dicomSeriesId\n    instances {\n      ...Instance\n    }\n    measurements {\n      ...Measurement\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), ModalityFragmentDoc, BodyPartFragmentDoc, InstanceFragmentDoc, MeasurementFragmentDoc);
export var StudyFragmentDoc = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  fragment Study on StudyType {\n    id\n    ...Dicom\n    practitioner {\n      ...Practitioner\n      roles\n    }\n    practitionerAssigned {\n      ...Practitioner\n    }\n    facility {\n      ...Facility\n    }\n    folio\n    urgencyLevel\n    patient {\n      ...Patient\n    }\n    status\n    studyType {\n      id\n      identifier\n      name\n    }\n    studyTypeEditable\n    deleted\n    createdAt\n    updatedAt\n    series {\n      ...Series\n    }\n    measurements {\n      ...Measurement\n    }\n    createdAt\n    notes {\n      id\n      content\n      createdAt\n      practitioner {\n        ...Practitioner\n      }\n      updatedAt\n    }\n    files {\n      id\n      name\n      fileUrl\n    }\n    reports {\n      id\n      status\n      pdfFile\n      pdfUrl\n      template {\n        id\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment Study on StudyType {\n    id\n    ...Dicom\n    practitioner {\n      ...Practitioner\n      roles\n    }\n    practitionerAssigned {\n      ...Practitioner\n    }\n    facility {\n      ...Facility\n    }\n    folio\n    urgencyLevel\n    patient {\n      ...Patient\n    }\n    status\n    studyType {\n      id\n      identifier\n      name\n    }\n    studyTypeEditable\n    deleted\n    createdAt\n    updatedAt\n    series {\n      ...Series\n    }\n    measurements {\n      ...Measurement\n    }\n    createdAt\n    notes {\n      id\n      content\n      createdAt\n      practitioner {\n        ...Practitioner\n      }\n      updatedAt\n    }\n    files {\n      id\n      name\n      fileUrl\n    }\n    reports {\n      id\n      status\n      pdfFile\n      pdfUrl\n      template {\n        id\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), DicomFragmentDoc, PractitionerFragmentDoc, FacilityFragmentDoc, PatientFragmentDoc, SeriesFragmentDoc, MeasurementFragmentDoc);
export var TemplateFieldFragmentFragmentDoc = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  fragment TemplateFieldFragment on TemplateFieldType {\n    id\n    name\n    fieldType\n    renderName\n    required\n    choiceOptions\n    defaultValue\n    sequence\n  }\n"], ["\n  fragment TemplateFieldFragment on TemplateFieldType {\n    id\n    name\n    fieldType\n    renderName\n    required\n    choiceOptions\n    defaultValue\n    sequence\n  }\n"])));
export var UserFragmentDoc = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  fragment User on UserNodeCustom {\n    id\n    email\n    isMo\n    data {\n      practitioner {\n        id\n        firstSurname\n        lastSurname\n        fullName\n        phone\n        phoneCode\n        gender\n        phoneCountry {\n          id\n          isoCode\n        }\n        facility {\n          id\n          name\n          country {\n            isoCode\n            phoneCode\n            name\n            id\n          }\n        }\n      }\n      organization {\n        id\n        name\n        hasPendingPayment\n        activeFlags {\n          id\n          identifier\n        }\n      }\n      productGroups {\n        id\n        isVisible\n        product {\n          id\n          name\n          slug\n          description\n        }\n        group {\n          id\n          name\n        }\n      }\n    }\n    visitant {\n      id\n    }\n  }\n"], ["\n  fragment User on UserNodeCustom {\n    id\n    email\n    isMo\n    data {\n      practitioner {\n        id\n        firstSurname\n        lastSurname\n        fullName\n        phone\n        phoneCode\n        gender\n        phoneCountry {\n          id\n          isoCode\n        }\n        facility {\n          id\n          name\n          country {\n            isoCode\n            phoneCode\n            name\n            id\n          }\n        }\n      }\n      organization {\n        id\n        name\n        hasPendingPayment\n        activeFlags {\n          id\n          identifier\n        }\n      }\n      productGroups {\n        id\n        isVisible\n        product {\n          id\n          name\n          slug\n          description\n        }\n        group {\n          id\n          name\n        }\n      }\n    }\n    visitant {\n      id\n    }\n  }\n"])));
export var VisitantFragmentDoc = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  fragment Visitant on UserNodeCustom {\n    id\n    firstSurname\n    fullName\n    email\n    visitant {\n      id\n      organization {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  fragment Visitant on UserNodeCustom {\n    id\n    firstSurname\n    fullName\n    email\n    visitant {\n      id\n      organization {\n        id\n        name\n      }\n    }\n  }\n"])));
export var StudyCriticalValueFragmentDoc = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  fragment StudyCriticalValue on StudyCriticalValueType {\n    id\n    observation\n    criticalValueName\n    criticalValue {\n      id\n      name\n    }\n  }\n"], ["\n  fragment StudyCriticalValue on StudyCriticalValueType {\n    id\n    observation\n    criticalValueName\n    criticalValue {\n      id\n      name\n    }\n  }\n"])));
export var WorklistStudyTableRowItemFragmentDoc = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  fragment WorklistStudyTableRowItem on StudyWorklistType {\n    id\n    dicomDateTime\n    dicomDescription\n    dicomReferringPhysician\n    dicomReason\n    dicomRequestingPhysician\n    dicomDateTimeEditable\n    status\n    urgencyLevel\n    createdAt\n    folio\n    studyTypeEditable\n    patientStudyAge\n    patientStudyAgeMonths\n    patientStudyAgeDays\n    facility {\n      id\n      name\n      timezone\n    }\n    reviewRequired\n    reviewerPractitioner {\n      id\n      fullName\n    }\n    practitionerAssigned {\n      id\n      fullName\n    }\n    referringPractitioner {\n      id\n      fullName\n    }\n    patient {\n      fullName\n      gender\n      birthDate\n      identifier\n      identifierEditable\n    }\n    modalities\n    criticalValues {\n      ...StudyCriticalValue\n    }\n  }\n  ", "\n"], ["\n  fragment WorklistStudyTableRowItem on StudyWorklistType {\n    id\n    dicomDateTime\n    dicomDescription\n    dicomReferringPhysician\n    dicomReason\n    dicomRequestingPhysician\n    dicomDateTimeEditable\n    status\n    urgencyLevel\n    createdAt\n    folio\n    studyTypeEditable\n    patientStudyAge\n    patientStudyAgeMonths\n    patientStudyAgeDays\n    facility {\n      id\n      name\n      timezone\n    }\n    reviewRequired\n    reviewerPractitioner {\n      id\n      fullName\n    }\n    practitionerAssigned {\n      id\n      fullName\n    }\n    referringPractitioner {\n      id\n      fullName\n    }\n    patient {\n      fullName\n      gender\n      birthDate\n      identifier\n      identifierEditable\n    }\n    modalities\n    criticalValues {\n      ...StudyCriticalValue\n    }\n  }\n  ", "\n"])), StudyCriticalValueFragmentDoc);
export var CreateMultipleUserRowPermissionDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  mutation createMultipleUserRowPermission($input: UserRowPermissionMultipleInputType!) {\n    createMultipleUserRowPermission(input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation createMultipleUserRowPermission($input: UserRowPermissionMultipleInputType!) {\n    createMultipleUserRowPermission(input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useCreateMultipleUserRowPermissionMutation__
 *
 * To run a mutation, you first call `useCreateMultipleUserRowPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultipleUserRowPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultipleUserRowPermissionMutation, { data, loading, error }] = useCreateMultipleUserRowPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMultipleUserRowPermissionMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateMultipleUserRowPermissionDocument, options);
}
export var SendPractitionerInviteDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  mutation sendPractitionerInvite($id: UUID!) {\n    sendPractitionerInvite(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation sendPractitionerInvite($id: UUID!) {\n    sendPractitionerInvite(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useSendPractitionerInviteMutation__
 *
 * To run a mutation, you first call `useSendPractitionerInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPractitionerInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPractitionerInviteMutation, { data, loading, error }] = useSendPractitionerInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendPractitionerInviteMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendPractitionerInviteDocument, options);
}
export var GetVisitantTokenAuthDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  mutation getVisitantTokenAuth($input: ObtainJSONWebTokenInput!) {\n    tokenAuth(input: $input) {\n      success\n      token\n      refreshToken\n      user {\n        ...Visitant\n      }\n      errors\n    }\n  }\n  ", "\n"], ["\n  mutation getVisitantTokenAuth($input: ObtainJSONWebTokenInput!) {\n    tokenAuth(input: $input) {\n      success\n      token\n      refreshToken\n      user {\n        ...Visitant\n      }\n      errors\n    }\n  }\n  ", "\n"])), VisitantFragmentDoc);
/**
 * __useGetVisitantTokenAuthMutation__
 *
 * To run a mutation, you first call `useGetVisitantTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetVisitantTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getVisitantTokenAuthMutation, { data, loading, error }] = useGetVisitantTokenAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVisitantTokenAuthMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(GetVisitantTokenAuthDocument, options);
}
export var PasswordResetDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  mutation passwordReset($input: PasswordResetInput!) {\n    passwordReset(input: $input) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation passwordReset($input: PasswordResetInput!) {\n    passwordReset(input: $input) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(PasswordResetDocument, options);
}
export var RefreshTokenDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  mutation refreshToken($input: RefreshTokenInput!) {\n    refreshToken(input: $input) {\n      payload\n      success\n      token\n      errors\n      refreshToken\n    }\n  }\n"], ["\n  mutation refreshToken($input: RefreshTokenInput!) {\n    refreshToken(input: $input) {\n      payload\n      success\n      token\n      errors\n      refreshToken\n    }\n  }\n"])));
/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RefreshTokenDocument, options);
}
export var RegisterDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  mutation register($input: RegisterInput!) {\n    register(input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation register($input: RegisterInput!) {\n    register(input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RegisterDocument, options);
}
export var RevokeTokenDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  mutation revokeToken($input: RevokeTokenInput!) {\n    revokeToken(input: $input) {\n      errors\n      success\n      revoked\n    }\n  }\n"], ["\n  mutation revokeToken($input: RevokeTokenInput!) {\n    revokeToken(input: $input) {\n      errors\n      success\n      revoked\n    }\n  }\n"])));
/**
 * __useRevokeTokenMutation__
 *
 * To run a mutation, you first call `useRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeTokenMutation, { data, loading, error }] = useRevokeTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeTokenMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RevokeTokenDocument, options);
}
export var SendPasswordResetEmailDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  mutation sendPasswordResetEmail($input: SendPasswordResetEmailInput!) {\n    sendPasswordResetEmail(input: $input) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation sendPasswordResetEmail($input: SendPasswordResetEmailInput!) {\n    sendPasswordResetEmail(input: $input) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendPasswordResetEmailDocument, options);
}
export var TokenAuthDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  mutation tokenAuth($input: ObtainJSONWebTokenInput!) {\n    tokenAuth(input: $input) {\n      success\n      token\n      refreshToken\n      user {\n        ...User\n      }\n      errors\n    }\n  }\n  ", "\n"], ["\n  mutation tokenAuth($input: ObtainJSONWebTokenInput!) {\n    tokenAuth(input: $input) {\n      success\n      token\n      refreshToken\n      user {\n        ...User\n      }\n      errors\n    }\n  }\n  ", "\n"])), UserFragmentDoc);
/**
 * __useTokenAuthMutation__
 *
 * To run a mutation, you first call `useTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenAuthMutation, { data, loading, error }] = useTokenAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTokenAuthMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(TokenAuthDocument, options);
}
export var VerifyAccountDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  mutation verifyAccount($input: VerifyAccountInput!) {\n    verifyAccount(input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation verifyAccount($input: VerifyAccountInput!) {\n    verifyAccount(input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useVerifyAccountMutation__
 *
 * To run a mutation, you first call `useVerifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAccountMutation, { data, loading, error }] = useVerifyAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAccountMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(VerifyAccountDocument, options);
}
export var VerifyTokenDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  mutation verifyToken($input: VerifyTokenInput!) {\n    verifyToken(input: $input) {\n      payload\n      success\n      errors\n    }\n  }\n"], ["\n  mutation verifyToken($input: VerifyTokenInput!) {\n    verifyToken(input: $input) {\n      payload\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useVerifyTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTokenMutation, { data, loading, error }] = useVerifyTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTokenMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(VerifyTokenDocument, options);
}
export var DeleteStudyFileDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  mutation deleteStudyFile($fileId: UUID!) {\n    deleteStudyFile(id: $fileId) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteStudyFile($fileId: UUID!) {\n    deleteStudyFile(id: $fileId) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteStudyFileMutation__
 *
 * To run a mutation, you first call `useDeleteStudyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudyFileMutation, { data, loading, error }] = useDeleteStudyFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteStudyFileMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteStudyFileDocument, options);
}
export var UpdateStudyFileDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  mutation updateStudyFile($fileId: UUID!, $input: StudyFileInputType!) {\n    updateStudyFile(id: $fileId, input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation updateStudyFile($fileId: UUID!, $input: StudyFileInputType!) {\n    updateStudyFile(id: $fileId, input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useUpdateStudyFileMutation__
 *
 * To run a mutation, you first call `useUpdateStudyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudyFileMutation, { data, loading, error }] = useUpdateStudyFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudyFileMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateStudyFileDocument, options);
}
export var CreateMeasurementDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  mutation createMeasurement($input: MeasurementInputType!) {\n    createMeasurement(input: $input) {\n      errors\n      success\n      measurement {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createMeasurement($input: MeasurementInputType!) {\n    createMeasurement(input: $input) {\n      errors\n      success\n      measurement {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateMeasurementMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementMutation, { data, loading, error }] = useCreateMeasurementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeasurementMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateMeasurementDocument, options);
}
export var CreateMeasurementByInstanceDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  mutation createMeasurementByInstance($id: UUID!, $input: MinimalMeasurementInputType!) {\n    createMeasurementByInstance(id: $id, input: $input) {\n      errors\n      success\n      measurement {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createMeasurementByInstance($id: UUID!, $input: MinimalMeasurementInputType!) {\n    createMeasurementByInstance(id: $id, input: $input) {\n      errors\n      success\n      measurement {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateMeasurementByInstanceMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementByInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementByInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementByInstanceMutation, { data, loading, error }] = useCreateMeasurementByInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeasurementByInstanceMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateMeasurementByInstanceDocument, options);
}
export var DeleteMeasurementDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  mutation deleteMeasurement($id: UUID!, $deletedReason: String!) {\n    deleteMeasurement(id: $id, deletedReason: $deletedReason) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation deleteMeasurement($id: UUID!, $deletedReason: String!) {\n    deleteMeasurement(id: $id, deletedReason: $deletedReason) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useDeleteMeasurementMutation__
 *
 * To run a mutation, you first call `useDeleteMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeasurementMutation, { data, loading, error }] = useDeleteMeasurementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedReason: // value for 'deletedReason'
 *   },
 * });
 */
export function useDeleteMeasurementMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteMeasurementDocument, options);
}
export var DeleteMeasurementsDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  mutation deleteMeasurements($input: MeasurementInputType!) {\n    deleteMeasurements(input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteMeasurements($input: MeasurementInputType!) {\n    deleteMeasurements(input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteMeasurementsMutation__
 *
 * To run a mutation, you first call `useDeleteMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeasurementsMutation, { data, loading, error }] = useDeleteMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMeasurementsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteMeasurementsDocument, options);
}
export var UpdateMeasurementDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  mutation updateMeasurement($id: UUID!, $input: MeasurementInputType!) {\n    updateMeasurement(input: $input, id: $id) {\n      errors\n      success\n      measurement {\n        ...Measurement\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation updateMeasurement($id: UUID!, $input: MeasurementInputType!) {\n    updateMeasurement(input: $input, id: $id) {\n      errors\n      success\n      measurement {\n        ...Measurement\n      }\n    }\n  }\n  ", "\n"])), MeasurementFragmentDoc);
/**
 * __useUpdateMeasurementMutation__
 *
 * To run a mutation, you first call `useUpdateMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasurementMutation, { data, loading, error }] = useUpdateMeasurementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeasurementMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateMeasurementDocument, options);
}
export var CreatePatientNoDicomDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  mutation createPatientNoDicom($input: PatientInputType!) {\n    createPatientNoDicom(input: $input) {\n      success\n      errors\n      patient {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createPatientNoDicom($input: PatientInputType!) {\n    createPatientNoDicom(input: $input) {\n      success\n      errors\n      patient {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreatePatientNoDicomMutation__
 *
 * To run a mutation, you first call `useCreatePatientNoDicomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientNoDicomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientNoDicomMutation, { data, loading, error }] = useCreatePatientNoDicomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientNoDicomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreatePatientNoDicomDocument, options);
}
export var UpdatePatientDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  mutation updatePatient($id: UUID!, $input: PatientExtendedInputType!) {\n    updatePatient(id: $id, input: $input) {\n      errors\n      success\n      patient {\n        id\n        studies {\n          status\n          id\n          reports {\n            id\n            pdfFile\n          }\n        }\n      }\n    }\n  }\n"], ["\n  mutation updatePatient($id: UUID!, $input: PatientExtendedInputType!) {\n    updatePatient(id: $id, input: $input) {\n      errors\n      success\n      patient {\n        id\n        studies {\n          status\n          id\n          reports {\n            id\n            pdfFile\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePatientDocument, options);
}
export var CreatePractitionerDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  mutation createPractitioner($input: CreatePractitionerInputType!) {\n    createPractitioner(input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        name\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation createPractitioner($input: CreatePractitionerInputType!) {\n    createPractitioner(input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        name\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreatePractitionerMutation__
 *
 * To run a mutation, you first call `useCreatePractitionerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePractitionerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPractitionerMutation, { data, loading, error }] = useCreatePractitionerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePractitionerMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreatePractitionerDocument, options);
}
export var UpdatePractitionerDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  mutation updatePractitioner($id: UUID!, $input: PractitionerInputType!) {\n    updatePractitioner(id: $id, input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        name\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation updatePractitioner($id: UUID!, $input: PractitionerInputType!) {\n    updatePractitioner(id: $id, input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        name\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdatePractitionerMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerMutation, { data, loading, error }] = useUpdatePractitionerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePractitionerMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePractitionerDocument, options);
}
export var UpdatePractitionerStatusDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  mutation updatePractitionerStatus($id: UUID!, $input: PractitionerStatusInputType!) {\n    updatePractitionerStatus(id: $id, input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        status\n      }\n    }\n  }\n"], ["\n  mutation updatePractitionerStatus($id: UUID!, $input: PractitionerStatusInputType!) {\n    updatePractitionerStatus(id: $id, input: $input) {\n      errors\n      success\n      practitioner {\n        id\n        status\n      }\n    }\n  }\n"])));
/**
 * __useUpdatePractitionerStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePractitionerStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePractitionerStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePractitionerStatusMutation, { data, loading, error }] = useUpdatePractitionerStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePractitionerStatusMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePractitionerStatusDocument, options);
}
export var BuildPdfReportDocument = gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  mutation buildPdfReport($id: UUID!) {\n    buildPdfReport(id: $id) {\n      errors\n      success\n      report {\n        id\n        pdfUrl\n      }\n    }\n  }\n"], ["\n  mutation buildPdfReport($id: UUID!) {\n    buildPdfReport(id: $id) {\n      errors\n      success\n      report {\n        id\n        pdfUrl\n      }\n    }\n  }\n"])));
/**
 * __useBuildPdfReportMutation__
 *
 * To run a mutation, you first call `useBuildPdfReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildPdfReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildPdfReportMutation, { data, loading, error }] = useBuildPdfReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBuildPdfReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(BuildPdfReportDocument, options);
}
export var CancelAddendumDocument = gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  mutation cancelAddendum($id: UUID!) {\n    cancelAddendum(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation cancelAddendum($id: UUID!) {\n    cancelAddendum(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useCancelAddendumMutation__
 *
 * To run a mutation, you first call `useCancelAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAddendumMutation, { data, loading, error }] = useCancelAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CancelAddendumDocument, options);
}
export var ClearReportDocument = gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  mutation clearReport($id: UUID!) {\n    clearReport(id: $id) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation clearReport($id: UUID!) {\n    clearReport(id: $id) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useClearReportMutation__
 *
 * To run a mutation, you first call `useClearReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearReportMutation, { data, loading, error }] = useClearReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClearReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ClearReportDocument, options);
}
export var CloneTemplateDocument = gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  mutation cloneTemplate($id: UUID!, $input: CloneTemplateInputType!) {\n    cloneTemplate(id: $id, input: $input) {\n      success\n      errors\n      template {\n        id\n        name\n        templateFields {\n          id\n          defaultValue\n        }\n      }\n    }\n  }\n"], ["\n  mutation cloneTemplate($id: UUID!, $input: CloneTemplateInputType!) {\n    cloneTemplate(id: $id, input: $input) {\n      success\n      errors\n      template {\n        id\n        name\n        templateFields {\n          id\n          defaultValue\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCloneTemplateMutation__
 *
 * To run a mutation, you first call `useCloneTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTemplateMutation, { data, loading, error }] = useCloneTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTemplateMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CloneTemplateDocument, options);
}
export var CreateAddendumDocument = gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  mutation createAddendum($input: AddendumInputType!) {\n    createAddendum(input: $input) {\n      success\n      errors\n      addendum {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createAddendum($input: AddendumInputType!) {\n    createAddendum(input: $input) {\n      success\n      errors\n      addendum {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateAddendumMutation__
 *
 * To run a mutation, you first call `useCreateAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddendumMutation, { data, loading, error }] = useCreateAddendumMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateAddendumDocument, options);
}
export var CreateReportDocument = gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  mutation createReport($input: CreateReportInputType!) {\n    createReport(input: $input) {\n      report {\n        id\n        template {\n          id\n        }\n      }\n      success\n      errors\n    }\n  }\n"], ["\n  mutation createReport($input: CreateReportInputType!) {\n    createReport(input: $input) {\n      report {\n        id\n        template {\n          id\n        }\n      }\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateReportDocument, options);
}
export var CreateReportConclusionDocument = gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  mutation createReportConclusion($reportId: UUID) {\n    createReportConclusion(input: { reportId: $reportId }) {\n      success\n      errors\n      reportConclusion {\n        id\n        conclusionGenerated\n        conclusionAccepted\n        usageData\n      }\n    }\n  }\n"], ["\n  mutation createReportConclusion($reportId: UUID) {\n    createReportConclusion(input: { reportId: $reportId }) {\n      success\n      errors\n      reportConclusion {\n        id\n        conclusionGenerated\n        conclusionAccepted\n        usageData\n      }\n    }\n  }\n"])));
/**
 * __useCreateReportConclusionMutation__
 *
 * To run a mutation, you first call `useCreateReportConclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportConclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportConclusionMutation, { data, loading, error }] = useCreateReportConclusionMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useCreateReportConclusionMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateReportConclusionDocument, options);
}
export var CreateReportFieldDocument = gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  mutation createReportField($input: CreateReportFieldInput!) {\n    createReportField(input: $input) {\n      reportField {\n        id\n      }\n      success\n    }\n  }\n"], ["\n  mutation createReportField($input: CreateReportFieldInput!) {\n    createReportField(input: $input) {\n      reportField {\n        id\n      }\n      success\n    }\n  }\n"])));
/**
 * __useCreateReportFieldMutation__
 *
 * To run a mutation, you first call `useCreateReportFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportFieldMutation, { data, loading, error }] = useCreateReportFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportFieldMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateReportFieldDocument, options);
}
export var DeleteAddendumDocument = gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  mutation deleteAddendum($id: UUID!) {\n    deleteAddendum(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteAddendum($id: UUID!) {\n    deleteAddendum(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteAddendumMutation__
 *
 * To run a mutation, you first call `useDeleteAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddendumMutation, { data, loading, error }] = useDeleteAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteAddendumDocument, options);
}
export var DeleteTemplateDocument = gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  mutation deleteTemplate($id: UUID!) {\n    deleteTemplate(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteTemplate($id: UUID!) {\n    deleteTemplate(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteTemplateDocument, options);
}
export var FinishReviewReportDocument = gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  mutation finishReviewReport($id: UUID!) {\n    reviewReport(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation finishReviewReport($id: UUID!) {\n    reviewReport(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useFinishReviewReportMutation__
 *
 * To run a mutation, you first call `useFinishReviewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishReviewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishReviewReportMutation, { data, loading, error }] = useFinishReviewReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishReviewReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(FinishReviewReportDocument, options);
}
export var PreviewReportDocument = gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n  mutation previewReport($id: UUID!) {\n    previewReport(id: $id) {\n      errors\n      success\n      pdfPreviewUrl\n    }\n  }\n"], ["\n  mutation previewReport($id: UUID!) {\n    previewReport(id: $id) {\n      errors\n      success\n      pdfPreviewUrl\n    }\n  }\n"])));
/**
 * __usePreviewReportMutation__
 *
 * To run a mutation, you first call `usePreviewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewReportMutation, { data, loading, error }] = usePreviewReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(PreviewReportDocument, options);
}
export var RequireReviewReportDocument = gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n  mutation requireReviewReport($id: UUID!, $practitionerId: UUID) {\n    requireReviewReport(id: $id, practitionerId: $practitionerId) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation requireReviewReport($id: UUID!, $practitionerId: UUID) {\n    requireReviewReport(id: $id, practitionerId: $practitionerId) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useRequireReviewReportMutation__
 *
 * To run a mutation, you first call `useRequireReviewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequireReviewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requireReviewReportMutation, { data, loading, error }] = useRequireReviewReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      practitionerId: // value for 'practitionerId'
 *   },
 * });
 */
export function useRequireReviewReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RequireReviewReportDocument, options);
}
export var SelectTemplateDocument = gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n  mutation selectTemplate($id: UUID!, $input: SelectTemplateInputType!) {\n    selectTemplate(id: $id, input: $input) {\n      success\n      errors\n      template {\n        id\n      }\n    }\n  }\n"], ["\n  mutation selectTemplate($id: UUID!, $input: SelectTemplateInputType!) {\n    selectTemplate(id: $id, input: $input) {\n      success\n      errors\n      template {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useSelectTemplateMutation__
 *
 * To run a mutation, you first call `useSelectTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectTemplateMutation, { data, loading, error }] = useSelectTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectTemplateMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SelectTemplateDocument, options);
}
export var SendMailReportDocument = gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n  mutation sendMailReport($id: UUID!, $email: String!) {\n    sendMailReport(id: $id, email: $email) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation sendMailReport($id: UUID!, $email: String!) {\n    sendMailReport(id: $id, email: $email) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useSendMailReportMutation__
 *
 * To run a mutation, you first call `useSendMailReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMailReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMailReportMutation, { data, loading, error }] = useSendMailReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendMailReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendMailReportDocument, options);
}
export var SendMessageReportDocument = gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n  mutation sendMessageReport($id: UUID!, $phone: String!, $phoneCode: String!) {\n    sendMessageReport(id: $id, phone: $phone, phoneCode: $phoneCode) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation sendMessageReport($id: UUID!, $phone: String!, $phoneCode: String!) {\n    sendMessageReport(id: $id, phone: $phone, phoneCode: $phoneCode) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useSendMessageReportMutation__
 *
 * To run a mutation, you first call `useSendMessageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageReportMutation, { data, loading, error }] = useSendMessageReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      phone: // value for 'phone'
 *      phoneCode: // value for 'phoneCode'
 *   },
 * });
 */
export function useSendMessageReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendMessageReportDocument, options);
}
export var SignAddendumDocument = gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n  mutation signAddendum($id: UUID!) {\n    signAddendum(id: $id) {\n      success\n      errors\n      addendum {\n        id\n        report {\n          id\n          pdfUrl\n          pdfLetterheadUrl\n        }\n      }\n    }\n  }\n"], ["\n  mutation signAddendum($id: UUID!) {\n    signAddendum(id: $id) {\n      success\n      errors\n      addendum {\n        id\n        report {\n          id\n          pdfUrl\n          pdfLetterheadUrl\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSignAddendumMutation__
 *
 * To run a mutation, you first call `useSignAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signAddendumMutation, { data, loading, error }] = useSignAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SignAddendumDocument, options);
}
export var SignReportDocument = gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  mutation signReport($id: UUID!) {\n    signReport(id: $id) {\n      success\n      report {\n        id\n        pdfUrl\n        pdfLetterheadUrl\n        study {\n          practitionerAssigned {\n            id\n          }\n          reviewerPractitioner {\n            id\n          }\n        }\n      }\n      errors\n    }\n  }\n"], ["\n  mutation signReport($id: UUID!) {\n    signReport(id: $id) {\n      success\n      report {\n        id\n        pdfUrl\n        pdfLetterheadUrl\n        study {\n          practitionerAssigned {\n            id\n          }\n          reviewerPractitioner {\n            id\n          }\n        }\n      }\n      errors\n    }\n  }\n"])));
/**
 * __useSignReportMutation__
 *
 * To run a mutation, you first call `useSignReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signReportMutation, { data, loading, error }] = useSignReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SignReportDocument, options);
}
export var UndoExternalReportDocument = gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n  mutation undoExternalReport($reportId: UUID!) {\n    undoExternalReport(id: $reportId) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation undoExternalReport($reportId: UUID!) {\n    undoExternalReport(id: $reportId) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useUndoExternalReportMutation__
 *
 * To run a mutation, you first call `useUndoExternalReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoExternalReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoExternalReportMutation, { data, loading, error }] = useUndoExternalReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useUndoExternalReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UndoExternalReportDocument, options);
}
export var UndoSignAddendumDocument = gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n  mutation UndoSignAddendum($id: UUID!) {\n    undoSignAddendum(id: $id) {\n      errors\n      success\n      addendum {\n        id\n      }\n    }\n  }\n"], ["\n  mutation UndoSignAddendum($id: UUID!) {\n    undoSignAddendum(id: $id) {\n      errors\n      success\n      addendum {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useUndoSignAddendumMutation__
 *
 * To run a mutation, you first call `useUndoSignAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoSignAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoSignAddendumMutation, { data, loading, error }] = useUndoSignAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoSignAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UndoSignAddendumDocument, options);
}
export var UndoSignReportDocument = gql(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n  mutation UndoSignReport($id: UUID!) {\n    undoSignReport(id: $id) {\n      errors\n      success\n      report {\n        id\n      }\n    }\n  }\n"], ["\n  mutation UndoSignReport($id: UUID!) {\n    undoSignReport(id: $id) {\n      errors\n      success\n      report {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useUndoSignReportMutation__
 *
 * To run a mutation, you first call `useUndoSignReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoSignReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoSignReportMutation, { data, loading, error }] = useUndoSignReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndoSignReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UndoSignReportDocument, options);
}
export var UpdateAddendumDocument = gql(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n  mutation updateAddendum($id: UUID!, $input: AddendumUpdateInputType!) {\n    updateAddendum(id: $id, input: $input) {\n      addendum {\n        report {\n          id\n          pdfUrl\n        }\n      }\n      success\n      errors\n    }\n  }\n"], ["\n  mutation updateAddendum($id: UUID!, $input: AddendumUpdateInputType!) {\n    updateAddendum(id: $id, input: $input) {\n      addendum {\n        report {\n          id\n          pdfUrl\n        }\n      }\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useUpdateAddendumMutation__
 *
 * To run a mutation, you first call `useUpdateAddendumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddendumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddendumMutation, { data, loading, error }] = useUpdateAddendumMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddendumMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateAddendumDocument, options);
}
export var UpdateReportDocument = gql(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n  mutation updateReport($id: UUID!, $input: UpdateReportInputType!) {\n    updateReport(id: $id, input: $input) {\n      errors\n      success\n      report {\n        id\n        pdfUrl\n      }\n    }\n  }\n"], ["\n  mutation updateReport($id: UUID!, $input: UpdateReportInputType!) {\n    updateReport(id: $id, input: $input) {\n      errors\n      success\n      report {\n        id\n        pdfUrl\n      }\n    }\n  }\n"])));
/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateReportDocument, options);
}
export var UpdateReportConclusionDocument = gql(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n  mutation updateReportConclusion($conclusionId: UUID!, $conclusion: String) {\n    updateReportConclusion(id: $conclusionId, input: { conclusion: $conclusion }) {\n      success\n      errors\n      reportConclusion {\n        id\n        report {\n          id\n        }\n        isEqual\n        conclusionGenerated\n        usageData\n      }\n    }\n  }\n"], ["\n  mutation updateReportConclusion($conclusionId: UUID!, $conclusion: String) {\n    updateReportConclusion(id: $conclusionId, input: { conclusion: $conclusion }) {\n      success\n      errors\n      reportConclusion {\n        id\n        report {\n          id\n        }\n        isEqual\n        conclusionGenerated\n        usageData\n      }\n    }\n  }\n"])));
/**
 * __useUpdateReportConclusionMutation__
 *
 * To run a mutation, you first call `useUpdateReportConclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportConclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportConclusionMutation, { data, loading, error }] = useUpdateReportConclusionMutation({
 *   variables: {
 *      conclusionId: // value for 'conclusionId'
 *      conclusion: // value for 'conclusion'
 *   },
 * });
 */
export function useUpdateReportConclusionMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateReportConclusionDocument, options);
}
export var UpdateReportFieldDocument = gql(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n  mutation updateReportField($id: UUID!, $input: UpdateReportFieldInput!) {\n    updateReportField(id: $id, input: $input) {\n      reportField {\n        id\n      }\n      success\n    }\n  }\n"], ["\n  mutation updateReportField($id: UUID!, $input: UpdateReportFieldInput!) {\n    updateReportField(id: $id, input: $input) {\n      reportField {\n        id\n      }\n      success\n    }\n  }\n"])));
/**
 * __useUpdateReportFieldMutation__
 *
 * To run a mutation, you first call `useUpdateReportFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportFieldMutation, { data, loading, error }] = useUpdateReportFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportFieldMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateReportFieldDocument, options);
}
export var AddCriticalValueDocument = gql(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n  mutation addCriticalValue($input: StudyCriticalValueInputType!) {\n    assignCriticalValues(input: [$input]) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation addCriticalValue($input: StudyCriticalValueInputType!) {\n    assignCriticalValues(input: [$input]) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useAddCriticalValueMutation__
 *
 * To run a mutation, you first call `useAddCriticalValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCriticalValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCriticalValueMutation, { data, loading, error }] = useAddCriticalValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCriticalValueMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AddCriticalValueDocument, options);
}
export var AddInstanceToKeySeriesDocument = gql(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n  mutation addInstanceToKeySeries($instanceId: UUID!) {\n    addInstanceToKeySeries(instanceId: $instanceId) {\n      success\n      errors\n      instanceParent {\n        series {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation addInstanceToKeySeries($instanceId: UUID!) {\n    addInstanceToKeySeries(instanceId: $instanceId) {\n      success\n      errors\n      instanceParent {\n        series {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useAddInstanceToKeySeriesMutation__
 *
 * To run a mutation, you first call `useAddInstanceToKeySeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInstanceToKeySeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInstanceToKeySeriesMutation, { data, loading, error }] = useAddInstanceToKeySeriesMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useAddInstanceToKeySeriesMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AddInstanceToKeySeriesDocument, options);
}
export var BurnIsoDocument = gql(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n  mutation burnIso($input: DownloadIsoInputType!) {\n    createBurnIso(input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"], ["\n  mutation burnIso($input: DownloadIsoInputType!) {\n    createBurnIso(input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useBurnIsoMutation__
 *
 * To run a mutation, you first call `useBurnIsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBurnIsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [burnIsoMutation, { data, loading, error }] = useBurnIsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBurnIsoMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(BurnIsoDocument, options);
}
export var CheckVisitantDocument = gql(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n  mutation checkVisitant($studyId: UUID!) {\n    checkVisitant(id: $studyId) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation checkVisitant($studyId: UUID!) {\n    checkVisitant(id: $studyId) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useCheckVisitantMutation__
 *
 * To run a mutation, you first call `useCheckVisitantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckVisitantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkVisitantMutation, { data, loading, error }] = useCheckVisitantMutation({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useCheckVisitantMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CheckVisitantDocument, options);
}
export var CreateDicomPdfFileDocument = gql(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n  mutation createDicomPdfFile($input: StudyPdfFileInputType!) {\n    createStudyPdfFile(input: $input) {\n      success\n      errors\n      studyPdfFile {\n        id\n        status\n        file\n        fileUrl\n      }\n    }\n  }\n"], ["\n  mutation createDicomPdfFile($input: StudyPdfFileInputType!) {\n    createStudyPdfFile(input: $input) {\n      success\n      errors\n      studyPdfFile {\n        id\n        status\n        file\n        fileUrl\n      }\n    }\n  }\n"])));
/**
 * __useCreateDicomPdfFileMutation__
 *
 * To run a mutation, you first call `useCreateDicomPdfFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDicomPdfFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDicomPdfFileMutation, { data, loading, error }] = useCreateDicomPdfFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDicomPdfFileMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateDicomPdfFileDocument, options);
}
export var CreateDownloadDocument = gql(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n  mutation createDownload($input: DownloadInputType!) {\n    createDownload(input: $input) {\n      download {\n        fileUrl\n        status\n        study {\n          id\n        }\n      }\n      errors\n      success\n    }\n  }\n"], ["\n  mutation createDownload($input: DownloadInputType!) {\n    createDownload(input: $input) {\n      download {\n        fileUrl\n        status\n        study {\n          id\n        }\n      }\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useCreateDownloadMutation__
 *
 * To run a mutation, you first call `useCreateDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownloadMutation, { data, loading, error }] = useCreateDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDownloadMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateDownloadDocument, options);
}
export var CreateDownloadIsoDocument = gql(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n  mutation createDownloadIso($input: DownloadIsoInputType!) {\n    createDownloadIso(input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"], ["\n  mutation createDownloadIso($input: DownloadIsoInputType!) {\n    createDownloadIso(input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useCreateDownloadIsoMutation__
 *
 * To run a mutation, you first call `useCreateDownloadIsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownloadIsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownloadIsoMutation, { data, loading, error }] = useCreateDownloadIsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDownloadIsoMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateDownloadIsoDocument, options);
}
export var CreateSeriesPrintDocument = gql(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n  mutation createSeriesPrint($input: DicomPrintSeriesInputType!) {\n    createSeriesPrint(input: $input) {\n      success\n      errors\n      dicomPrint {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createSeriesPrint($input: DicomPrintSeriesInputType!) {\n    createSeriesPrint(input: $input) {\n      success\n      errors\n      dicomPrint {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateSeriesPrintMutation__
 *
 * To run a mutation, you first call `useCreateSeriesPrintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeriesPrintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeriesPrintMutation, { data, loading, error }] = useCreateSeriesPrintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeriesPrintMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateSeriesPrintDocument, options);
}
export var CreateStudiesCsvDocument = gql(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n  mutation createStudiesCsv {\n    createStudiesCsv {\n      success\n      errors\n      download {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createStudiesCsv {\n    createStudiesCsv {\n      success\n      errors\n      download {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateStudiesCsvMutation__
 *
 * To run a mutation, you first call `useCreateStudiesCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudiesCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudiesCsvMutation, { data, loading, error }] = useCreateStudiesCsvMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateStudiesCsvMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateStudiesCsvDocument, options);
}
export var CreateStudyNoDicomDocument = gql(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n  mutation createStudyNoDicom($input: StudyInputType!) {\n    createStudyNoDicom(input: $input) {\n      success\n      errors\n      study {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createStudyNoDicom($input: StudyInputType!) {\n    createStudyNoDicom(input: $input) {\n      success\n      errors\n      study {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateStudyNoDicomMutation__
 *
 * To run a mutation, you first call `useCreateStudyNoDicomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudyNoDicomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudyNoDicomMutation, { data, loading, error }] = useCreateStudyNoDicomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudyNoDicomMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateStudyNoDicomDocument, options);
}
export var CreateStudyPdfFileDocument = gql(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n  mutation createStudyPdfFile($input: StudyPdfFileInputType!) {\n    createStudyPdfFile(input: $input) {\n      success\n      errors\n      studyPdfFile {\n        fileUrl\n        status\n      }\n    }\n  }\n"], ["\n  mutation createStudyPdfFile($input: StudyPdfFileInputType!) {\n    createStudyPdfFile(input: $input) {\n      success\n      errors\n      studyPdfFile {\n        fileUrl\n        status\n      }\n    }\n  }\n"])));
/**
 * __useCreateStudyPdfFileMutation__
 *
 * To run a mutation, you first call `useCreateStudyPdfFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudyPdfFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStudyPdfFileMutation, { data, loading, error }] = useCreateStudyPdfFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudyPdfFileMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateStudyPdfFileDocument, options);
}
export var DeleteCriticalValueDocument = gql(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n  mutation deleteCriticalValue($id: UUID!) {\n    deleteCriticalValue(id: $id) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation deleteCriticalValue($id: UUID!) {\n    deleteCriticalValue(id: $id) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useDeleteCriticalValueMutation__
 *
 * To run a mutation, you first call `useDeleteCriticalValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCriticalValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCriticalValueMutation, { data, loading, error }] = useDeleteCriticalValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCriticalValueMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteCriticalValueDocument, options);
}
export var DeleteStudyDocument = gql(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n  mutation deleteStudy($id: UUID!) {\n    deleteStudy(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteStudy($id: UUID!) {\n    deleteStudy(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteStudyMutation__
 *
 * To run a mutation, you first call `useDeleteStudyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStudyMutation, { data, loading, error }] = useDeleteStudyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStudyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteStudyDocument, options);
}
export var EditCriticalValueDocument = gql(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n  mutation editCriticalValue($id: UUID!, $input: StudyCriticalValueInputType!) {\n    updateCriticalValue(id: $id, input: $input) {\n      errors\n      success\n    }\n  }\n"], ["\n  mutation editCriticalValue($id: UUID!, $input: StudyCriticalValueInputType!) {\n    updateCriticalValue(id: $id, input: $input) {\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useEditCriticalValueMutation__
 *
 * To run a mutation, you first call `useEditCriticalValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCriticalValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCriticalValueMutation, { data, loading, error }] = useEditCriticalValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCriticalValueMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(EditCriticalValueDocument, options);
}
export var JoinMultipleStudiesDocument = gql(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n  mutation joinMultipleStudies($input: JoinMultipleStudiesInputType!) {\n    joinMultipleStudies(input: $input) {\n      success\n      errors\n      joinedStudy {\n        ...Study\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation joinMultipleStudies($input: JoinMultipleStudiesInputType!) {\n    joinMultipleStudies(input: $input) {\n      success\n      errors\n      joinedStudy {\n        ...Study\n      }\n    }\n  }\n  ", "\n"])), StudyFragmentDoc);
/**
 * __useJoinMultipleStudiesMutation__
 *
 * To run a mutation, you first call `useJoinMultipleStudiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinMultipleStudiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinMultipleStudiesMutation, { data, loading, error }] = useJoinMultipleStudiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinMultipleStudiesMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(JoinMultipleStudiesDocument, options);
}
export var RemoveInstanceFromKeySeriesDocument = gql(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n  mutation removeInstanceFromKeySeries($instanceId: UUID!) {\n    removeInstanceFromKeySeries(instanceId: $instanceId) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation removeInstanceFromKeySeries($instanceId: UUID!) {\n    removeInstanceFromKeySeries(instanceId: $instanceId) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useRemoveInstanceFromKeySeriesMutation__
 *
 * To run a mutation, you first call `useRemoveInstanceFromKeySeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInstanceFromKeySeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInstanceFromKeySeriesMutation, { data, loading, error }] = useRemoveInstanceFromKeySeriesMutation({
 *   variables: {
 *      instanceId: // value for 'instanceId'
 *   },
 * });
 */
export function useRemoveInstanceFromKeySeriesMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemoveInstanceFromKeySeriesDocument, options);
}
export var SendMailViewerLinkDocument = gql(templateObject_83 || (templateObject_83 = __makeTemplateObject(["\n  mutation sendMailViewerLink($id: UUID!, $email: String!) {\n    sendMailViewerLink(id: $id, email: $email) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation sendMailViewerLink($id: UUID!, $email: String!) {\n    sendMailViewerLink(id: $id, email: $email) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useSendMailViewerLinkMutation__
 *
 * To run a mutation, you first call `useSendMailViewerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMailViewerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMailViewerLinkMutation, { data, loading, error }] = useSendMailViewerLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendMailViewerLinkMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendMailViewerLinkDocument, options);
}
export var SendMessageViewerLinkDocument = gql(templateObject_84 || (templateObject_84 = __makeTemplateObject(["\n  mutation sendMessageViewerLink($id: UUID!, $phone: String!, $phoneCode: String!) {\n    sendMessageViewerLink(id: $id, phone: $phone, phoneCode: $phoneCode) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation sendMessageViewerLink($id: UUID!, $phone: String!, $phoneCode: String!) {\n    sendMessageViewerLink(id: $id, phone: $phone, phoneCode: $phoneCode) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useSendMessageViewerLinkMutation__
 *
 * To run a mutation, you first call `useSendMessageViewerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageViewerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageViewerLinkMutation, { data, loading, error }] = useSendMessageViewerLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      phone: // value for 'phone'
 *      phoneCode: // value for 'phoneCode'
 *   },
 * });
 */
export function useSendMessageViewerLinkMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SendMessageViewerLinkDocument, options);
}
export var UpdateBurnIsoStatusDocument = gql(templateObject_85 || (templateObject_85 = __makeTemplateObject(["\n  mutation updateBurnIsoStatus($downloadIsoId: UUID!, $input: DownloadIsoInputType!) {\n    updateDownloadIso(id: $downloadIsoId, input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"], ["\n  mutation updateBurnIsoStatus($downloadIsoId: UUID!, $input: DownloadIsoInputType!) {\n    updateDownloadIso(id: $downloadIsoId, input: $input) {\n      downloadIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n      errors\n      success\n    }\n  }\n"])));
/**
 * __useUpdateBurnIsoStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBurnIsoStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBurnIsoStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBurnIsoStatusMutation, { data, loading, error }] = useUpdateBurnIsoStatusMutation({
 *   variables: {
 *      downloadIsoId: // value for 'downloadIsoId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBurnIsoStatusMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBurnIsoStatusDocument, options);
}
export var UpdateSerieDocument = gql(templateObject_86 || (templateObject_86 = __makeTemplateObject(["\n  mutation updateSerie($id: UUID!, $input: SeriesInputType!) {\n    updateSeries(id: $id, input: $input) {\n      success\n      errors\n      series {\n        id\n      }\n    }\n  }\n"], ["\n  mutation updateSerie($id: UUID!, $input: SeriesInputType!) {\n    updateSeries(id: $id, input: $input) {\n      success\n      errors\n      series {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useUpdateSerieMutation__
 *
 * To run a mutation, you first call `useUpdateSerieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSerieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSerieMutation, { data, loading, error }] = useUpdateSerieMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSerieMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateSerieDocument, options);
}
export var UpdateStudyDocument = gql(templateObject_87 || (templateObject_87 = __makeTemplateObject(["\n  mutation updateStudy($id: UUID!, $input: StudyInputType!) {\n    updateStudy(id: $id, input: $input) {\n      errors\n      success\n      study {\n        id\n        reports {\n          id\n          pdfFile\n        }\n        status\n      }\n    }\n  }\n"], ["\n  mutation updateStudy($id: UUID!, $input: StudyInputType!) {\n    updateStudy(id: $id, input: $input) {\n      errors\n      success\n      study {\n        id\n        reports {\n          id\n          pdfFile\n        }\n        status\n      }\n    }\n  }\n"])));
/**
 * __useUpdateStudyMutation__
 *
 * To run a mutation, you first call `useUpdateStudyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudyMutation, { data, loading, error }] = useUpdateStudyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudyMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateStudyDocument, options);
}
export var DeleteReferringPractitionerNotificationsDocument = gql(templateObject_88 || (templateObject_88 = __makeTemplateObject(["\n  mutation deleteReferringPractitionerNotifications($organizationId: UUID!, $userId: UUID!) {\n    deleteReferringPractitionerNotifications(organizationId: $organizationId, userId: $userId) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteReferringPractitionerNotifications($organizationId: UUID!, $userId: UUID!) {\n    deleteReferringPractitionerNotifications(organizationId: $organizationId, userId: $userId) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteReferringPractitionerNotificationsMutation__
 *
 * To run a mutation, you first call `useDeleteReferringPractitionerNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReferringPractitionerNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReferringPractitionerNotificationsMutation, { data, loading, error }] = useDeleteReferringPractitionerNotificationsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteReferringPractitionerNotificationsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteReferringPractitionerNotificationsDocument, options);
}
export var CreateUserPreferenceDocument = gql(templateObject_89 || (templateObject_89 = __makeTemplateObject(["\n  mutation createUserPreference($input: UserPreferenceInputType!) {\n    createUserPreference(input: $input) {\n      success\n      errors\n      userPreference {\n        user {\n          id\n        }\n        family\n        key\n        value\n      }\n    }\n  }\n"], ["\n  mutation createUserPreference($input: UserPreferenceInputType!) {\n    createUserPreference(input: $input) {\n      success\n      errors\n      userPreference {\n        user {\n          id\n        }\n        family\n        key\n        value\n      }\n    }\n  }\n"])));
/**
 * __useCreateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useCreateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPreferenceMutation, { data, loading, error }] = useCreateUserPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserPreferenceMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateUserPreferenceDocument, options);
}
export var DeleteAllUserPreferencesDocument = gql(templateObject_90 || (templateObject_90 = __makeTemplateObject(["\n  mutation deleteAllUserPreferences($input: UserPreferenceInputType!) {\n    deleteUserPreferences(input: $input) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteAllUserPreferences($input: UserPreferenceInputType!) {\n    deleteUserPreferences(input: $input) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteAllUserPreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteAllUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllUserPreferencesMutation, { data, loading, error }] = useDeleteAllUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllUserPreferencesMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteAllUserPreferencesDocument, options);
}
export var DeleteUserPreferenceDocument = gql(templateObject_91 || (templateObject_91 = __makeTemplateObject(["\n  mutation deleteUserPreference($id: UUID!) {\n    deleteUserPreference(id: $id) {\n      success\n      errors\n    }\n  }\n"], ["\n  mutation deleteUserPreference($id: UUID!) {\n    deleteUserPreference(id: $id) {\n      success\n      errors\n    }\n  }\n"])));
/**
 * __useDeleteUserPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPreferenceMutation, { data, loading, error }] = useDeleteUserPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserPreferenceMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteUserPreferenceDocument, options);
}
export var UpdateUserPreferenceDocument = gql(templateObject_92 || (templateObject_92 = __makeTemplateObject(["\n  mutation updateUserPreference($id: UUID!, $input: UserPreferenceInputType!) {\n    updateUserPreference(id: $id, input: $input) {\n      success\n      errors\n      userPreference {\n        user {\n          id\n        }\n        family\n        key\n        value\n      }\n    }\n  }\n"], ["\n  mutation updateUserPreference($id: UUID!, $input: UserPreferenceInputType!) {\n    updateUserPreference(id: $id, input: $input) {\n      success\n      errors\n      userPreference {\n        user {\n          id\n        }\n        family\n        key\n        value\n      }\n    }\n  }\n"])));
/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUserPreferenceDocument, options);
}
export var CreateWorklistCsvDocument = gql(templateObject_93 || (templateObject_93 = __makeTemplateObject(["\n  mutation createWorklistCsv {\n    createWorklistCsv {\n      success\n      errors\n      download {\n        id\n      }\n    }\n  }\n"], ["\n  mutation createWorklistCsv {\n    createWorklistCsv {\n      success\n      errors\n      download {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateWorklistCsvMutation__
 *
 * To run a mutation, you first call `useCreateWorklistCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorklistCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorklistCsvMutation, { data, loading, error }] = useCreateWorklistCsvMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateWorklistCsvMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateWorklistCsvDocument, options);
}
export var GetProductPermissionGroupsDocument = gql(templateObject_94 || (templateObject_94 = __makeTemplateObject(["\n  query GetProductPermissionGroups {\n    productPermissionGroups {\n      results {\n        id\n        group {\n          id\n          name\n        }\n        product {\n          id\n          slug\n          productOrganizations {\n            hasAccess\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query GetProductPermissionGroups {\n    productPermissionGroups {\n      results {\n        id\n        group {\n          id\n          name\n        }\n        product {\n          id\n          slug\n          productOrganizations {\n            hasAccess\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetProductPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetProductPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductPermissionGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductPermissionGroupsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetProductPermissionGroupsDocument, options);
}
export function useGetProductPermissionGroupsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetProductPermissionGroupsDocument, options);
}
export var GetProductsDocument = gql(templateObject_95 || (templateObject_95 = __makeTemplateObject(["\n  query GetProducts {\n    products {\n      results {\n        id\n        name\n        description\n        slug\n        productPermissionGroups {\n          isVisible\n          id\n          group {\n            id\n            name\n          }\n        }\n        productOrganizations {\n          hasAccess\n        }\n      }\n      totalCount\n    }\n  }\n"], ["\n  query GetProducts {\n    products {\n      results {\n        id\n        name\n        description\n        slug\n        productPermissionGroups {\n          isVisible\n          id\n          group {\n            id\n            name\n          }\n        }\n        productOrganizations {\n          hasAccess\n        }\n      }\n      totalCount\n    }\n  }\n"])));
/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetProductsDocument, options);
}
export function useGetProductsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetProductsDocument, options);
}
export var PermissionOptionsDocument = gql(templateObject_96 || (templateObject_96 = __makeTemplateObject(["\n  query PermissionOptions($roleIn: [String!]!) {\n    facilities(permissions: false) {\n      results {\n        id\n        name\n      }\n    }\n    modalities(permissions: false) {\n      results {\n        id\n        name\n      }\n    }\n    practitioners(ordering: \"fullName,asc\", isValidPacsPractitioner: true, permissions: false, rolesIn: $roleIn) {\n      results {\n        id\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query PermissionOptions($roleIn: [String!]!) {\n    facilities(permissions: false) {\n      results {\n        id\n        name\n      }\n    }\n    modalities(permissions: false) {\n      results {\n        id\n        name\n      }\n    }\n    practitioners(ordering: \"fullName,asc\", isValidPacsPractitioner: true, permissions: false, rolesIn: $roleIn) {\n      results {\n        id\n        fullName\n        user {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __usePermissionOptionsQuery__
 *
 * To run a query within a React component, call `usePermissionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionOptionsQuery({
 *   variables: {
 *      roleIn: // value for 'roleIn'
 *   },
 * });
 */
export function usePermissionOptionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PermissionOptionsDocument, options);
}
export function usePermissionOptionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PermissionOptionsDocument, options);
}
export var UserDeniedPermissionsDocument = gql(templateObject_97 || (templateObject_97 = __makeTemplateObject(["\n  query UserDeniedPermissions($userId: UUID) {\n    userRowPermissions(userId: $userId, allowed: false) {\n      results {\n        model\n        allowed\n        objectId\n      }\n      totalCount\n    }\n  }\n"], ["\n  query UserDeniedPermissions($userId: UUID) {\n    userRowPermissions(userId: $userId, allowed: false) {\n      results {\n        model\n        allowed\n        objectId\n      }\n      totalCount\n    }\n  }\n"])));
/**
 * __useUserDeniedPermissionsQuery__
 *
 * To run a query within a React component, call `useUserDeniedPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDeniedPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDeniedPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeniedPermissionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(UserDeniedPermissionsDocument, options);
}
export function useUserDeniedPermissionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(UserDeniedPermissionsDocument, options);
}
export var BurnersDocument = gql(templateObject_98 || (templateObject_98 = __makeTemplateObject(["\n  query Burners {\n    burners {\n      results {\n        id\n        name\n        facility {\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query Burners {\n    burners {\n      results {\n        id\n        name\n        facility {\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useBurnersQuery__
 *
 * To run a query within a React component, call `useBurnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBurnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBurnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBurnersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BurnersDocument, options);
}
export function useBurnersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BurnersDocument, options);
}
export var CreateIsoAndBurnerByStudyIdsDocument = gql(templateObject_99 || (templateObject_99 = __makeTemplateObject(["\n  mutation createIsoAndBurnerByStudyIds($input: DownloadIsoMultiMatrixInputType!) {\n    createDownloadIsoMatrix(input: $input) {\n      downloads {\n        id\n        status\n        statusBurn\n        fileUrl\n        studies {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation createIsoAndBurnerByStudyIds($input: DownloadIsoMultiMatrixInputType!) {\n    createDownloadIsoMatrix(input: $input) {\n      downloads {\n        id\n        status\n        statusBurn\n        fileUrl\n        studies {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateIsoAndBurnerByStudyIdsMutation__
 *
 * To run a mutation, you first call `useCreateIsoAndBurnerByStudyIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIsoAndBurnerByStudyIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIsoAndBurnerByStudyIdsMutation, { data, loading, error }] = useCreateIsoAndBurnerByStudyIdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIsoAndBurnerByStudyIdsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateIsoAndBurnerByStudyIdsDocument, options);
}
export var GetCurrentIsoAndBurnerStatusByStudyIdsDocument = gql(templateObject_100 || (templateObject_100 = __makeTemplateObject(["\n  query getCurrentIsoAndBurnerStatusByStudyIds($studies: [[UUID]]!) {\n    downloadIsoMultiByStudiesMatrix(studies: $studies) {\n      id\n      status\n      statusBurn\n      fileUrl\n      studies {\n        id\n      }\n    }\n  }\n"], ["\n  query getCurrentIsoAndBurnerStatusByStudyIds($studies: [[UUID]]!) {\n    downloadIsoMultiByStudiesMatrix(studies: $studies) {\n      id\n      status\n      statusBurn\n      fileUrl\n      studies {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useGetCurrentIsoAndBurnerStatusByStudyIdsQuery__
 *
 * To run a query within a React component, call `useGetCurrentIsoAndBurnerStatusByStudyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentIsoAndBurnerStatusByStudyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentIsoAndBurnerStatusByStudyIdsQuery({
 *   variables: {
 *      studies: // value for 'studies'
 *   },
 * });
 */
export function useGetCurrentIsoAndBurnerStatusByStudyIdsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetCurrentIsoAndBurnerStatusByStudyIdsDocument, options);
}
export function useGetCurrentIsoAndBurnerStatusByStudyIdsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetCurrentIsoAndBurnerStatusByStudyIdsDocument, options);
}
export var CountriesDocument = gql(templateObject_101 || (templateObject_101 = __makeTemplateObject(["\n  query Countries {\n    countries {\n      results {\n        id\n        name\n        isoCode\n        iso3Code\n        phoneCode\n      }\n    }\n  }\n"], ["\n  query Countries {\n    countries {\n      results {\n        id\n        name\n        isoCode\n        iso3Code\n        phoneCode\n      }\n    }\n  }\n"])));
/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CountriesDocument, options);
}
export function useCountriesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CountriesDocument, options);
}
export var FacilitiesDocument = gql(templateObject_102 || (templateObject_102 = __makeTemplateObject(["\n  query Facilities {\n    facilities {\n      results {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query Facilities {\n    facilities {\n      results {\n        id\n        name\n      }\n    }\n  }\n"])));
/**
 * __useFacilitiesQuery__
 *
 * To run a query within a React component, call `useFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFacilitiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FacilitiesDocument, options);
}
export function useFacilitiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FacilitiesDocument, options);
}
export var GetFacilityByStudyDocument = gql(templateObject_103 || (templateObject_103 = __makeTemplateObject(["\n  query GetFacilityByStudy($studyId: UUID) {\n    study(id: $studyId) {\n      facility {\n        id\n        country {\n          id\n          name\n          phoneCode\n          isoCode\n        }\n      }\n    }\n  }\n"], ["\n  query GetFacilityByStudy($studyId: UUID) {\n    study(id: $studyId) {\n      facility {\n        id\n        country {\n          id\n          name\n          phoneCode\n          isoCode\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetFacilityByStudyQuery__
 *
 * To run a query within a React component, call `useGetFacilityByStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacilityByStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacilityByStudyQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetFacilityByStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetFacilityByStudyDocument, options);
}
export function useGetFacilityByStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetFacilityByStudyDocument, options);
}
export var StudyFilesDocument = gql(templateObject_104 || (templateObject_104 = __makeTemplateObject(["\n  query studyFiles($studyId: UUID) {\n    studyFiles(study_Id: $studyId) {\n      results {\n        id\n        name\n        fileUrl\n        isVisible\n        thumbnailUrl\n      }\n    }\n  }\n"], ["\n  query studyFiles($studyId: UUID) {\n    studyFiles(study_Id: $studyId) {\n      results {\n        id\n        name\n        fileUrl\n        isVisible\n        thumbnailUrl\n      }\n    }\n  }\n"])));
/**
 * __useStudyFilesQuery__
 *
 * To run a query within a React component, call `useStudyFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyFilesQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useStudyFilesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudyFilesDocument, options);
}
export function useStudyFilesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudyFilesDocument, options);
}
export var GetSpellCheckLanguagesDocument = gql(templateObject_105 || (templateObject_105 = __makeTemplateObject(["\n  query getSpellCheckLanguages {\n    spellCheckLanguages {\n      results {\n        id\n        language\n        spellerLanguage\n        dictionaryIds\n      }\n    }\n  }\n"], ["\n  query getSpellCheckLanguages {\n    spellCheckLanguages {\n      results {\n        id\n        language\n        spellerLanguage\n        dictionaryIds\n      }\n    }\n  }\n"])));
/**
 * __useGetSpellCheckLanguagesQuery__
 *
 * To run a query within a React component, call `useGetSpellCheckLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpellCheckLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpellCheckLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpellCheckLanguagesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSpellCheckLanguagesDocument, options);
}
export function useGetSpellCheckLanguagesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSpellCheckLanguagesDocument, options);
}
export var OrganizationSpecificFieldsDocument = gql(templateObject_106 || (templateObject_106 = __makeTemplateObject(["\n  query organizationSpecificFields($relatedModelType: String) {\n    organizationSpecificFields(relatedModelType: $relatedModelType) {\n      results {\n        id\n        show\n        key\n        name\n        required\n        organizationSpecificFieldOptions {\n          id\n          name\n          key\n          show\n        }\n      }\n    }\n  }\n"], ["\n  query organizationSpecificFields($relatedModelType: String) {\n    organizationSpecificFields(relatedModelType: $relatedModelType) {\n      results {\n        id\n        show\n        key\n        name\n        required\n        organizationSpecificFieldOptions {\n          id\n          name\n          key\n          show\n        }\n      }\n    }\n  }\n"])));
/**
 * __useOrganizationSpecificFieldsQuery__
 *
 * To run a query within a React component, call `useOrganizationSpecificFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSpecificFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSpecificFieldsQuery({
 *   variables: {
 *      relatedModelType: // value for 'relatedModelType'
 *   },
 * });
 */
export function useOrganizationSpecificFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(OrganizationSpecificFieldsDocument, options);
}
export function useOrganizationSpecificFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(OrganizationSpecificFieldsDocument, options);
}
export var GetPatientByStudyDocument = gql(templateObject_107 || (templateObject_107 = __makeTemplateObject(["\n  query GetPatientByStudy($studyId: UUID) {\n    study(id: $studyId) {\n      patient {\n        email\n        phoneNumber\n        phoneCode\n        phoneCountry {\n          id\n          isoCode\n        }\n      }\n    }\n  }\n"], ["\n  query GetPatientByStudy($studyId: UUID) {\n    study(id: $studyId) {\n      patient {\n        email\n        phoneNumber\n        phoneCode\n        phoneCountry {\n          id\n          isoCode\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetPatientByStudyQuery__
 *
 * To run a query within a React component, call `useGetPatientByStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientByStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientByStudyQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetPatientByStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPatientByStudyDocument, options);
}
export function useGetPatientByStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPatientByStudyDocument, options);
}
export var GetPractitionerBasicInfoDocument = gql(templateObject_108 || (templateObject_108 = __makeTemplateObject(["\n  query getPractitionerBasicInfo($id: UUID!) {\n    practitioner(id: $id) {\n      id\n      fullName\n      isValidPacsPractitioner\n      phone\n      status\n      user {\n        email\n      }\n    }\n  }\n"], ["\n  query getPractitionerBasicInfo($id: UUID!) {\n    practitioner(id: $id) {\n      id\n      fullName\n      isValidPacsPractitioner\n      phone\n      status\n      user {\n        email\n      }\n    }\n  }\n"])));
/**
 * __useGetPractitionerBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetPractitionerBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionerBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionerBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPractitionerBasicInfoQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPractitionerBasicInfoDocument, options);
}
export function useGetPractitionerBasicInfoLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPractitionerBasicInfoDocument, options);
}
export var GetPractitionersOptionsDocument = gql(templateObject_109 || (templateObject_109 = __makeTemplateObject(["\n  query getPractitionersOptions(\n    $roleIn: [String!]!\n    $statusIn: [String!]!\n    $limit: Int\n    $offset: Int\n    $search: String\n    $reviewer: Boolean\n  ) {\n    practitioners(\n      ordering: \"fullName,asc\"\n      isValidPacsPractitioner: true\n      rolesIn: $roleIn\n      status_In: $statusIn\n      limit: $limit\n      offset: $offset\n      search: $search\n      reviewer: $reviewer\n    ) {\n      results {\n        id\n        fullName\n        user {\n          id\n        }\n      }\n      totalCount\n    }\n  }\n"], ["\n  query getPractitionersOptions(\n    $roleIn: [String!]!\n    $statusIn: [String!]!\n    $limit: Int\n    $offset: Int\n    $search: String\n    $reviewer: Boolean\n  ) {\n    practitioners(\n      ordering: \"fullName,asc\"\n      isValidPacsPractitioner: true\n      rolesIn: $roleIn\n      status_In: $statusIn\n      limit: $limit\n      offset: $offset\n      search: $search\n      reviewer: $reviewer\n    ) {\n      results {\n        id\n        fullName\n        user {\n          id\n        }\n      }\n      totalCount\n    }\n  }\n"])));
/**
 * __useGetPractitionersOptionsQuery__
 *
 * To run a query within a React component, call `useGetPractitionersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPractitionersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPractitionersOptionsQuery({
 *   variables: {
 *      roleIn: // value for 'roleIn'
 *      statusIn: // value for 'statusIn'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      reviewer: // value for 'reviewer'
 *   },
 * });
 */
export function useGetPractitionersOptionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPractitionersOptionsDocument, options);
}
export function useGetPractitionersOptionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPractitionersOptionsDocument, options);
}
export var PractitionerDocument = gql(templateObject_110 || (templateObject_110 = __makeTemplateObject(["\n  query practitioner($id: UUID!) {\n    practitioner(id: $id) {\n      id\n      signature\n      roles\n      multilineSpecialty\n      name\n      firstSurname\n      lastSurname\n      phone\n      phoneCode\n      signatureUrl\n      gender\n      reviewer\n      facility {\n        id\n      }\n      phoneCountry {\n        id\n        isoCode\n      }\n      user {\n        email\n        id\n        groups {\n          productPermissionGroup {\n            id\n            product {\n              id\n              name\n              productOrganizations {\n                hasAccess\n              }\n            }\n            group {\n              id\n              name\n            }\n          }\n        }\n      }\n      initials\n    }\n  }\n"], ["\n  query practitioner($id: UUID!) {\n    practitioner(id: $id) {\n      id\n      signature\n      roles\n      multilineSpecialty\n      name\n      firstSurname\n      lastSurname\n      phone\n      phoneCode\n      signatureUrl\n      gender\n      reviewer\n      facility {\n        id\n      }\n      phoneCountry {\n        id\n        isoCode\n      }\n      user {\n        email\n        id\n        groups {\n          productPermissionGroup {\n            id\n            product {\n              id\n              name\n              productOrganizations {\n                hasAccess\n              }\n            }\n            group {\n              id\n              name\n            }\n          }\n        }\n      }\n      initials\n    }\n  }\n"])));
/**
 * __usePractitionerQuery__
 *
 * To run a query within a React component, call `usePractitionerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePractitionerQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PractitionerDocument, options);
}
export function usePractitionerLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PractitionerDocument, options);
}
export var PractitionersDocument = gql(templateObject_111 || (templateObject_111 = __makeTemplateObject(["\n  query practitioners($limit: Int, $offset: Int, $search: String, $searchInitials: String) {\n    practitioners(\n      ordering: \"fullName,asc\"\n      isValidPacsPractitioner: true\n      limit: $limit\n      offset: $offset\n      search: $search\n      searchInitials: $searchInitials\n    ) {\n      pageInfo {\n        hasNextPage\n      }\n      totalCount\n      results {\n        id\n        roles\n        status\n        phone\n        phoneCode\n        fullName\n        facility {\n          name\n          id\n        }\n        user {\n          productGroups {\n            group {\n              id\n              name\n            }\n            product {\n              id\n              name\n            }\n          }\n          groups {\n            id\n            name\n          }\n          id\n          email\n        }\n      }\n    }\n  }\n"], ["\n  query practitioners($limit: Int, $offset: Int, $search: String, $searchInitials: String) {\n    practitioners(\n      ordering: \"fullName,asc\"\n      isValidPacsPractitioner: true\n      limit: $limit\n      offset: $offset\n      search: $search\n      searchInitials: $searchInitials\n    ) {\n      pageInfo {\n        hasNextPage\n      }\n      totalCount\n      results {\n        id\n        roles\n        status\n        phone\n        phoneCode\n        fullName\n        facility {\n          name\n          id\n        }\n        user {\n          productGroups {\n            group {\n              id\n              name\n            }\n            product {\n              id\n              name\n            }\n          }\n          groups {\n            id\n            name\n          }\n          id\n          email\n        }\n      }\n    }\n  }\n"])));
/**
 * __usePractitionersQuery__
 *
 * To run a query within a React component, call `usePractitionersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      searchInitials: // value for 'searchInitials'
 *   },
 * });
 */
export function usePractitionersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PractitionersDocument, options);
}
export function usePractitionersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PractitionersDocument, options);
}
export var DicomPrintDocument = gql(templateObject_112 || (templateObject_112 = __makeTemplateObject(["\n  query dicomPrint($id: UUID!) {\n    dicomPrint(id: $id) {\n      id\n      status\n      statusPrint\n      dicomPrinter {\n        id\n        ip\n        aeTitle\n        port\n      }\n      file\n      image\n    }\n  }\n"], ["\n  query dicomPrint($id: UUID!) {\n    dicomPrint(id: $id) {\n      id\n      status\n      statusPrint\n      dicomPrinter {\n        id\n        ip\n        aeTitle\n        port\n      }\n      file\n      image\n    }\n  }\n"])));
/**
 * __useDicomPrintQuery__
 *
 * To run a query within a React component, call `useDicomPrintQuery` and pass it any options that fit your needs.
 * When your component renders, `useDicomPrintQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDicomPrintQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDicomPrintQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DicomPrintDocument, options);
}
export function useDicomPrintLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DicomPrintDocument, options);
}
export var PrintersDocument = gql(templateObject_113 || (templateObject_113 = __makeTemplateObject(["\n  query Printers {\n    dicomPrinters {\n      results {\n        id\n        name\n        facility {\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query Printers {\n    dicomPrinters {\n      results {\n        id\n        name\n        facility {\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __usePrintersQuery__
 *
 * To run a query within a React component, call `usePrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrintersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PrintersDocument, options);
}
export function usePrintersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PrintersDocument, options);
}
export var AddendumsDocument = gql(templateObject_114 || (templateObject_114 = __makeTemplateObject(["\n  query addendums($reportId: UUID) {\n    addendums(report_Id: $reportId, ordering: \"createdAt,asc\") {\n      results {\n        id\n        status\n        value\n        createdAt\n      }\n    }\n  }\n"], ["\n  query addendums($reportId: UUID) {\n    addendums(report_Id: $reportId, ordering: \"createdAt,asc\") {\n      results {\n        id\n        status\n        value\n        createdAt\n      }\n    }\n  }\n"])));
/**
 * __useAddendumsQuery__
 *
 * To run a query within a React component, call `useAddendumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddendumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddendumsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useAddendumsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(AddendumsDocument, options);
}
export function useAddendumsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(AddendumsDocument, options);
}
export var GetCriticalValuesByStudyIdDocument = gql(templateObject_115 || (templateObject_115 = __makeTemplateObject(["\n  query getCriticalValuesByStudyId($studyId: UUID) {\n    study(id: $studyId) {\n      id\n      criticalValues {\n        id\n        observation\n        criticalValueName\n        criticalValue {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query getCriticalValuesByStudyId($studyId: UUID) {\n    study(id: $studyId) {\n      id\n      criticalValues {\n        id\n        observation\n        criticalValueName\n        criticalValue {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetCriticalValuesByStudyIdQuery__
 *
 * To run a query within a React component, call `useGetCriticalValuesByStudyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriticalValuesByStudyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriticalValuesByStudyIdQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetCriticalValuesByStudyIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetCriticalValuesByStudyIdDocument, options);
}
export function useGetCriticalValuesByStudyIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetCriticalValuesByStudyIdDocument, options);
}
export var GetOrgCriticalValuesDocument = gql(templateObject_116 || (templateObject_116 = __makeTemplateObject(["\n  query getOrgCriticalValues {\n    orgCriticalValues {\n      id\n      criticalValueId\n      criticalValueName\n    }\n  }\n"], ["\n  query getOrgCriticalValues {\n    orgCriticalValues {\n      id\n      criticalValueId\n      criticalValueName\n    }\n  }\n"])));
/**
 * __useGetOrgCriticalValuesQuery__
 *
 * To run a query within a React component, call `useGetOrgCriticalValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgCriticalValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgCriticalValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgCriticalValuesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetOrgCriticalValuesDocument, options);
}
export function useGetOrgCriticalValuesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetOrgCriticalValuesDocument, options);
}
export var GetReportIdsByStudyIdDocument = gql(templateObject_117 || (templateObject_117 = __makeTemplateObject(["\n  query getReportIdsByStudyId($studyId: UUID) {\n    reports(study_Id: $studyId) {\n      results {\n        id\n        status\n        isActive\n      }\n    }\n  }\n"], ["\n  query getReportIdsByStudyId($studyId: UUID) {\n    reports(study_Id: $studyId) {\n      results {\n        id\n        status\n        isActive\n      }\n    }\n  }\n"])));
/**
 * __useGetReportIdsByStudyIdQuery__
 *
 * To run a query within a React component, call `useGetReportIdsByStudyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportIdsByStudyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportIdsByStudyIdQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetReportIdsByStudyIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetReportIdsByStudyIdDocument, options);
}
export function useGetReportIdsByStudyIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetReportIdsByStudyIdDocument, options);
}
export var GetReportsByStudyDocument = gql(templateObject_118 || (templateObject_118 = __makeTemplateObject(["\n  query GetReportsByStudy($studyId: UUID) {\n    reports(study_Id: $studyId) {\n      results {\n        id\n        pdfUrl\n        pdfLetterheadUrl\n        status\n        viewerLinkPermission\n        isExternalPdf\n        signedBy {\n          id\n        }\n        template {\n          id\n          name\n          practitioner {\n            id\n          }\n          templateFields {\n            ...TemplateFieldFragment\n          }\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetReportsByStudy($studyId: UUID) {\n    reports(study_Id: $studyId) {\n      results {\n        id\n        pdfUrl\n        pdfLetterheadUrl\n        status\n        viewerLinkPermission\n        isExternalPdf\n        signedBy {\n          id\n        }\n        template {\n          id\n          name\n          practitioner {\n            id\n          }\n          templateFields {\n            ...TemplateFieldFragment\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), TemplateFieldFragmentFragmentDoc);
/**
 * __useGetReportsByStudyQuery__
 *
 * To run a query within a React component, call `useGetReportsByStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsByStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsByStudyQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetReportsByStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetReportsByStudyDocument, options);
}
export function useGetReportsByStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetReportsByStudyDocument, options);
}
export var ReportDocument = gql(templateObject_119 || (templateObject_119 = __makeTemplateObject(["\n  query report($id: UUID!) {\n    report(id: $id) {\n      id\n      pdfUrl\n      pdfLetterheadUrl\n      status\n      viewerLinkPermission\n      template {\n        id\n      }\n    }\n  }\n"], ["\n  query report($id: UUID!) {\n    report(id: $id) {\n      id\n      pdfUrl\n      pdfLetterheadUrl\n      status\n      viewerLinkPermission\n      template {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportDocument, options);
}
export function useReportLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportDocument, options);
}
export var ReportFieldsDocument = gql(templateObject_120 || (templateObject_120 = __makeTemplateObject(["\n  query reportFields($id: UUID!) {\n    report(id: $id) {\n      reportFields {\n        value\n        templateField {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query reportFields($id: UUID!) {\n    report(id: $id) {\n      reportFields {\n        value\n        templateField {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useReportFieldsQuery__
 *
 * To run a query within a React component, call `useReportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportFieldsDocument, options);
}
export function useReportFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportFieldsDocument, options);
}
export var TemplateAndReportFieldsDocument = gql(templateObject_121 || (templateObject_121 = __makeTemplateObject(["\n  query templateAndReportFields($reportId: UUID) {\n    reportFields(report_Id: $reportId) {\n      results {\n        id\n        templateField {\n          id\n          renderName\n        }\n        value\n        report {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query templateAndReportFields($reportId: UUID) {\n    reportFields(report_Id: $reportId) {\n      results {\n        id\n        templateField {\n          id\n          renderName\n        }\n        value\n        report {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useTemplateAndReportFieldsQuery__
 *
 * To run a query within a React component, call `useTemplateAndReportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateAndReportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateAndReportFieldsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useTemplateAndReportFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(TemplateAndReportFieldsDocument, options);
}
export function useTemplateAndReportFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(TemplateAndReportFieldsDocument, options);
}
export var TemplateFieldsDocument = gql(templateObject_122 || (templateObject_122 = __makeTemplateObject(["\n  query templateFields($templateId: UUID) {\n    templateFields(template_Id: $templateId) {\n      results {\n        id\n        defaultValue\n        fieldType\n        required\n        name\n      }\n    }\n  }\n"], ["\n  query templateFields($templateId: UUID) {\n    templateFields(template_Id: $templateId) {\n      results {\n        id\n        defaultValue\n        fieldType\n        required\n        name\n      }\n    }\n  }\n"])));
/**
 * __useTemplateFieldsQuery__
 *
 * To run a query within a React component, call `useTemplateFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateFieldsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useTemplateFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(TemplateFieldsDocument, options);
}
export function useTemplateFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(TemplateFieldsDocument, options);
}
export var TemplatesDocument = gql(templateObject_123 || (templateObject_123 = __makeTemplateObject(["\n  query templates {\n    templates {\n      results {\n        id\n        name\n        practitioner {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query templates {\n    templates {\n      results {\n        id\n        name\n        practitioner {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(TemplatesDocument, options);
}
export function useTemplatesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(TemplatesDocument, options);
}
export var TemplatesAndReportFieldsDocument = gql(templateObject_124 || (templateObject_124 = __makeTemplateObject(["\n  query templatesAndReportFields($reportId: UUID) {\n    reportFields(report_Id: $reportId) {\n      results {\n        id\n        templateField {\n          id\n          renderName\n        }\n        value\n        report {\n          id\n        }\n      }\n    }\n    templates {\n      results {\n        id\n        name\n        practitioner {\n          id\n        }\n        templateFields {\n          renderName\n          ...TemplateFieldFragment\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query templatesAndReportFields($reportId: UUID) {\n    reportFields(report_Id: $reportId) {\n      results {\n        id\n        templateField {\n          id\n          renderName\n        }\n        value\n        report {\n          id\n        }\n      }\n    }\n    templates {\n      results {\n        id\n        name\n        practitioner {\n          id\n        }\n        templateFields {\n          renderName\n          ...TemplateFieldFragment\n        }\n      }\n    }\n  }\n  ", "\n"])), TemplateFieldFragmentFragmentDoc);
/**
 * __useTemplatesAndReportFieldsQuery__
 *
 * To run a query within a React component, call `useTemplatesAndReportFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesAndReportFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesAndReportFieldsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useTemplatesAndReportFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(TemplatesAndReportFieldsDocument, options);
}
export function useTemplatesAndReportFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(TemplatesAndReportFieldsDocument, options);
}
export var GetEcgSeriesIntancesBySerieIdDocument = gql(templateObject_125 || (templateObject_125 = __makeTemplateObject(["\n  query GetECGSeriesIntancesBySerieId($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      ecgSeries {\n        id\n        status\n        ecgSignals {\n          id\n          channel\n          signalList\n        }\n      }\n      instanceFiles {\n        id\n        fileUrl\n      }\n    }\n  }\n"], ["\n  query GetECGSeriesIntancesBySerieId($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      ecgSeries {\n        id\n        status\n        ecgSignals {\n          id\n          channel\n          signalList\n        }\n      }\n      instanceFiles {\n        id\n        fileUrl\n      }\n    }\n  }\n"])));
/**
 * __useGetEcgSeriesIntancesBySerieIdQuery__
 *
 * To run a query within a React component, call `useGetEcgSeriesIntancesBySerieIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEcgSeriesIntancesBySerieIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEcgSeriesIntancesBySerieIdQuery({
 *   variables: {
 *      serieId: // value for 'serieId'
 *   },
 * });
 */
export function useGetEcgSeriesIntancesBySerieIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetEcgSeriesIntancesBySerieIdDocument, options);
}
export function useGetEcgSeriesIntancesBySerieIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetEcgSeriesIntancesBySerieIdDocument, options);
}
export var GetSerieCropAreaByIdDocument = gql(templateObject_126 || (templateObject_126 = __makeTemplateObject(["\n  query GetSerieCropAreaById($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomBottomRightX\n      dicomBottomRightY\n      dicomTopLeftX\n      dicomTopLeftY\n    }\n  }\n"], ["\n  query GetSerieCropAreaById($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomBottomRightX\n      dicomBottomRightY\n      dicomTopLeftX\n      dicomTopLeftY\n    }\n  }\n"])));
/**
 * __useGetSerieCropAreaByIdQuery__
 *
 * To run a query within a React component, call `useGetSerieCropAreaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerieCropAreaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSerieCropAreaByIdQuery({
 *   variables: {
 *      serieId: // value for 'serieId'
 *   },
 * });
 */
export function useGetSerieCropAreaByIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSerieCropAreaByIdDocument, options);
}
export function useGetSerieCropAreaByIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSerieCropAreaByIdDocument, options);
}
export var CustomFilesDocument = gql(templateObject_127 || (templateObject_127 = __makeTemplateObject(["\n  query CustomFiles($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomWindowCenter\n      dicomWindowWidth\n      isKeySeries\n      ecgSeries {\n        id\n        status\n        ecgSignals {\n          id\n          channel\n          signalList\n        }\n      }\n      hasDocument\n      instanceFiles {\n        id\n        dicomInstanceId\n        file\n        fileUrl\n        mobileFile\n        mobileFileUrl\n      }\n      instanceParents {\n        id\n        instance {\n          id\n          dicomInstanceId\n          files {\n            file\n            fileUrl\n          }\n          mobileFiles {\n            file\n            fileUrl\n          }\n        }\n      }\n      modality {\n        identifier\n      }\n      study {\n        id\n      }\n    }\n  }\n"], ["\n  query CustomFiles($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomWindowCenter\n      dicomWindowWidth\n      isKeySeries\n      ecgSeries {\n        id\n        status\n        ecgSignals {\n          id\n          channel\n          signalList\n        }\n      }\n      hasDocument\n      instanceFiles {\n        id\n        dicomInstanceId\n        file\n        fileUrl\n        mobileFile\n        mobileFileUrl\n      }\n      instanceParents {\n        id\n        instance {\n          id\n          dicomInstanceId\n          files {\n            file\n            fileUrl\n          }\n          mobileFiles {\n            file\n            fileUrl\n          }\n        }\n      }\n      modality {\n        identifier\n      }\n      study {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCustomFilesQuery__
 *
 * To run a query within a React component, call `useCustomFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFilesQuery({
 *   variables: {
 *      serieId: // value for 'serieId'
 *   },
 * });
 */
export function useCustomFilesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CustomFilesDocument, options);
}
export function useCustomFilesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CustomFilesDocument, options);
}
export var GetStudyPreviewDocument = gql(templateObject_128 || (templateObject_128 = __makeTemplateObject(["\n  query getStudyPreview($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      thumbnail\n      dicomDescription\n      series {\n        id\n        modality {\n          id\n          identifier\n        }\n      }\n    }\n  }\n"], ["\n  query getStudyPreview($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      thumbnail\n      dicomDescription\n      series {\n        id\n        modality {\n          id\n          identifier\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetStudyPreviewQuery__
 *
 * To run a query within a React component, call `useGetStudyPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyPreviewQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetStudyPreviewQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyPreviewDocument, options);
}
export function useGetStudyPreviewLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyPreviewDocument, options);
}
export var SeriesInstancesByIdDocument = gql(templateObject_129 || (templateObject_129 = __makeTemplateObject(["\n  query SeriesInstancesById($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomWindowCenter\n      dicomWindowWidth\n      isKeySeries\n      instances {\n        id\n        files {\n          file\n          fileUrl\n        }\n        mobileFiles {\n          file\n          fileUrl\n        }\n      }\n      instanceParents {\n        id\n        instance {\n          id\n          dicomInstanceId\n          files {\n            file\n            fileUrl\n          }\n          mobileFiles {\n            file\n            fileUrl\n          }\n        }\n      }\n      modality {\n        identifier\n      }\n      study {\n        id\n      }\n    }\n  }\n"], ["\n  query SeriesInstancesById($serieId: UUID) {\n    serie(id: $serieId) {\n      id\n      dicomWindowCenter\n      dicomWindowWidth\n      isKeySeries\n      instances {\n        id\n        files {\n          file\n          fileUrl\n        }\n        mobileFiles {\n          file\n          fileUrl\n        }\n      }\n      instanceParents {\n        id\n        instance {\n          id\n          dicomInstanceId\n          files {\n            file\n            fileUrl\n          }\n          mobileFiles {\n            file\n            fileUrl\n          }\n        }\n      }\n      modality {\n        identifier\n      }\n      study {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useSeriesInstancesByIdQuery__
 *
 * To run a query within a React component, call `useSeriesInstancesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesInstancesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesInstancesByIdQuery({
 *   variables: {
 *      serieId: // value for 'serieId'
 *   },
 * });
 */
export function useSeriesInstancesByIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SeriesInstancesByIdDocument, options);
}
export function useSeriesInstancesByIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SeriesInstancesByIdDocument, options);
}
export var SeriesThumbnailsDocument = gql(templateObject_130 || (templateObject_130 = __makeTemplateObject(["\n  query seriesThumbnails($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      instanceCount\n      dicomNumber\n    }\n  }\n"], ["\n  query seriesThumbnails($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      instanceCount\n      dicomNumber\n    }\n  }\n"])));
/**
 * __useSeriesThumbnailsQuery__
 *
 * To run a query within a React component, call `useSeriesThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesThumbnailsQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useSeriesThumbnailsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SeriesThumbnailsDocument, options);
}
export function useSeriesThumbnailsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SeriesThumbnailsDocument, options);
}
export var SeriesThumbnailsAndFilesDocument = gql(templateObject_131 || (templateObject_131 = __makeTemplateObject(["\n  query SeriesThumbnailsAndFiles($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      dicomDescription\n      dicomNumber\n      instanceCount\n      thumbnail\n      isKeySeries\n      modality\n      series {\n        id\n        dicomTags {\n          instance\n          series\n          study\n          tagValues\n        }\n        hasDocument\n        ecgSeries {\n          status\n        }\n      }\n    }\n    imageBookmarks(studyId: $studyId) {\n      id\n      fileUrl\n    }\n    orderStudyFiles(studyId: $studyId, isVisible: true) {\n      id\n      fileUrl\n      name\n    }\n    study(id: $studyId) {\n      id\n      reports {\n        id\n        status\n        pdfUrl\n      }\n    }\n  }\n"], ["\n  query SeriesThumbnailsAndFiles($studyId: UUID!) {\n    seriesThumbnails(studyId: $studyId) {\n      id\n      dicomDescription\n      dicomNumber\n      instanceCount\n      thumbnail\n      isKeySeries\n      modality\n      series {\n        id\n        dicomTags {\n          instance\n          series\n          study\n          tagValues\n        }\n        hasDocument\n        ecgSeries {\n          status\n        }\n      }\n    }\n    imageBookmarks(studyId: $studyId) {\n      id\n      fileUrl\n    }\n    orderStudyFiles(studyId: $studyId, isVisible: true) {\n      id\n      fileUrl\n      name\n    }\n    study(id: $studyId) {\n      id\n      reports {\n        id\n        status\n        pdfUrl\n      }\n    }\n  }\n"])));
/**
 * __useSeriesThumbnailsAndFilesQuery__
 *
 * To run a query within a React component, call `useSeriesThumbnailsAndFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesThumbnailsAndFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesThumbnailsAndFilesQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useSeriesThumbnailsAndFilesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SeriesThumbnailsAndFilesDocument, options);
}
export function useSeriesThumbnailsAndFilesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SeriesThumbnailsAndFilesDocument, options);
}
export var BasicStudyDocument = gql(templateObject_132 || (templateObject_132 = __makeTemplateObject(["\n  query BasicStudy($id: UUID) {\n    study(id: $id) {\n      id\n      status\n      referringPractitioner {\n        id\n        fullName\n      }\n      reviewerPractitioner {\n        ...Practitioner\n      }\n      patient {\n        email\n        phoneCode\n        phoneNumber\n        gender\n        fullName\n        identifierEditable\n      }\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      dicomDateTimeEditable\n      dicomDescription\n      dicomRequestingPhysician\n      dicomReferringPhysician\n      dicomReason\n      reviewRequired\n      facility {\n        timezone\n      }\n    }\n  }\n  ", "\n"], ["\n  query BasicStudy($id: UUID) {\n    study(id: $id) {\n      id\n      status\n      referringPractitioner {\n        id\n        fullName\n      }\n      reviewerPractitioner {\n        ...Practitioner\n      }\n      patient {\n        email\n        phoneCode\n        phoneNumber\n        gender\n        fullName\n        identifierEditable\n      }\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      dicomDateTimeEditable\n      dicomDescription\n      dicomRequestingPhysician\n      dicomReferringPhysician\n      dicomReason\n      reviewRequired\n      facility {\n        timezone\n      }\n    }\n  }\n  ", "\n"])), PractitionerFragmentDoc);
/**
 * __useBasicStudyQuery__
 *
 * To run a query within a React component, call `useBasicStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBasicStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BasicStudyDocument, options);
}
export function useBasicStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BasicStudyDocument, options);
}
export var DownloadDocument = gql(templateObject_133 || (templateObject_133 = __makeTemplateObject(["\n  query download($id: UUID!) {\n    download(id: $id) {\n      fileUrl\n      status\n    }\n  }\n"], ["\n  query download($id: UUID!) {\n    download(id: $id) {\n      fileUrl\n      status\n    }\n  }\n"])));
/**
 * __useDownloadQuery__
 *
 * To run a query within a React component, call `useDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DownloadDocument, options);
}
export function useDownloadLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DownloadDocument, options);
}
export var DownloadIsoDocument = gql(templateObject_134 || (templateObject_134 = __makeTemplateObject(["\n  query downloadIso($downloadIsoId: UUID!) {\n    downloadIso(id: $downloadIsoId) {\n      id\n      fileUrl\n      status\n    }\n  }\n"], ["\n  query downloadIso($downloadIsoId: UUID!) {\n    downloadIso(id: $downloadIsoId) {\n      id\n      fileUrl\n      status\n    }\n  }\n"])));
/**
 * __useDownloadIsoQuery__
 *
 * To run a query within a React component, call `useDownloadIsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadIsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadIsoQuery({
 *   variables: {
 *      downloadIsoId: // value for 'downloadIsoId'
 *   },
 * });
 */
export function useDownloadIsoQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DownloadIsoDocument, options);
}
export function useDownloadIsoLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DownloadIsoDocument, options);
}
export var FilterFieldsDocument = gql(templateObject_135 || (templateObject_135 = __makeTemplateObject(["\n  query FilterFields {\n    facilities {\n      results {\n        id\n        name\n      }\n    }\n    modalities {\n      results {\n        id\n        name\n      }\n    }\n    seriesDistinct(dicomOperatorsNameExcludeEmpty: true) {\n      dicomOperatorsName\n    }\n    studyTypes {\n      results {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query FilterFields {\n    facilities {\n      results {\n        id\n        name\n      }\n    }\n    modalities {\n      results {\n        id\n        name\n      }\n    }\n    seriesDistinct(dicomOperatorsNameExcludeEmpty: true) {\n      dicomOperatorsName\n    }\n    studyTypes {\n      results {\n        id\n        name\n      }\n    }\n  }\n"])));
/**
 * __useFilterFieldsQuery__
 *
 * To run a query within a React component, call `useFilterFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterFieldsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FilterFieldsDocument, options);
}
export function useFilterFieldsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FilterFieldsDocument, options);
}
export var GetDicomPdfStatusDocument = gql(templateObject_136 || (templateObject_136 = __makeTemplateObject(["\n  query getDicomPdfStatus($id: UUID!) {\n    studyPdfFile(id: $id) {\n      id\n      status\n      file\n      fileUrl\n    }\n  }\n"], ["\n  query getDicomPdfStatus($id: UUID!) {\n    studyPdfFile(id: $id) {\n      id\n      status\n      file\n      fileUrl\n    }\n  }\n"])));
/**
 * __useGetDicomPdfStatusQuery__
 *
 * To run a query within a React component, call `useGetDicomPdfStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDicomPdfStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDicomPdfStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDicomPdfStatusQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetDicomPdfStatusDocument, options);
}
export function useGetDicomPdfStatusLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetDicomPdfStatusDocument, options);
}
export var GetIsoByStudyDocument = gql(templateObject_137 || (templateObject_137 = __makeTemplateObject(["\n  query getIsoByStudy($studyId: UUID!) {\n    study(id: $studyId) {\n      downloadsIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n    }\n  }\n"], ["\n  query getIsoByStudy($studyId: UUID!) {\n    study(id: $studyId) {\n      downloadsIso {\n        id\n        fileUrl\n        status\n        statusBurn\n      }\n    }\n  }\n"])));
/**
 * __useGetIsoByStudyQuery__
 *
 * To run a query within a React component, call `useGetIsoByStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsoByStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsoByStudyQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetIsoByStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetIsoByStudyDocument, options);
}
export function useGetIsoByStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetIsoByStudyDocument, options);
}
export var OrganizationModalityDocument = gql(templateObject_138 || (templateObject_138 = __makeTemplateObject(["\n  query organizationModality {\n    organizationModalities {\n      id\n      identifier\n      name\n      nameEs\n      nameEn\n    }\n  }\n"], ["\n  query organizationModality {\n    organizationModalities {\n      id\n      identifier\n      name\n      nameEs\n      nameEn\n    }\n  }\n"])));
/**
 * __useOrganizationModalityQuery__
 *
 * To run a query within a React component, call `useOrganizationModalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationModalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationModalityQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationModalityQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(OrganizationModalityDocument, options);
}
export function useOrganizationModalityLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(OrganizationModalityDocument, options);
}
export var GetPatientHistoryCountDocument = gql(templateObject_139 || (templateObject_139 = __makeTemplateObject(["\n  query getPatientHistoryCount($patientFullName: String!, $identifier: String!) {\n    studiesHistory(fullName: $patientFullName, identifier: $identifier) {\n      id\n    }\n  }\n"], ["\n  query getPatientHistoryCount($patientFullName: String!, $identifier: String!) {\n    studiesHistory(fullName: $patientFullName, identifier: $identifier) {\n      id\n    }\n  }\n"])));
/**
 * __useGetPatientHistoryCountQuery__
 *
 * To run a query within a React component, call `useGetPatientHistoryCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientHistoryCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientHistoryCountQuery({
 *   variables: {
 *      patientFullName: // value for 'patientFullName'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetPatientHistoryCountQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPatientHistoryCountDocument, options);
}
export function useGetPatientHistoryCountLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPatientHistoryCountDocument, options);
}
export var GetStudiesByPatientNameDocument = gql(templateObject_140 || (templateObject_140 = __makeTemplateObject(["\n  query getStudiesByPatientName($patientFullName: String, $limit: Int) {\n    studies(patient_FullName_Icontains: $patientFullName, limit: $limit) {\n      results {\n        id\n        dicomDateTime\n        dicomDescription\n        status\n        urgencyLevel\n        modalities\n        createdAt\n        facility {\n          name\n        }\n        practitionerAssigned {\n          id\n        }\n        patient {\n          fullName\n          age\n          gender\n          birthDate\n          identifier\n        }\n        reports {\n          pdfUrl\n        }\n      }\n    }\n  }\n"], ["\n  query getStudiesByPatientName($patientFullName: String, $limit: Int) {\n    studies(patient_FullName_Icontains: $patientFullName, limit: $limit) {\n      results {\n        id\n        dicomDateTime\n        dicomDescription\n        status\n        urgencyLevel\n        modalities\n        createdAt\n        facility {\n          name\n        }\n        practitionerAssigned {\n          id\n        }\n        patient {\n          fullName\n          age\n          gender\n          birthDate\n          identifier\n        }\n        reports {\n          pdfUrl\n        }\n      }\n    }\n  }\n"])));
/**
 * __useGetStudiesByPatientNameQuery__
 *
 * To run a query within a React component, call `useGetStudiesByPatientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudiesByPatientNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudiesByPatientNameQuery({
 *   variables: {
 *      patientFullName: // value for 'patientFullName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStudiesByPatientNameQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudiesByPatientNameDocument, options);
}
export function useGetStudiesByPatientNameLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudiesByPatientNameDocument, options);
}
export var GetStudiesHistoryDocument = gql(templateObject_141 || (templateObject_141 = __makeTemplateObject(["\n  query getStudiesHistory($fullName: String!, $identifier: String!) {\n    studiesHistory(fullName: $fullName, identifier: $identifier) {\n      id\n      thumbnail\n      modalities\n      dicomDateTime\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      patient {\n        fullName\n        birthDate\n      }\n      reports {\n        pdfUrl\n      }\n    }\n  }\n"], ["\n  query getStudiesHistory($fullName: String!, $identifier: String!) {\n    studiesHistory(fullName: $fullName, identifier: $identifier) {\n      id\n      thumbnail\n      modalities\n      dicomDateTime\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      patient {\n        fullName\n        birthDate\n      }\n      reports {\n        pdfUrl\n      }\n    }\n  }\n"])));
/**
 * __useGetStudiesHistoryQuery__
 *
 * To run a query within a React component, call `useGetStudiesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudiesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudiesHistoryQuery({
 *   variables: {
 *      fullName: // value for 'fullName'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetStudiesHistoryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudiesHistoryDocument, options);
}
export function useGetStudiesHistoryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudiesHistoryDocument, options);
}
export var GetStudyDoubleSignatureStatusDocument = gql(templateObject_142 || (templateObject_142 = __makeTemplateObject(["\n  query GetStudyDoubleSignatureStatus($studyId: UUID) {\n    study(id: $studyId) {\n      reviewRequired\n    }\n  }\n"], ["\n  query GetStudyDoubleSignatureStatus($studyId: UUID) {\n    study(id: $studyId) {\n      reviewRequired\n    }\n  }\n"])));
/**
 * __useGetStudyDoubleSignatureStatusQuery__
 *
 * To run a query within a React component, call `useGetStudyDoubleSignatureStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyDoubleSignatureStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyDoubleSignatureStatusQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetStudyDoubleSignatureStatusQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyDoubleSignatureStatusDocument, options);
}
export function useGetStudyDoubleSignatureStatusLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyDoubleSignatureStatusDocument, options);
}
export var GetStudyListTotalCountDocument = gql(templateObject_143 || (templateObject_143 = __makeTemplateObject(["\n  query getStudyListTotalCount {\n    studies(limit: 1) {\n      totalCount\n    }\n  }\n"], ["\n  query getStudyListTotalCount {\n    studies(limit: 1) {\n      totalCount\n    }\n  }\n"])));
/**
 * __useGetStudyListTotalCountQuery__
 *
 * To run a query within a React component, call `useGetStudyListTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyListTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyListTotalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStudyListTotalCountQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyListTotalCountDocument, options);
}
export function useGetStudyListTotalCountLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyListTotalCountDocument, options);
}
export var GetStudyOverlayDataDocument = gql(templateObject_144 || (templateObject_144 = __makeTemplateObject(["\n  query getStudyOverlayData($id: UUID) {\n    study(id: $id) {\n      id\n      dicomDateTimeEditable\n      dicomDescription\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      patient {\n        id\n        birthDate\n        fullName\n        gender\n      }\n      facility {\n        id\n        name\n      }\n      series {\n        id\n        dicomOperatorsName\n      }\n      radiologistTechnician {\n        id\n        fullName\n        initials\n      }\n    }\n  }\n"], ["\n  query getStudyOverlayData($id: UUID) {\n    study(id: $id) {\n      id\n      dicomDateTimeEditable\n      dicomDescription\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      patient {\n        id\n        birthDate\n        fullName\n        gender\n      }\n      facility {\n        id\n        name\n      }\n      series {\n        id\n        dicomOperatorsName\n      }\n      radiologistTechnician {\n        id\n        fullName\n        initials\n      }\n    }\n  }\n"])));
/**
 * __useGetStudyOverlayDataQuery__
 *
 * To run a query within a React component, call `useGetStudyOverlayDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyOverlayDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyOverlayDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStudyOverlayDataQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyOverlayDataDocument, options);
}
export function useGetStudyOverlayDataLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyOverlayDataDocument, options);
}
export var GetStudyStatusDocument = gql(templateObject_145 || (templateObject_145 = __makeTemplateObject(["\n  query GetStudyStatus($studyId: UUID) {\n    study(id: $studyId) {\n      status\n    }\n  }\n"], ["\n  query GetStudyStatus($studyId: UUID) {\n    study(id: $studyId) {\n      status\n    }\n  }\n"])));
/**
 * __useGetStudyStatusQuery__
 *
 * To run a query within a React component, call `useGetStudyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyStatusQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useGetStudyStatusQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyStatusDocument, options);
}
export function useGetStudyStatusLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyStatusDocument, options);
}
export var ReportAndPatientFromStudyDocument = gql(templateObject_146 || (templateObject_146 = __makeTemplateObject(["\n  query ReportAndPatientFromStudy($id: UUID) {\n    study(id: $id) {\n      id\n      patient {\n        id\n        email\n        phoneCode\n        phoneNumber\n      }\n      reports {\n        id\n        pdfUrl\n        isExternalPdf\n        pdfLetterheadUrl\n      }\n    }\n  }\n"], ["\n  query ReportAndPatientFromStudy($id: UUID) {\n    study(id: $id) {\n      id\n      patient {\n        id\n        email\n        phoneCode\n        phoneNumber\n      }\n      reports {\n        id\n        pdfUrl\n        isExternalPdf\n        pdfLetterheadUrl\n      }\n    }\n  }\n"])));
/**
 * __useReportAndPatientFromStudyQuery__
 *
 * To run a query within a React component, call `useReportAndPatientFromStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAndPatientFromStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAndPatientFromStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportAndPatientFromStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportAndPatientFromStudyDocument, options);
}
export function useReportAndPatientFromStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportAndPatientFromStudyDocument, options);
}
export var SequenceBrowserStudyDocument = gql(templateObject_147 || (templateObject_147 = __makeTemplateObject(["\n  query SequenceBrowserStudy($id: UUID) {\n    study(id: $id) {\n      id\n      dicomDateTimeEditable\n      series {\n        id\n        modality {\n          id\n          identifier\n        }\n      }\n    }\n  }\n"], ["\n  query SequenceBrowserStudy($id: UUID) {\n    study(id: $id) {\n      id\n      dicomDateTimeEditable\n      series {\n        id\n        modality {\n          id\n          identifier\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSequenceBrowserStudyQuery__
 *
 * To run a query within a React component, call `useSequenceBrowserStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSequenceBrowserStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSequenceBrowserStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSequenceBrowserStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SequenceBrowserStudyDocument, options);
}
export function useSequenceBrowserStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SequenceBrowserStudyDocument, options);
}
export var StudiesStatisticsDocument = gql(templateObject_148 || (templateObject_148 = __makeTemplateObject(["\n  query studiesStatistics {\n    studiesStatistics {\n      historicCount\n      normalCount\n      normalNoReportCount\n      priorityCount\n      priorityNoReportCount\n      urgentCount\n      urgentNoReportCount\n    }\n  }\n"], ["\n  query studiesStatistics {\n    studiesStatistics {\n      historicCount\n      normalCount\n      normalNoReportCount\n      priorityCount\n      priorityNoReportCount\n      urgentCount\n      urgentNoReportCount\n    }\n  }\n"])));
/**
 * __useStudiesStatisticsQuery__
 *
 * To run a query within a React component, call `useStudiesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudiesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudiesStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudiesStatisticsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudiesStatisticsDocument, options);
}
export function useStudiesStatisticsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudiesStatisticsDocument, options);
}
export var StudyDocument = gql(templateObject_149 || (templateObject_149 = __makeTemplateObject(["\n  query Study($id: UUID) {\n    study(id: $id) {\n      ...Study\n    }\n  }\n  ", "\n"], ["\n  query Study($id: UUID) {\n    study(id: $id) {\n      ...Study\n    }\n  }\n  ", "\n"])), StudyFragmentDoc);
/**
 * __useStudyQuery__
 *
 * To run a query within a React component, call `useStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudyDocument, options);
}
export function useStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudyDocument, options);
}
export var StudyListPageDocument = gql(templateObject_150 || (templateObject_150 = __makeTemplateObject(["\n  query StudyListPage(\n    $search: String\n    $limit: Int\n    $offset: Int\n    $ordering: String\n    $patientAgeStart: Float\n    $patientAgeEnd: Float\n    $pacsStudyStartDate: DateTime\n    $pacsStudyEndDate: DateTime\n    $reportSignedStartDate: DateTime\n    $reportSignedEndDate: DateTime\n    $organizationSpecificFields: String\n  ) {\n    studies(\n      search: $search\n      limit: $limit\n      offset: $offset\n      ordering: $ordering\n      patientAgeStart: $patientAgeStart\n      patientAgeEnd: $patientAgeEnd\n      studyStartDate: $pacsStudyStartDate\n      studyEndDate: $pacsStudyEndDate\n      reportSignedStartDate: $reportSignedStartDate\n      reportSignedEndDate: $reportSignedEndDate\n      organizationSpecificField: $organizationSpecificFields\n    ) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        id\n        dicomDateTime\n        dicomDescription\n        dicomReferringPhysician\n        dicomReason\n        dicomRequestingPhysician\n        dicomDateTimeEditable\n        status\n        urgencyLevel\n        createdAt\n        folio\n        studyTypeEditable\n        patientStudyAge\n        patientStudyAgeMonths\n        patientStudyAgeDays\n        facility {\n          id\n          name\n          timezone\n        }\n        reviewRequired\n        reviewerPractitioner {\n          id\n          fullName\n        }\n        practitionerAssigned {\n          fullName\n          id\n        }\n        referringPractitioner {\n          id\n          fullName\n        }\n        patient {\n          fullName\n          gender\n          birthDate\n          identifier\n          identifierEditable\n        }\n        reports {\n          pdfUrl\n        }\n        modalities\n        criticalValues {\n          ...StudyCriticalValue\n        }\n      }\n      totalCount\n    }\n  }\n  ", "\n"], ["\n  query StudyListPage(\n    $search: String\n    $limit: Int\n    $offset: Int\n    $ordering: String\n    $patientAgeStart: Float\n    $patientAgeEnd: Float\n    $pacsStudyStartDate: DateTime\n    $pacsStudyEndDate: DateTime\n    $reportSignedStartDate: DateTime\n    $reportSignedEndDate: DateTime\n    $organizationSpecificFields: String\n  ) {\n    studies(\n      search: $search\n      limit: $limit\n      offset: $offset\n      ordering: $ordering\n      patientAgeStart: $patientAgeStart\n      patientAgeEnd: $patientAgeEnd\n      studyStartDate: $pacsStudyStartDate\n      studyEndDate: $pacsStudyEndDate\n      reportSignedStartDate: $reportSignedStartDate\n      reportSignedEndDate: $reportSignedEndDate\n      organizationSpecificField: $organizationSpecificFields\n    ) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        id\n        dicomDateTime\n        dicomDescription\n        dicomReferringPhysician\n        dicomReason\n        dicomRequestingPhysician\n        dicomDateTimeEditable\n        status\n        urgencyLevel\n        createdAt\n        folio\n        studyTypeEditable\n        patientStudyAge\n        patientStudyAgeMonths\n        patientStudyAgeDays\n        facility {\n          id\n          name\n          timezone\n        }\n        reviewRequired\n        reviewerPractitioner {\n          id\n          fullName\n        }\n        practitionerAssigned {\n          fullName\n          id\n        }\n        referringPractitioner {\n          id\n          fullName\n        }\n        patient {\n          fullName\n          gender\n          birthDate\n          identifier\n          identifierEditable\n        }\n        reports {\n          pdfUrl\n        }\n        modalities\n        criticalValues {\n          ...StudyCriticalValue\n        }\n      }\n      totalCount\n    }\n  }\n  ", "\n"])), StudyCriticalValueFragmentDoc);
/**
 * __useStudyListPageQuery__
 *
 * To run a query within a React component, call `useStudyListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyListPageQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ordering: // value for 'ordering'
 *      patientAgeStart: // value for 'patientAgeStart'
 *      patientAgeEnd: // value for 'patientAgeEnd'
 *      pacsStudyStartDate: // value for 'pacsStudyStartDate'
 *      pacsStudyEndDate: // value for 'pacsStudyEndDate'
 *      reportSignedStartDate: // value for 'reportSignedStartDate'
 *      reportSignedEndDate: // value for 'reportSignedEndDate'
 *      organizationSpecificFields: // value for 'organizationSpecificFields'
 *   },
 * });
 */
export function useStudyListPageQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudyListPageDocument, options);
}
export function useStudyListPageLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudyListPageDocument, options);
}
export var ValidateStudyPermissionsDocument = gql(templateObject_151 || (templateObject_151 = __makeTemplateObject(["\n  query validateStudyPermissions($studyId: UUID!) {\n    study(id: $studyId) {\n      id\n    }\n  }\n"], ["\n  query validateStudyPermissions($studyId: UUID!) {\n    study(id: $studyId) {\n      id\n    }\n  }\n"])));
/**
 * __useValidateStudyPermissionsQuery__
 *
 * To run a query within a React component, call `useValidateStudyPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateStudyPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateStudyPermissionsQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useValidateStudyPermissionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ValidateStudyPermissionsDocument, options);
}
export function useValidateStudyPermissionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ValidateStudyPermissionsDocument, options);
}
export var ViewerLinkDocument = gql(templateObject_152 || (templateObject_152 = __makeTemplateObject(["\n  query ViewerLink($studyId: UUID!) {\n    viewerLink(id: $studyId) {\n      viewerLink\n    }\n  }\n"], ["\n  query ViewerLink($studyId: UUID!) {\n    viewerLink(id: $studyId) {\n      viewerLink\n    }\n  }\n"])));
/**
 * __useViewerLinkQuery__
 *
 * To run a query within a React component, call `useViewerLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerLinkQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useViewerLinkQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ViewerLinkDocument, options);
}
export function useViewerLinkLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ViewerLinkDocument, options);
}
export var ViewerQrPdfDocument = gql(templateObject_153 || (templateObject_153 = __makeTemplateObject(["\n  query ViewerQrPdf($studyId: UUID) {\n    viewerLinkPdf(id: $studyId) {\n      pdfBase64\n    }\n  }\n"], ["\n  query ViewerQrPdf($studyId: UUID) {\n    viewerLinkPdf(id: $studyId) {\n      pdfBase64\n    }\n  }\n"])));
/**
 * __useViewerQrPdfQuery__
 *
 * To run a query within a React component, call `useViewerQrPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQrPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQrPdfQuery({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useViewerQrPdfQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ViewerQrPdfDocument, options);
}
export function useViewerQrPdfLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ViewerQrPdfDocument, options);
}
export var ViewerStudyDocument = gql(templateObject_154 || (templateObject_154 = __makeTemplateObject(["\n  query ViewerStudy($id: UUID, $credentials: String) {\n    study(id: $id, credentials: $credentials) {\n      id\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      ...Dicom\n      practitioner {\n        ...Practitioner\n      }\n      practitionerAssigned {\n        ...Practitioner\n      }\n      patient {\n        ...Patient\n      }\n      status\n      measurements {\n        ...Measurement\n      }\n      reviewerPractitioner {\n        ...Practitioner\n      }\n      reviewRequired\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  query ViewerStudy($id: UUID, $credentials: String) {\n    study(id: $id, credentials: $credentials) {\n      id\n      patientStudyAge\n      patientStudyAgeMonths\n      patientStudyAgeDays\n      ...Dicom\n      practitioner {\n        ...Practitioner\n      }\n      practitionerAssigned {\n        ...Practitioner\n      }\n      patient {\n        ...Patient\n      }\n      status\n      measurements {\n        ...Measurement\n      }\n      reviewerPractitioner {\n        ...Practitioner\n      }\n      reviewRequired\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"])), DicomFragmentDoc, PractitionerFragmentDoc, PatientFragmentDoc, MeasurementFragmentDoc);
/**
 * __useViewerStudyQuery__
 *
 * To run a query within a React component, call `useViewerStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerStudyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useViewerStudyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ViewerStudyDocument, options);
}
export function useViewerStudyLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ViewerStudyDocument, options);
}
export var UserPreferencesDocument = gql(templateObject_155 || (templateObject_155 = __makeTemplateObject(["\n  query userPreferences(\n    $userId: UUID!\n    $family: String\n    $limit: Int\n    $offset: Int\n    $ordering: String\n    $before: String\n    $after: String\n    $first: Int\n    $last: Int\n  ) {\n    userPreferences(\n      userId: $userId\n      family: $family\n      limit: $limit\n      offset: $offset\n      ordering: $ordering\n      before: $before\n      after: $after\n      first: $first\n      last: $last\n    ) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        id\n        deleted\n        createdAt\n        updatedAt\n        family\n        key\n        value\n      }\n      totalCount\n    }\n  }\n"], ["\n  query userPreferences(\n    $userId: UUID!\n    $family: String\n    $limit: Int\n    $offset: Int\n    $ordering: String\n    $before: String\n    $after: String\n    $first: Int\n    $last: Int\n  ) {\n    userPreferences(\n      userId: $userId\n      family: $family\n      limit: $limit\n      offset: $offset\n      ordering: $ordering\n      before: $before\n      after: $after\n      first: $first\n      last: $last\n    ) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        id\n        deleted\n        createdAt\n        updatedAt\n        family\n        key\n        value\n      }\n      totalCount\n    }\n  }\n"])));
/**
 * __useUserPreferencesQuery__
 *
 * To run a query within a React component, call `useUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferencesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      family: // value for 'family'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ordering: // value for 'ordering'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useUserPreferencesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(UserPreferencesDocument, options);
}
export function useUserPreferencesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(UserPreferencesDocument, options);
}
export var GetNotificationsDocument = gql(templateObject_156 || (templateObject_156 = __makeTemplateObject(["\n  query getNotifications($userId: UUID!) {\n    notifications(userId: $userId) {\n      results {\n        priority\n        id\n        userId\n        organizationName\n      }\n    }\n  }\n"], ["\n  query getNotifications($userId: UUID!) {\n    notifications(userId: $userId) {\n      results {\n        priority\n        id\n        userId\n        organizationName\n      }\n    }\n  }\n"])));
/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetNotificationsDocument, options);
}
export function useGetNotificationsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetNotificationsDocument, options);
}
export var GetUserNotificationsDocument = gql(templateObject_157 || (templateObject_157 = __makeTemplateObject(["\n  query getUserNotifications($userId: UUID!) {\n    userNotifications(userId: $userId) {\n      organizationId\n      highStudies\n      normalStudies\n      organization {\n        id\n        name\n      }\n      hasHighStudies\n      hasNormalStudies\n    }\n  }\n"], ["\n  query getUserNotifications($userId: UUID!) {\n    userNotifications(userId: $userId) {\n      organizationId\n      highStudies\n      normalStudies\n      organization {\n        id\n        name\n      }\n      hasHighStudies\n      hasNormalStudies\n    }\n  }\n"])));
/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetUserNotificationsDocument, options);
}
export function useGetUserNotificationsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetUserNotificationsDocument, options);
}
export var MeDocument = gql(templateObject_158 || (templateObject_158 = __makeTemplateObject(["\n  query me {\n    me {\n      ...User\n    }\n  }\n  ", "\n"], ["\n  query me {\n    me {\n      ...User\n    }\n  }\n  ", "\n"])), UserFragmentDoc);
/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MeDocument, options);
}
export function useMeLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MeDocument, options);
}
export var GetStudyWorkListDocument = gql(templateObject_159 || (templateObject_159 = __makeTemplateObject(["\n  query getStudyWorkList($limit: Int, $offset: Int, $ordering: String) {\n    studyWorklist(limit: $limit, ordering: $ordering, offset: $offset) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        ...WorklistStudyTableRowItem\n      }\n      totalCount\n    }\n  }\n  ", "\n"], ["\n  query getStudyWorkList($limit: Int, $offset: Int, $ordering: String) {\n    studyWorklist(limit: $limit, ordering: $ordering, offset: $offset) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      results {\n        ...WorklistStudyTableRowItem\n      }\n      totalCount\n    }\n  }\n  ", "\n"])), WorklistStudyTableRowItemFragmentDoc);
/**
 * __useGetStudyWorkListQuery__
 *
 * To run a query within a React component, call `useGetStudyWorkListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyWorkListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyWorkListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useGetStudyWorkListQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetStudyWorkListDocument, options);
}
export function useGetStudyWorkListLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetStudyWorkListDocument, options);
}
export var GetWorklistPositionsDocument = gql(templateObject_160 || (templateObject_160 = __makeTemplateObject(["\n  query getWorklistPositions($ordering: String, $ids: [UUID]) {\n    positions(ordering: $ordering, ids: $ids) {\n      id\n      nextId\n      prevId\n    }\n  }\n"], ["\n  query getWorklistPositions($ordering: String, $ids: [UUID]) {\n    positions(ordering: $ordering, ids: $ids) {\n      id\n      nextId\n      prevId\n    }\n  }\n"])));
/**
 * __useGetWorklistPositionsQuery__
 *
 * To run a query within a React component, call `useGetWorklistPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklistPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklistPositionsQuery({
 *   variables: {
 *      ordering: // value for 'ordering'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetWorklistPositionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetWorklistPositionsDocument, options);
}
export function useGetWorklistPositionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetWorklistPositionsDocument, options);
}
export var GetWorklistStudyByIdDocument = gql(templateObject_161 || (templateObject_161 = __makeTemplateObject(["\n  query getWorklistStudyById($idsIn: [String]) {\n    studyWorklist(id_In: $idsIn) {\n      results {\n        ...WorklistStudyTableRowItem\n      }\n    }\n  }\n  ", "\n"], ["\n  query getWorklistStudyById($idsIn: [String]) {\n    studyWorklist(id_In: $idsIn) {\n      results {\n        ...WorklistStudyTableRowItem\n      }\n    }\n  }\n  ", "\n"])), WorklistStudyTableRowItemFragmentDoc);
/**
 * __useGetWorklistStudyByIdQuery__
 *
 * To run a query within a React component, call `useGetWorklistStudyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklistStudyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklistStudyByIdQuery({
 *   variables: {
 *      idsIn: // value for 'idsIn'
 *   },
 * });
 */
export function useGetWorklistStudyByIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetWorklistStudyByIdDocument, options);
}
export function useGetWorklistStudyByIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetWorklistStudyByIdDocument, options);
}
export var GetWorklistTotalCountDocument = gql(templateObject_162 || (templateObject_162 = __makeTemplateObject(["\n  query getWorklistTotalCount {\n    studyWorklist {\n      totalCount\n    }\n  }\n"], ["\n  query getWorklistTotalCount {\n    studyWorklist {\n      totalCount\n    }\n  }\n"])));
/**
 * __useGetWorklistTotalCountQuery__
 *
 * To run a query within a React component, call `useGetWorklistTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorklistTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorklistTotalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorklistTotalCountQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetWorklistTotalCountDocument, options);
}
export function useGetWorklistTotalCountLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetWorklistTotalCountDocument, options);
}
export var StudiesUpdateDocument = gql(templateObject_163 || (templateObject_163 = __makeTemplateObject(["\n  subscription studiesUpdate($organizationId: UUID!) {\n    studiesUpdate(organizationId: $organizationId) {\n      event\n    }\n  }\n"], ["\n  subscription studiesUpdate($organizationId: UUID!) {\n    studiesUpdate(organizationId: $organizationId) {\n      event\n    }\n  }\n"])));
/**
 * __useStudiesUpdateSubscription__
 *
 * To run a query within a React component, call `useStudiesUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudiesUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudiesUpdateSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStudiesUpdateSubscription(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(StudiesUpdateDocument, options);
}
export var StudyCriticalValuesDocument = gql(templateObject_164 || (templateObject_164 = __makeTemplateObject(["\n  subscription studyCriticalValues($organizationId: UUID!) {\n    studyCriticalValues(organizationId: $organizationId) {\n      event\n    }\n  }\n"], ["\n  subscription studyCriticalValues($organizationId: UUID!) {\n    studyCriticalValues(organizationId: $organizationId) {\n      event\n    }\n  }\n"])));
/**
 * __useStudyCriticalValuesSubscription__
 *
 * To run a query within a React component, call `useStudyCriticalValuesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudyCriticalValuesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyCriticalValuesSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStudyCriticalValuesSubscription(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(StudyCriticalValuesDocument, options);
}
export var StudyEventsDocument = gql(templateObject_165 || (templateObject_165 = __makeTemplateObject(["\n  subscription studyEvents($studyId: UUID!) {\n    studyEvents(studyId: $studyId) {\n      event\n    }\n  }\n"], ["\n  subscription studyEvents($studyId: UUID!) {\n    studyEvents(studyId: $studyId) {\n      event\n    }\n  }\n"])));
/**
 * __useStudyEventsSubscription__
 *
 * To run a query within a React component, call `useStudyEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudyEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyEventsSubscription({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useStudyEventsSubscription(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(StudyEventsDocument, options);
}
export var StudyFilesUpdateDocument = gql(templateObject_166 || (templateObject_166 = __makeTemplateObject(["\n  subscription studyFilesUpdate($studyId: UUID!) {\n    studyFilesUpdate(studyId: $studyId) {\n      event\n    }\n  }\n"], ["\n  subscription studyFilesUpdate($studyId: UUID!) {\n    studyFilesUpdate(studyId: $studyId) {\n      event\n    }\n  }\n"])));
/**
 * __useStudyFilesUpdateSubscription__
 *
 * To run a query within a React component, call `useStudyFilesUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStudyFilesUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyFilesUpdateSubscription({
 *   variables: {
 *      studyId: // value for 'studyId'
 *   },
 * });
 */
export function useStudyFilesUpdateSubscription(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(StudyFilesUpdateDocument, options);
}
export var UpdateNotificationsDocument = gql(templateObject_167 || (templateObject_167 = __makeTemplateObject(["\n  subscription updateNotifications($userId: UUID!) {\n    updateUserNotifications(userId: $userId) {\n      organizationId\n      userId\n      notifications {\n        id\n        organization {\n          id\n          name\n        }\n        hasNormalStudies\n        highStudies\n        normalStudies\n        hasHighStudies\n      }\n    }\n  }\n"], ["\n  subscription updateNotifications($userId: UUID!) {\n    updateUserNotifications(userId: $userId) {\n      organizationId\n      userId\n      notifications {\n        id\n        organization {\n          id\n          name\n        }\n        hasNormalStudies\n        highStudies\n        normalStudies\n        hasHighStudies\n      }\n    }\n  }\n"])));
/**
 * __useUpdateNotificationsSubscription__
 *
 * To run a query within a React component, call `useUpdateNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateNotificationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateNotificationsSubscription(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useSubscription(UpdateNotificationsDocument, options);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86, templateObject_87, templateObject_88, templateObject_89, templateObject_90, templateObject_91, templateObject_92, templateObject_93, templateObject_94, templateObject_95, templateObject_96, templateObject_97, templateObject_98, templateObject_99, templateObject_100, templateObject_101, templateObject_102, templateObject_103, templateObject_104, templateObject_105, templateObject_106, templateObject_107, templateObject_108, templateObject_109, templateObject_110, templateObject_111, templateObject_112, templateObject_113, templateObject_114, templateObject_115, templateObject_116, templateObject_117, templateObject_118, templateObject_119, templateObject_120, templateObject_121, templateObject_122, templateObject_123, templateObject_124, templateObject_125, templateObject_126, templateObject_127, templateObject_128, templateObject_129, templateObject_130, templateObject_131, templateObject_132, templateObject_133, templateObject_134, templateObject_135, templateObject_136, templateObject_137, templateObject_138, templateObject_139, templateObject_140, templateObject_141, templateObject_142, templateObject_143, templateObject_144, templateObject_145, templateObject_146, templateObject_147, templateObject_148, templateObject_149, templateObject_150, templateObject_151, templateObject_152, templateObject_153, templateObject_154, templateObject_155, templateObject_156, templateObject_157, templateObject_158, templateObject_159, templateObject_160, templateObject_161, templateObject_162, templateObject_163, templateObject_164, templateObject_165, templateObject_166, templateObject_167;
